import { Modal } from "react-bootstrap";
import { AddwithBlueCircle, AddwithWhiteCircle, CloudUpload, CrosswithRedCircle, DeleteDustbin, UpdatePencil, SubmitArrowHead2, SubmitArrowHead1, UpdatePencilBox, InfoIcon } from "../AllSvg";
import { toast, ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import { customSortByKey, formatCurrencyIndian, generateCustomFileForUpload, getFileNameFromUrl, handleErrorToast, inputMinLimit, isValidTwoDecimalNumber, getCurrentFinancialYear, getMonthBoundaryDate, CustomTooltip, AttachmentIcon } from "../CustomFunctions";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { formattedDateLong, formatDate } from "../Date";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
import { TdsCalculationModal } from "../PayrollManagement/PayrollComponent";
import { useLocation } from "react-router-dom";

// ----------------------------------Tax Regime Components----------------------------------
const AddTaxregime = ({ SUB_COMPANIES, SUPER_ADMIN, getTaxRegime }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        getSalaryStructureHeadings()
        setShow(true)
    };
    const handleClose = () => {
        setFormData(initialData);
        setErrors({});
        setShow(false);
    };

    const initialData = {
        name: "",
        financial_year_start: "",
        financial_year_end: "",
        proof_submission_start_date: "",
        proof_submission_end_date: "",
        adjustment_month_start: "",
        adjustment_month_end: "",
        standard_deduction: "",
        cess_percent: "",
        rebate_threshold: "",
        // rebate_max_value: "",
        final_salary_for_tds: true,
        salary_for_tds: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
        sub_company: sessionStorage.getItem('company_id'),
    }


    const [formData, setFormData] = useState(initialData);
    const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);
    const [buffer, setBuffering] = useState(true);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const getSalaryStructureHeadings = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${formData.sub_company}/`);
            setSalaryStructureHeadings(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getSalaryStructureHeadings();
    }, [formData.sub_company]);




    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "name",
            "financial_year_start",
            "financial_year_end",
            "proof_submission_start_date",
            "proof_submission_end_date",
            "adjustment_month_start",
            "adjustment_month_end",
            "standard_deduction",
            "cess_percent",
            "rebate_threshold",
            // "rebate_max_value",
            "sub_company",

        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = `${formattedFieldName
                    } is required !`;
            }
        });

        if (!formData.final_salary_for_tds && !formData.salary_for_tds) {
            newErrors.final_or_selected_salary_for_tds = " Final salary check or Specific salary is required !";
        }

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };






    const handleInputChange = (e) => {
        const { name, value } = e.target;

        const numericFields = [
            "standard_deduction",
            "cess_percent",
            "rebate_threshold",
            // "rebate_max_value",
        ];


        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (name === "salary_for_tds") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors.final_or_selected_salary_for_tds;
                return updatedErrors;
            });
        }


        if (name === "proof_submission_start_date") {
            setFormData((prev) => ({
                ...prev,
                proof_submission_start_date: value,
                proof_submission_end_date:
                    prev.proof_submission_end_date &&
                        prev.proof_submission_end_date < value
                        ? ""
                        : prev.proof_submission_end_date
            }))
            return;
        }
        if (numericFields.includes(name)) {
            if (!isValidTwoDecimalNumber(value)) {
                return;
            }

            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }

            const { success, error } = inputMinLimit(name, value, 0);
            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }

        setInputState((prevState) => ({
            ...prevState,
            [name]: value.trim() ? "green" : "",
        }));

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleMonthInputChange = (e, type) => {
        const { name, value } = e.target;
        const formattedDate = getMonthBoundaryDate(value, type); // converts month to actual start/end date

        setFormData((prev) => ({
            ...prev,
            [name]: formattedDate,
        }));

        setInputState((prev) => ({
            ...prev,
            [name]: "green",
        }));

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });
    };

    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/tax-regieme/`,
                    [formData]);

                if (res.status === 200 || res.status === 201) {
                    await getTaxRegime();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Tax Regime created successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button title="Add Tax Regime" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle /><span className="">Tax regime</span>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="half-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Tax Regime</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form className="form-flex-wrap">
                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            onChange={handleInputChange}
                                            className={`form-input-half-full  ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        {errors.sub_company && (
                                            <span className="error-message font-size-text ">{errors.sub_company}</span>
                                        )}
                                    </div>
                                    : null
                                }

                                <div className="flex-column">
                                    <label
                                        htmlFor="name"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Name"
                                        maxLength={150}
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input-half-full ${errors.name ? "error" : inputState.name ? "success" : ""
                                            }`}
                                    />
                                    {errors.name && (
                                        <span className="error-message font-size-text">
                                            {errors.name}
                                        </span>
                                    )}
                                </div>

                                <hr className="line"></hr>

                                <div className="flex-column">
                                    <label htmlFor="financial_year_start" className="form-labels font-weight500 font-size-subheading">
                                        Financial Year Start<span className="required">*</span>
                                    </label>
                                    <input
                                        type="month"
                                        id="financial_year_start"
                                        name="financial_year_start"
                                        value={formData.financial_year_start?.slice(0, 7) || ""}
                                        onChange={(e) => handleMonthInputChange(e, "start")}
                                        max={formData.financial_year_end?.slice(0, 7) || ""}
                                        className={`form-input-half-half ${errors.financial_year_start ? "error" : inputState.financial_year_start ? "success" : ""}`}
                                    />
                                    {errors.financial_year_start && <span className="error-message font-size-text mt-2">{errors.financial_year_start}</span>}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="financial_year_end" className="form-labels font-weight500 font-size-subheading">
                                        Financial Year End<span className="required">*</span>
                                    </label>
                                    <input
                                        type="month"
                                        id="financial_year_end"
                                        name="financial_year_end"
                                        value={formData.financial_year_end?.slice(0, 7) || ""}
                                        onChange={(e) => handleMonthInputChange(e, "end")}
                                        min={formData.financial_year_start?.slice(0, 7) || ""}
                                        className={`form-input-half-half ${errors.financial_year_end ? "error" : inputState.financial_year_end ? "success" : ""}`}
                                    />
                                    {errors.financial_year_end && <span className="error-message font-size-text mt-2">{errors.financial_year_end}</span>}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="proof_submission_start_date"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Proof Submission Start Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="proof_submission_start_date"
                                        name="proof_submission_start_date"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        value={formData.proof_submission_start_date}
                                        min={formData.financial_year_start || undefined}
                                        max={formData.adjustment_month_start || formData.financial_year_end || undefined}
                                        className={`form-input-half-half ${errors.proof_submission_start_date ? "error" : inputState.proof_submission_start_date ? "success" : ""
                                            }`}

                                    />
                                    {errors.proof_submission_start_date && (
                                        <span className="error-message font-size-text mt-2">
                                            {errors.proof_submission_start_date}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="proof_submission_end_date"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Proof Submission End Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="proof_submission_end_date"
                                        name="proof_submission_end_date"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        value={formData.proof_submission_end_date}
                                        min={formData.proof_submission_start_date || formData.financial_year_start || undefined}
                                        max={formData.adjustment_month_start || formData.financial_year_end || undefined}
                                        className={`form-input-half-half ${errors.proof_submission_end_date ? "error" : inputState.proof_submission_end_date ? "success" : ""
                                            }`}

                                    />
                                    {errors.proof_submission_end_date && (
                                        <span className="error-message font-size-text mt-2">
                                            {errors.proof_submission_end_date}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="adjustment_month_start" className="form-labels font-weight500 font-size-subheading">
                                        Adjustment Start Month<span className="required">*</span>
                                    </label>
                                    <input
                                        type="month"
                                        id="adjustment_month_start"
                                        name="adjustment_month_start"
                                        value={formData.adjustment_month_start?.slice(0, 7) || ""}
                                        onChange={(e) => handleMonthInputChange(e, "start")}
                                        min={formData.proof_submission_end_date?.slice(0, 7) || formData.financial_year_start?.slice(0, 7) || ""}
                                        max={formData.adjustment_month_end?.slice(0, 7) || formData.financial_year_end?.slice(0, 7) || ""}
                                        className={`form-input-half-half ${errors.adjustment_month_start ? "error" : inputState.adjustment_month_start ? "success" : ""}`}
                                    />
                                    {errors.adjustment_month_start && <span className="error-message font-size-text mt-2">{errors.adjustment_month_start}</span>}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="adjustment_month_end" className="form-labels font-weight500 font-size-subheading">
                                        Adjustment End Month<span className="required">*</span>
                                    </label>
                                    <input
                                        type="month"
                                        id="adjustment_month_end"
                                        name="adjustment_month_end"
                                        value={formData.adjustment_month_end?.slice(0, 7) || ""}
                                        onChange={(e) => handleMonthInputChange(e, "end")}
                                        min={formData.adjustment_month_start?.slice(0, 7) || formData.proof_submission_end_date?.slice(0, 7) || formData.financial_year_start?.slice(0, 7) || ""}
                                        max={formData.financial_year_end?.slice(0, 7) || ""}
                                        className={`form-input-half-half ${errors.adjustment_month_end ? "error" : inputState.adjustment_month_end ? "success" : ""}`}
                                    />
                                    {errors.adjustment_month_end && <span className="error-message font-size-text mt-2">{errors.adjustment_month_end}</span>}
                                </div>

                                <hr className="line"></hr>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="standard_deduction">
                                        Standard Deduction<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="standard_deduction"
                                        id="standard_deduction"
                                        placeholder="Deduction amount"
                                        // defaultValue={}
                                        min={0}
                                        // style={{ marginTop: '14px' }}
                                        value={formData.standard_deduction}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input-half-half ${errors.standard_deduction ? "error" : inputState.standard_deduction ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.standard_deduction && (
                                        <span className="error-message font-size-text ">
                                            {errors.standard_deduction}
                                        </span>
                                    )}
                                </div>



                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="cess_percent">
                                        Cess (in %)<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="cess_percent"
                                        id="cess_percent"
                                        placeholder="Cess"
                                        // defaultValue={}
                                        min={0}
                                        value={formData.cess_percent}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input-half-half ${errors.cess_percent ? "error" : inputState.cess_percent ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.cess_percent && (
                                        <span className="error-message font-size-text ">
                                            {errors.cess_percent}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <div
                                        style={{ marginTop: '10px' }}
                                    />
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="rebate_threshold">
                                        Rebate Threshold<span className="required">*</span>
                                    </label>
                                    <div
                                        style={{ marginTop: '3px' }}
                                    />
                                    <input
                                        type="number"
                                        name="rebate_threshold"
                                        id="rebate_threshold"
                                        // defaultValue={}
                                        placeholder="Rebate threshold"
                                        min={0}
                                        value={formData.rebate_threshold}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input-half-half ${errors.rebate_threshold ? "error" : inputState.rebate_threshold ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.rebate_threshold && (
                                        <span className="error-message font-size-text ">
                                            {errors.rebate_threshold}
                                        </span>
                                    )}
                                </div>

                                {/* <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="rebate_max_value">
                                        Rebate Max Value<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="rebate_max_value"
                                        id="rebate_max_value"
                                        placeholder="Rebate max value"
                                        // defaultValue={}
                                        min={0}
                                        value={formData.rebate_max_value}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input-half-half ${errors.rebate_max_value ? "error" : inputState.rebate_max_value ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.rebate_max_value && (
                                        <span className="error-message font-size-text ">
                                            {errors.rebate_max_value}
                                        </span>
                                    )}
                                </div> */}

                                <div
                                    title={formData.final_salary_for_tds
                                        ? "Using final salary calculation for TDS"
                                        : "Select a specific salary heading for TDS calculation"
                                    }
                                    className="flex-column">
                                    <div className="flex-row ">
                                        <label htmlFor="final_salary_for_tds" className="form-labels font-weight500 font-size-subheading">
                                            Use {" "}
                                            <label htmlFor="" className="form-labels  font-weight500    font-size-subheading">
                                                {formData.final_salary_for_tds ? 'Final Salary' : 'Specific Heading'}
                                            </label>
                                            {/* {" "} */}
                                            <span className="required">*</span>
                                        </label>
                                        <hr
                                            // style={{ marginTop: '10px' }} 
                                            className="field-cont-hr"
                                        />
                                        <div className="checkbox-toggle">
                                            <input
                                                id="final_salary_for_tds"
                                                name="final_salary_for_tds"
                                                className="form-input-half-half"
                                                type="checkbox"
                                                checked={formData.final_salary_for_tds || false}
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    setFormData({
                                                        ...formData,
                                                        final_salary_for_tds: isChecked,
                                                        salary_for_tds: isChecked ? '' : formData.salary_for_tds
                                                    });
                                                    setErrors(prevErrors => {
                                                        const newErrors = { ...prevErrors };
                                                        delete newErrors.final_or_selected_salary_for_tds;
                                                        return newErrors;
                                                    });
                                                }}
                                            />
                                            <label htmlFor='final_salary_for_tds'></label>
                                        </div>
                                    </div>

                                    <select
                                        id="salary_for_tds"
                                        name="salary_for_tds"
                                        onChange={handleInputChange}
                                        value={formData.salary_for_tds}
                                        className={`form-input-half-half ${errors.salary_for_tds ? "error" : inputState.salary_for_tds ? "success" : ""}`}
                                        disabled={formData.final_salary_for_tds}
                                        style={{ cursor: formData.final_salary_for_tds ? 'not-allowed' : 'default' }}
                                    >
                                        <option value="">{formData.final_salary_for_tds ? "Final Salary Heading Selected" : "Select Specific Salary Heading"}</option>
                                        {salaryStructureHeadings
                                            .sort((a, b) => a.sorting_var - b.sorting_var)
                                            .map(option => (
                                                <option key={option.id} value={option.id}>
                                                    {option.title}
                                                </option>
                                            ))}
                                    </select>
                                    {errors.final_or_selected_salary_for_tds && (
                                        <span className="error-message font-size-text">{errors.final_or_selected_salary_for_tds}</span>
                                    )}
                                    {/* {errors.salary_selection && (
                                        <span className="error-message font-size-text">{errors.salary_selection}</span>
                                    )} */}
                                </div>

                            </form>

                            <div className="button-models">
                                <button
                                    type="button"
                                    className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button model-button-leave font-weight500 font-size-heading"
                                    disabled={loading}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateTaxregime = ({ i, SUB_COMPANIES, SUPER_ADMIN, getTaxRegime }) => {
    const [show, setShow] = useState(false);
    const [variableConfirmation, setVariableConfirmation] = useState(false);
    const handleClose = () => {
        setErrors({});
        setShow(false)
    };
    const handleShow = () => {
        setFormData(i);
        getSalaryStructureHeadings();
        setShow(true)
    };

    const initialData = {
        name: "",
        financial_year_start: "",
        financial_year_end: "",
        proof_submission_start_date: "",
        proof_submission_end_date: "",
        adjustment_month_start: "",
        adjustment_month_end: "",
        standard_deduction: "",
        cess_percent: "",
        rebate_threshold: "",
        // rebate_max_value: "",
        final_salary_for_tds: true,
        salary_for_tds: "",
        updated_by: sessionStorage.getItem('emp_code'),
        sub_company: sessionStorage.getItem('company_id'),
    }
    const [formData, setFormData] = useState(initialData);
    const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const getSalaryStructureHeadings = async () => {
        setBuffering(true); //buffering logic // Start Buffering 
        try {
            const res = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${formData.sub_company}/`);
            setSalaryStructureHeadings(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getSalaryStructureHeadings();
    }, [formData.sub_company]);

    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "name",
            "financial_year_start",
            "financial_year_end",
            "proof_submission_start_date",
            "proof_submission_end_date",
            "adjustment_month_start",
            "adjustment_month_end",
            "standard_deduction",
            "cess_percent",
            "rebate_threshold",
            // "rebate_max_value",
            "sub_company",
        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = ` ${formattedFieldName
                    } is required !`;
            }
        });

        if (!formData.final_salary_for_tds && !formData.salary_for_tds) {
            newErrors.final_or_selected_salary_for_tds = " Final salary check or Specific salary is required !";
        }

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };



    const handleInputChange = (e) => {
        const { name, value } = e.target;

        const numericFields = [
            "standard_deduction",
            "cess_percent",
            "rebate_threshold",
            // "rebate_max_value",
        ];

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (name === "salary_for_tds") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors.final_or_selected_salary_for_tds;
                return updatedErrors;
            });
        }


        if (name === "proof_submission_start_date") {
            setFormData((prev) => ({
                ...prev,
                proof_submission_start_date: value,
                proof_submission_end_date:
                    prev.proof_submission_end_date &&
                        prev.proof_submission_end_date < value
                        ? ""
                        : prev.proof_submission_end_date
            }))
            return;
        }

        if (numericFields.includes(name)) {
            if (!isValidTwoDecimalNumber(value)) {
                return;
            }


            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }
            const { success, error } = inputMinLimit(name, value, 0);
            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setInputState((prev) => ({
            ...prev,
            [name]: value.trim() ? "green" : "",
        }));
    };


    const handleMonthInputChange = (e, type) => {
        const { name, value } = e.target;
        const formattedDate = getMonthBoundaryDate(value, type); // converts month to start/end date

        setFormData((prev) => ({
            ...prev,
            [name]: formattedDate,
        }));

        setInputState((prev) => ({
            ...prev,
            [name]: "green",
        }));

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });
    };

    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");
            const uploadData = {
                ...formData,
                updated_by: sessionStorage.getItem('emp_code'),
            }

            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/tax-regieme/${i?.id}/`,
                    uploadData
                );

                if (res.status === 200) {
                    await getTaxRegime();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Tax regime updated successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const usageList = [
        { label: "Income/Investments types", count: i?.regime_income_investment_count },
        { label: "Tax Sections", count: i?.regime_tax_section_count },
        { label: "Age Ranges", count: i?.regime_age_range_count },
        { label: "Slabs", count: i?.regime_slab_count },
        { label: "Surcharge", count: i?.regime_surcharge_count },
        { label: "Investment Forms", count: i?.regime_investment_forms_count },
        { label: "Saved TDS", count: i?.regime_saved_tds_count },
    ];

    const usedIn = usageList
        .filter(item => item.count > 0)
        .map(item => `${item.count} ${item.label} `)
        .join(", ");



    return (
        <>

            <button
                title="Update Tax Regime"
                className="model-edit-button-ml"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="half-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Tax Regime</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form className="form-flex-wrap">
                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            onChange={handleInputChange}
                                            className={`form-input-half-full  ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        {errors.sub_company && (
                                            <span className="error-message font-size-text ">{errors.sub_company}</span>
                                        )}
                                    </div>
                                    : null
                                }

                                <div className="flex-column">
                                    <label
                                        htmlFor="name"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Name"
                                        maxLength={150}
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input-half-full ${errors.name ? "error" : inputState.name ? "success" : ""
                                            }`}
                                    />
                                    {errors.name && (
                                        <span className="error-message font-size-text">
                                            {errors.name}
                                        </span>
                                    )}
                                </div>

                                <hr className="line"></hr>

                                <div className="flex-column">
                                    <label htmlFor="financial_year_start" className="form-labels font-weight500 font-size-subheading">
                                        Financial Year Start<span className="required">*</span>
                                    </label>
                                    <input
                                        type="month"
                                        id="financial_year_start"
                                        name="financial_year_start"
                                        value={formData.financial_year_start?.slice(0, 7) || ""}
                                        onChange={(e) => handleMonthInputChange(e, "start")}
                                        max={formData.financial_year_end?.slice(0, 7) || ""}
                                        className={`form-input-half-half ${errors.financial_year_start ? "error" : inputState.financial_year_start ? "success" : ""}`}
                                    />
                                    {errors.financial_year_start && <span className="error-message font-size-text mt-2">{errors.financial_year_start}</span>}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="financial_year_end" className="form-labels font-weight500 font-size-subheading">
                                        Financial Year End<span className="required">*</span>
                                    </label>
                                    <input
                                        type="month"
                                        id="financial_year_end"
                                        name="financial_year_end"
                                        value={formData.financial_year_end?.slice(0, 7) || ""}
                                        onChange={(e) => handleMonthInputChange(e, "end")}
                                        min={formData.financial_year_start?.slice(0, 7) || ""}
                                        className={`form-input-half-half ${errors.financial_year_end ? "error" : inputState.financial_year_end ? "success" : ""}`}
                                    />
                                    {errors.financial_year_end && <span className="error-message font-size-text mt-2">{errors.financial_year_end}</span>}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="proof_submission_start_date"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Proof Submission Start Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="proof_submission_start_date"
                                        name="proof_submission_start_date"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        value={formData.proof_submission_start_date}
                                        min={formData.financial_year_start || undefined}
                                        max={formData.adjustment_month_start || formData.financial_year_end || undefined}
                                        className={`form-input-half-half ${errors.proof_submission_start_date ? "error" : inputState.proof_submission_start_date ? "success" : ""
                                            }`}

                                    />
                                    {errors.proof_submission_start_date && (
                                        <span className="error-message font-size-text mt-2">
                                            {errors.proof_submission_start_date}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="proof_submission_end_date"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Proof Submission End Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="proof_submission_end_date"
                                        name="proof_submission_end_date"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        value={formData.proof_submission_end_date}
                                        min={formData.proof_submission_start_date || formData.financial_year_start || undefined}
                                        max={formData.adjustment_month_start || formData.financial_year_end || undefined}
                                        className={`form-input-half-half ${errors.proof_submission_end_date ? "error" : inputState.proof_submission_end_date ? "success" : ""
                                            }`}

                                    />
                                    {errors.proof_submission_end_date && (
                                        <span className="error-message font-size-text mt-2">
                                            {errors.proof_submission_end_date}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="adjustment_month_start" className="form-labels font-weight500 font-size-subheading">
                                        Adjustment Start Month<span className="required">*</span>
                                    </label>
                                    <input
                                        type="month"
                                        id="adjustment_month_start"
                                        name="adjustment_month_start"
                                        value={formData.adjustment_month_start?.slice(0, 7) || ""}
                                        onChange={(e) => handleMonthInputChange(e, "start")}
                                        min={formData.proof_submission_end_date?.slice(0, 7) || formData.financial_year_start?.slice(0, 7) || ""}
                                        max={formData.adjustment_month_end?.slice(0, 7) || formData.financial_year_end?.slice(0, 7) || ""}
                                        className={`form-input-half-half ${errors.adjustment_month_start ? "error" : inputState.adjustment_month_start ? "success" : ""}`}
                                    />
                                    {errors.adjustment_month_start && <span className="error-message font-size-text mt-2">{errors.adjustment_month_start}</span>}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="adjustment_month_end" className="form-labels font-weight500 font-size-subheading">
                                        Adjustment End Month<span className="required">*</span>
                                    </label>
                                    <input
                                        type="month"
                                        id="adjustment_month_end"
                                        name="adjustment_month_end"
                                        value={formData.adjustment_month_end?.slice(0, 7) || ""}
                                        onChange={(e) => handleMonthInputChange(e, "end")}
                                        min={formData.adjustment_month_start?.slice(0, 7) || formData.proof_submission_end_date?.slice(0, 7) || formData.financial_year_start?.slice(0, 7) || ""}
                                        max={formData.financial_year_end?.slice(0, 7) || ""}
                                        className={`form-input-half-half ${errors.adjustment_month_end ? "error" : inputState.adjustment_month_end ? "success" : ""}`}
                                    />
                                    {errors.adjustment_month_end && <span className="error-message font-size-text mt-2">{errors.adjustment_month_end}</span>}
                                </div>

                                <hr className="line"></hr>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="standard_deduction">
                                        Standard Deduction<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="standard_deduction"
                                        id="standard_deduction"
                                        placeholder="Deduction amount"
                                        // defaultValue={}
                                        min={0}
                                        // style={{ marginTop: '14px' }}
                                        value={formData.standard_deduction}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input-half-half ${errors.standard_deduction ? "error" : inputState.standard_deduction ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.standard_deduction && (
                                        <span className="error-message font-size-text ">
                                            {errors.standard_deduction}
                                        </span>
                                    )}
                                </div>



                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="cess_percent">
                                        Cess (in %)<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="cess_percent"
                                        id="cess_percent"
                                        placeholder="Cess"
                                        // defaultValue={}
                                        min={0}
                                        value={formData.cess_percent}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input-half-half ${errors.cess_percent ? "error" : inputState.cess_percent ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.cess_percent && (
                                        <span className="error-message font-size-text ">
                                            {errors.cess_percent}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <div
                                        style={{ marginTop: '10px' }}
                                    />
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="rebate_threshold">
                                        Rebate Threshold<span className="required">*</span>
                                    </label>
                                    <div
                                        style={{ marginTop: '3px' }}
                                    />
                                    <input
                                        type="number"
                                        name="rebate_threshold"
                                        id="rebate_threshold"
                                        // defaultValue={}
                                        placeholder="Rebate threshold"
                                        min={0}
                                        value={formData.rebate_threshold}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input-half-half ${errors.rebate_threshold ? "error" : inputState.rebate_threshold ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.rebate_threshold && (
                                        <span className="error-message font-size-text ">
                                            {errors.rebate_threshold}
                                        </span>
                                    )}
                                </div>

                                {/* <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="rebate_max_value">
                                        Rebate Max Value<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="rebate_max_value"
                                        id="rebate_max_value"
                                        placeholder="Rebate max value"
                                        // defaultValue={}
                                        min={0}
                                        value={formData.rebate_max_value}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input-half-half ${errors.rebate_max_value ? "error" : inputState.rebate_max_value ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.rebate_max_value && (
                                        <span className="error-message font-size-text ">
                                            {errors.rebate_max_value}
                                        </span>
                                    )}
                                </div> */}

                                <div
                                    title={formData.final_salary_for_tds
                                        ? "Using final salary calculation for TDS"
                                        : "Select a specific salary heading for TDS calculation"
                                    }
                                    className="flex-column">
                                    <div className="flex-row ">
                                        <label htmlFor="final_salary_for_tds" className="form-labels font-weight500 font-size-subheading">
                                            Use {" "}
                                            <label htmlFor="" className="form-labels  font-weight500    font-size-subheading">
                                                {formData.final_salary_for_tds ? 'Final Salary' : 'Specific Heading'}
                                            </label>
                                            {/* {" "} */}
                                            <span className="required">*</span>
                                        </label>
                                        <hr
                                            // style={{ marginTop: '10px' }} 
                                            className="field-cont-hr"
                                        />
                                        <div className="checkbox-toggle">
                                            <input
                                                id="final_salary_for_tds"
                                                name="final_salary_for_tds"
                                                className="form-input-half-half"
                                                type="checkbox"
                                                checked={formData.final_salary_for_tds || false}
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    setFormData({
                                                        ...formData,
                                                        final_salary_for_tds: isChecked,
                                                        salary_for_tds: isChecked ? '' : formData.salary_for_tds
                                                    });
                                                    setErrors(prevErrors => {
                                                        const newErrors = { ...prevErrors };
                                                        delete newErrors.final_or_selected_salary_for_tds;
                                                        return newErrors;
                                                    });
                                                }}
                                            />
                                            <label htmlFor='final_salary_for_tds'></label>
                                        </div>
                                    </div>

                                    <select
                                        id="salary_for_tds"
                                        name="salary_for_tds"
                                        onChange={handleInputChange}
                                        value={formData.salary_for_tds}
                                        className={`form-input-half-half ${errors.salary_for_tds ? "error" : inputState.salary_for_tds ? "success" : ""}`}
                                        disabled={formData.final_salary_for_tds}
                                        style={{ cursor: formData.final_salary_for_tds ? 'not-allowed' : 'default' }}
                                    >
                                        <option value="">{formData.final_salary_for_tds ? "Final Salary Heading Selected" : "Select Specific Salary Heading"}</option>
                                        {salaryStructureHeadings
                                            .sort((a, b) => a.sorting_var - b.sorting_var)
                                            .map(option => (
                                                <option key={option.id} value={option.id}>
                                                    {option.title}
                                                </option>
                                            ))}
                                    </select>
                                    {errors.final_or_selected_salary_for_tds && (
                                        <span className="error-message font-size-text">{errors.final_or_selected_salary_for_tds}</span>
                                    )}
                                    {/* {errors.salary_selection && (
                                        <span className="error-message font-size-text">{errors.salary_selection}</span>
                                    )} */}
                                </div>

                            </form>

                            {(i?.regime_income_investment_count || i?.regime_tax_section_count || i?.regime_age_range_count || i?.regime_slab_count || i?.regime_surcharge_count || i?.regime_investment_forms_count || i?.regime_saved_tds_count) > 0 && (
                                <div className="flex-column margin_top padding_ color-badge-danger color-border-red notice-badge" style={{ marginTop: "5px" }}>
                                    <label
                                        className="font-weight500 font-size-subheading flex align-start item-center gap-1"
                                        style={{ marginTop: "5px" }}
                                    >
                                        <input
                                            type="checkbox"
                                            style={{ marginTop: '6px' }}
                                            checked={variableConfirmation}
                                            onChange={(e) =>
                                                setVariableConfirmation(e.target.checked)
                                            }
                                        />
                                        <span>
                                            Note: This Tax Regime is currently in use in:
                                            <br />
                                            {usedIn}
                                            <br />
                                            Editing this may impact existing configurations and records.
                                            Please confirm if you want to proceed.
                                        </span>

                                    </label>
                                </div>
                            )}

                            <div className="button-models">
                                <button
                                    type="button"
                                    className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    className={`${(i?.regime_income_investment_count || i?.regime_tax_section_count || i?.regime_age_range_count || i?.regime_slab_count || i?.regime_surcharge_count || i?.regime_investment_forms_count || i?.regime_saved_tds_count) > 0 &&
                                        !variableConfirmation
                                        ? "model-button model-button-cancel font-weight500"
                                        : "model-button model-button-leave font-weight500 font-size-heading"
                                        }`}
                                    disabled={
                                        loading ||
                                        ((i?.regime_income_investment_count || i?.regime_tax_section_count || i?.regime_age_range_count || i?.regime_slab_count || i?.regime_surcharge_count || i?.regime_investment_forms_count || i?.regime_saved_tds_count) > 0 &&
                                            !variableConfirmation)
                                    }
                                    onClick={handleSubmit}
                                >
                                    {(i?.regime_income_investment_count || i?.regime_tax_section_count || i?.regime_age_range_count || i?.regime_slab_count || i?.regime_surcharge_count || i?.regime_investment_forms_count || i?.regime_saved_tds_count) > 0
                                        ? variableConfirmation
                                            ? "Submit"
                                            : "Confirmation Needed"
                                        : "Submit"}
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body >
            </Modal >
        </>
    );
};
const DeleteTaxRegime = ({ i, getTaxRegime }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };


    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(
                `${BASE_URL}/wfm/tax-regieme/${i.id}/`
            );
            if (res.status === 200) {
                await getTaxRegime();
                setShow(false);
                toast.success("Tax Regime Deleted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow} title="Delete Tax Regime">
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Tax Regime </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete {" "}
                        <b>{i?.name}</b>{" "}
                        (<b>{formattedDateLong(i?.financial_year_start)}</b> to <b>{formattedDateLong(i?.financial_year_end)}</b>)
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel   font-weight500"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

// ----------------------------------Investment Types Components----------------------------------

const AddInvestmentType = ({ SUB_COMPANIES, SUPER_ADMIN, getInvestmentTypes }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [buffer1, setBuffering1] = useState(true);


    const initialData = {
        name: "",
        category: "",
        regime: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
        sub_company: sessionStorage.getItem('company_id'),
    }
    const [formData, setFormData] = useState(initialData);
    const handleClose = () => {
        setShow(false)
        setFormData(initialData);
        setErrors({});
    };
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "name",
            "category",
            "updated_by",
            "regime",
            "sub_company",

        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = ` ${formattedFieldName
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        }
        finally {
            setBuffering1(false);
        }
    };


    const handleShow = () => {
        setShow(true);
        getTaxRegimeList();
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/type-of-investment/`,
                    [formData]);

                if (res.status === 200 || res.status === 201) {
                    await getInvestmentTypes();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Investment / Income Type created successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };



    return (
        <>
            <button title="Add Investment / Income" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle /><span className="ms-1">Investment / Income</span>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Investment / Income Types </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>

                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        <div className="mb-2">
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                    : null
                                }



                                <div className="flex-column">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime{!formData.sub_company && <span className="required"> (Select Sub Company First)</span>}<span className="required">*</span>

                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="regime"
                                            name="regime"
                                            value={formData.regime}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.regime ? "error" : inputState.regime ? "success" : ""}`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>
                                                    {i?.name} ({formattedDateLong(i?.financial_year_start)} - {formattedDateLong(i?.financial_year_end)})
                                                </option>
                                            ))}
                                        </select>
                                    )}

                                    {errors.regime && (
                                        <span className="error-message font-size-text">{errors.regime}</span>
                                    )}
                                </div>



                                <div className="flex-column">
                                    <label
                                        htmlFor="name"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Name"
                                        maxLength={150}
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input form-input-background ${errors.name ? "error" : inputState.name ? "success" : ""
                                            }`}
                                    />
                                    {errors.name && (
                                        <span className="error-message font-size-text">
                                            {errors.name}
                                        </span>
                                    )}
                                </div>



                                <div className="flex-column">
                                    <label htmlFor="category" className="form-labels font-weight500 font-size-subheading">
                                        Type<span className="required">*</span>
                                    </label>

                                    <select
                                        id="category"
                                        name="category"
                                        value={formData.category}
                                        style={{ marginBottom: "8px" }}
                                        onChange={handleInputChange}
                                        className={`form-input form-input-background ${errors.category ? "error" : inputState.category ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="income">Income</option>
                                        <option value="investment">Investment</option>
                                    </select>

                                    <div className="mb-2">
                                        {errors.category && (
                                            <span className="error-message font-size-text ">{errors.category}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="button-models">
                                    <button
                                        type="button"
                                        className="model-button model-button-cancel font-weight500"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="model-button model-button-leave font-weight500 font-size-heading"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
const UpdateInvestmentType = ({ i, SUB_COMPANIES, SUPER_ADMIN, getInvestmentTypes }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [buffer1, setBuffering1] = useState(true);
    const [variableConfirmation, setVariableConfirmation] = useState(false);

    const handleClose = () => setShow(false);

    const initialData = {
        name: "",
        category: "",
        regime: "",
        updated_by: sessionStorage.getItem('emp_code'),
        sub_company: sessionStorage.getItem('company_id'),
    }
    const [formData, setFormData] = useState(initialData);


    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        }
        finally {
            setBuffering1(false);
        }
    };


    const handleShow = () => {
        setShow(true);
        getTaxRegimeList();
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "name",
            "category",
            "updated_by",
            "regime",
            "sub_company",

        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = `${formattedFieldName
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    useEffect(() => {
        setFormData(i);
    }, [i]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");
            const uploadData = {
                ...formData,
                updated_by: sessionStorage.getItem('emp_code'),
            }
            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/type-of-investment/${i?.id}/`,
                    uploadData
                );

                if (res.status === 200) {
                    await getInvestmentTypes();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Investment / Income type updated successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const usageList = [
        { label: "Tax Sections", count: i?.invest_income_tax_section_count },
    ];

    const usedIn = usageList
        .filter(item => item.count > 0)
        .map(item => `${item.count} ${item.label} `)
        .join(", ");

    return (
        <>

            <button
                title="Update Investment / Income"
                className="model-edit-button-ml"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Investment / Income Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>

                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            onChange={handleInputChange}
                                            style={{ marginBottom: "8px" }}
                                            className={`form-input ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        <div className="mb-2">
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                    : null
                                }


                                <div className="flex-column">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime {!formData.sub_company && <span className="required"> (Select Sub Company First)</span>}<span className="required">*</span>
                                        {/* <span className="info-icon-wrapper">
                                            <InfoIcon />
                                            <span className="tooltip-text">Please select a subcompany first.</span>
                                        </span> */}
                                    </label>

                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="regime"
                                            name="regime"
                                            value={formData.regime}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.regime ? "error" : inputState.regime ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>{i?.name} ({formattedDateLong(i?.financial_year_start)} - {formattedDateLong(i?.financial_year_end)})</option>
                                            ))}


                                        </select>
                                    )}

                                    <div>
                                        {errors.regime && (
                                            <span className="error-message font-size-text ">{errors.regime}</span>
                                        )}
                                    </div>
                                </div>


                                <div className="flex-column">
                                    <label
                                        htmlFor="name"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        maxLength={150}
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input form-input-background ${errors.name ? "error" : inputState.name ? "success" : ""
                                            }`}
                                    />
                                    {errors.name && (
                                        <span className="error-message font-size-text">
                                            {errors.name}
                                        </span>
                                    )}
                                </div>



                                <div className="flex-column">
                                    <label htmlFor="category" className="form-labels font-weight500 font-size-subheading">
                                        Type<span className="required">*</span>
                                    </label>

                                    <select
                                        id="category"
                                        name="category"
                                        value={formData.category}
                                        style={{ marginBottom: "8px" }}
                                        onChange={handleInputChange}
                                        className={`form-input form-input-background ${errors.category ? "error" : inputState.category ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="income">Income</option>
                                        <option value="investment">Investment</option>
                                    </select>

                                    <div className="mb-2">
                                        {errors.category && (
                                            <span className="error-message font-size-text ">{errors.category}</span>
                                        )}
                                    </div>
                                </div>

                                {(i?.invest_income_tax_section_count) > 0 && (
                                    <div className="flex-column margin_top padding_ color-badge-danger color-border-red notice-badge" style={{ marginTop: "5px" }}>
                                        <label
                                            className="font-weight500 font-size-subheading flex  align-start item-center gap-1"
                                            style={{ marginTop: "5px" }}
                                        >
                                            <input
                                                type="checkbox"
                                                style={{ marginTop: '6px' }}
                                                checked={variableConfirmation}
                                                onChange={(e) =>
                                                    setVariableConfirmation(e.target.checked)
                                                }
                                            />


                                            <span>
                                                Note: This Investment/Income types is currently in use in:
                                                <br />
                                                {usedIn}
                                                <br />
                                                Editing this may impact existing configurations and records.
                                                Please confirm if you want to proceed.
                                            </span>

                                        </label>
                                    </div>
                                )}
                                <div className="button-models">
                                    <button
                                        type="button"
                                        className="model-button model-button-cancel font-weight500"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="submit"
                                        className={`${(i?.invest_income_tax_section_count) > 0 &&
                                            !variableConfirmation
                                            ? "model-button model-button-cancel font-weight500"
                                            : "model-button model-button-leave font-weight500 font-size-heading"
                                            }`}
                                        disabled={
                                            loading ||
                                            ((i?.invest_income_tax_section_count) > 0 &&
                                                !variableConfirmation)
                                        }
                                        onClick={handleSubmit}
                                    >
                                        {(i?.invest_income_tax_section_count) > 0
                                            ? variableConfirmation
                                                ? "Submit"
                                                : "Confirmation Needed"
                                            : "Submit"}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
const DeleteInvestmentType = ({ i, getInvestmentTypes }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(
                `${BASE_URL}/wfm/type-of-investment/${i.id}/`
            );
            if (res.status === 200) {
                await getInvestmentTypes();
                setShow(false);
                toast.success("Investment / Income Type Deleted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow} title="Delete Investment / Income">
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Investment / Income Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You want to delete<b> {i?.category} </b> type of{" "}
                        <b>{i?.name}</b>
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

// ----------------------------------Tax Section Components----------------------------------

const AddTaxSection = ({ SUB_COMPANIES, SUPER_ADMIN, getTaxSections }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [investmentType, setInvestmentType] = useState([]);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);

    const [taxRegimeData, setTaxRegimeData] = useState([]);

    const initialData = {
        code: "",
        description: "",
        type: "",
        max_limit: "",
        ref_doc: "",
        regime: "",
        is_manual: false,
        sub_company: sessionStorage.getItem('company_id'),
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    }


    const [formData, setFormData] = useState(initialData);
    const handleClose = () => {
        setShow(false)
        setFormData(initialData);
        setErrors({});
    };
    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };

    const getInvestmentType = async (regimeId) => {
        setBuffering2(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/type-of-investment-by-regime/${regimeId}/`
            );

            setInvestmentType(res.data);
        } catch (err) {
            handleErrorToast(err)
        }
        finally {
            setBuffering2(false);
        }
    };

    useEffect(() => {
        if (formData.sub_company) {
            getTaxRegimeList();

        }
    }, [formData.sub_company])

    useEffect(() => {
        if (formData.regime) {
            getInvestmentType(formData.regime);

        }
    }, [formData.regime])

    const handleShow = () => {
        setShow(true);
    };


    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "code",
            "description",
            "type",
            // "max_limit",
            "regime",
            "ref_doc",
            "sub_company",

        ].filter(Boolean)

        const selectedType = investmentType.find(i => i.id === formData.type);
        if (selectedType?.category.toLowerCase() === "investment") {
            requiredFields.push("max_limit");
        }

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = `${formattedFieldName
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value, checked } = e.target;
        const numericFields = [
            "max_limit",
        ];

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (numericFields.includes(name)) {
            const selectedType = investmentType.find(i => i.id === formData.type);
            const isVisible = selectedType?.category.toLowerCase() === "investment";

            if (!isVisible) {
                setFormData((prev) => ({ ...prev, [name]: value }));
                setInputState((prev) => ({ ...prev, [name]: value.trim() ? "green" : "" }));
                return;
            }

            if (!isValidTwoDecimalNumber(value)) {
                return;
            }
            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }
            const { success, error } = inputMinLimit(name, value, 0);
            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }

        }


        setInputState((prevState) => ({
            ...prevState,
            [name]: value.trim() ? "green" : "",
        }));


        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
            is_manual: checked,
        }));



    };




    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");
            // const formattedCode = formData.code?.trim()?.replace(/\s+/g, "_")?.toUpperCase();
            const selectedType = investmentType.find(i => i.id === formData.type);
            const maxLimitValue =
                selectedType?.category.toLowerCase() === "income"
                    ? 9999999999
                    : formData.max_limit;

            const newFormData = new FormData();
            newFormData.append("code", formData.code);
            newFormData.append("description", formData.description);
            newFormData.append("type", formData.type);
            newFormData.append("regime", formData.regime);
            newFormData.append("max_limit", maxLimitValue);
            newFormData.append("sub_company", formData.sub_company);
            newFormData.append("created_by", formData.created_by);
            newFormData.append("updated_by", formData.updated_by);
            newFormData.append("is_manual", formData.is_manual);

            if (formData.ref_doc) {
                const customFile = generateCustomFileForUpload(formData.ref_doc, "Aimantra");
                newFormData.append("ref_doc", customFile);
            }

            try {

                let res = await axios.post(
                    `${BASE_URL}/wfm/tax-sections/`,
                    newFormData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200 || res.status === 201) {
                    await getTaxSections();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Tax Section created successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };


    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];

        if (file) {
            const validFileTypes = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ];

            if (validFileTypes.includes(file.type)) {
                setFormData({
                    ...formData,
                    [name]: file,
                });
                setErrors({
                    ...errors,
                    [name]: "",
                });
            } else {
                setErrors({
                    ...errors,
                    [name]: "Invalid file type. Please select a PDF or DOC file.",
                });
            }
        } else {
            setFormData({
                ...formData,
                [name]: null,
            });
        }
    };


    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    return (
        <>
            <button title="Add Tax Section" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle /><span className="ms-1">Tax Section</span>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton >
                    <Modal.Title>Add Tax Section</Modal.Title>
                    <div className="justify-end" style={{ marginleft: '100px', width: '23vw' }}>
                        <div className="flex-row align-center justify-end">

                            <label
                                htmlFor="is_manual"
                                className="font-weight500 font-size-subheading "
                            >
                                Manual Calculation:
                            </label>
                            <hr className="field-cont-hr" />
                            <div className="checkbox-toggle">
                                <input
                                    type="checkbox"
                                    name="is_manual"
                                    checked={formData.is_manual}
                                    onChange={handleInputChange}
                                    id="is_manual"
                                />
                                <label htmlFor={`is_manual`}></label>
                            </div>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>

                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            onChange={handleInputChange}
                                            style={{ marginBottom: "8px" }}
                                            className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company</option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        <div className="mb-2">
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                    : null
                                }

                                <div className="flex-column">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime {!formData.sub_company && <span className="required"> (Select Sub Company First)</span>}<span className="required">*</span>
                                        {/* <span className="info-icon-wrapper">
                                            <InfoIcon />
                                            <span className="tooltip-text"></span>
                                        </span> */}
                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (

                                        <select
                                            id="regime"
                                            name="regime"
                                            value={formData.regime}
                                            onChange={handleInputChange}
                                            style={{ marginBottom: "8px", width: 'auto' }}
                                            className={`form-input   ${errors.regime ? "error" : inputState.regime ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>{i?.name} ({formatDate(i?.financial_year_start)} - {formatDate(i?.financial_year_end)})</option>
                                            ))}


                                        </select>
                                    )}

                                    <div className="mb-2">
                                        {errors.regime && (
                                            <span className="error-message font-size-text ">{errors.regime}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="flex-column">
                                    <label
                                        htmlFor="type"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Income/Investment Type {!formData.regime && <span className="required"> (Select Tax Regime First)</span>}<span className="required">*</span>
                                        {/* <span className="info-icon-wrapper">
                                            <InfoIcon />
                                            <span className="tooltip-text">Please select a Tax regime first.</span>
                                        </span> */}
                                    </label>
                                    {buffer2 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="type"
                                            name="type"
                                            value={formData.type}
                                            onChange={handleInputChange}
                                            style={{ marginBottom: "8px", width: 'auto' }}
                                            className={`form-input  ${errors.type ? "error" : inputState.type ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select an Investment Type</option>


                                            {/* {[
                                            ...new Map(investmentType.map((item) => [item.type, item.id])).entries(),
                                        ].map(([type, id], index) => (
                                            <option key={index} value={id}>
                                                {type?.charAt(0).toUpperCase() + type?.slice(1)}
                                            </option>
                                        ))} */}
                                            {investmentType.map((i, index) => (
                                                <option key={index} value={i.id} >
                                                    {i.category.charAt(0).toUpperCase() + i.category.slice(1)} under {i.name}
                                                </option>
                                            ))}

                                        </select>
                                    )}


                                    <div className="mb-2">
                                        {errors.type && (
                                            <span className="error-message font-size-text">{errors.type}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-row justify-between">

                                    <div className="flex-column w-full"
                                    >
                                        <label
                                            htmlFor="code"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Code / Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="code"
                                            name="code"
                                            // maxLength={150}
                                            placeholder="Code"
                                            onChange={handleInputChange}
                                            value={formData.code}
                                            style={{
                                                width: (() => {
                                                    if (!formData.type) return "auto";
                                                    const selectedType = investmentType.find(i => i.id === formData.type);
                                                    return selectedType?.category.toLowerCase() === "income" ? "auto" : "14vw";
                                                })()
                                            }}
                                            className={`form-input form-input-background   ${errors.code
                                                ? "error"
                                                : inputState.code
                                                    ? "success"
                                                    : ""
                                                }`
                                            }
                                        />
                                        {errors.code && (
                                            <span className="error-message font-size-text">
                                                {errors.code}
                                            </span>
                                        )}
                                    </div>


                                    {formData.type && (() => {
                                        const selectedType = investmentType.find(i => i.id === formData.type);
                                        return selectedType?.category.toLowerCase() === "investment";
                                    })() && (
                                            <div className="flex-column">
                                                <label className="form-labels font-weight500 font-size-subheading"
                                                    htmlFor="max_limit">
                                                    Max limit <span className="required"> (Enter Value in Lakhs)*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    name="max_limit"
                                                    id="max_limit"
                                                    placeholder="Max limit"
                                                    min={0}
                                                    style={{ marginTop: '10px', width: '14vw' }}
                                                    value={formData.max_limit}
                                                    onChange={handleInputChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className={`form-input ${errors.max_limit ? "error" : inputState.max_limit ? "success" : ""}`}
                                                    required={(() => {
                                                        const selectedType = investmentType.find(i => i.id === formData.type);
                                                        return selectedType?.category.toLowerCase() === "investment";
                                                    })()}
                                                />
                                                {errors.max_limit && (
                                                    <span className="error-message font-size-text">
                                                        {errors.max_limit}
                                                    </span>
                                                )}
                                            </div>
                                        )}


                                </div>




                                <div className="flex-column">
                                    <label htmlFor="description" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                        Description<span className="required">*</span>
                                    </label>
                                    <textarea
                                        id="description"
                                        type="text"
                                        name="description"
                                        placeholder="Description"
                                        onChange={handleInputChange}
                                        // maxLength={200}
                                        value={formData.description}
                                        style={{ width: 'auto' }}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.description
                                            ? "error"
                                            : inputState.description
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.description && (
                                        <span className="error-message font-size-text ">{errors.description}</span>
                                    )}
                                </div>





                                <div className="flex-column">
                                    <label
                                        htmlFor="ref_doc"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Attachment<span className="required">*</span>
                                    </label>
                                    <div
                                        className={`file-upload-container flex-row justify-between file-in-upload`}
                                        style={{ padding: "0 3px", width: 'auto' }}
                                    >
                                        <label
                                            className="popup-label"
                                            htmlFor="ref_doc"
                                        >
                                            <CloudUpload />
                                            <span className="truncate-url">
                                                {formData?.ref_doc
                                                    ? formData?.ref_doc instanceof File
                                                        ? formData?.ref_doc.name
                                                        : getFileNameFromUrl(formData?.ref_doc)
                                                    : "No file selected"}
                                            </span>
                                        </label>
                                        <input
                                            type="file"
                                            id="ref_doc"
                                            name="ref_doc"
                                            accept=".pdf, .doc, .docx"
                                            onChange={handleFileChange}
                                            className="popup-input"

                                        />
                                        {formData?.ref_doc && (
                                            <span
                                                className="file-clear"
                                                onClick={() => handleFileClear("ref_doc")}
                                            >
                                                Clear
                                            </span>
                                        )}

                                    </div>
                                    <div>
                                        {errors.ref_doc && (
                                            <span className="error-message font-size-text ">
                                                {errors.ref_doc}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className="button-models">
                                    <button
                                        type="button"
                                        className="model-button model-button-cancel font-weight500"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="model-button model-button-leave font-weight500 font-size-heading"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
const UpdateTaxSection = ({ i, SUB_COMPANIES, SUPER_ADMIN, getTaxSections }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [investmentType, setInvestmentType] = useState([]);
    const handleClose = () => setShow(false);
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);
    const [variableConfirmation, setVariableConfirmation] = useState(false);


    const initialData = {
        code: "",
        description: "",
        type: "",
        max_limit: "",
        is_manual: false,
        ref_doc: "",
        regime: "",
        updated_by: sessionStorage.getItem('emp_code'),
        sub_company: sessionStorage.getItem('company_id'),
    }
    const [formData, setFormData] = useState(initialData);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "code",
            "description",
            "type",
            // "max_limit",
            "regime",
            "ref_doc",
            "sub_company",

        ].filter(Boolean)

        const selectedType = investmentType.find(i => i.id === formData.type);
        if (selectedType?.category.toLowerCase() === "investment") {
            requiredFields.push("max_limit");
        }

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = `${formattedFieldName
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    useEffect(() => {
        setFormData(i);
    }, [i]);

    const getInvestmentType = async (regimeId) => {
        setBuffering2(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/type-of-investment-by-regime/${regimeId}/`
            );
            setInvestmentType(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering2(false);
        }
    };


    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };

    useEffect(() => {
        if (formData.sub_company) {
            getTaxRegimeList();
        }
    }, [formData.sub_company])

    useEffect(() => {
        if (formData.regime) {
            getInvestmentType(formData.regime);

        }
    }, [formData.regime])


    const handleShow = () => {
        setShow(true)

    }


    const handleInputChange = (e) => {
        const { name, value, checked } = e.target;
        const numericFields = [
            "max_limit",
        ];
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (numericFields.includes(name)) {
            const selectedType = investmentType.find(i => i.id === formData.type);
            const isVisible = selectedType?.category.toLowerCase() === "investment";

            if (!isVisible) {
                setFormData((prev) => ({ ...prev, [name]: value }));
                setInputState((prev) => ({ ...prev, [name]: value.trim() ? "green" : "" }));
                return;
            }

            if (!isValidTwoDecimalNumber(value)) {
                return;
            }

            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prev) => ({
                    ...prev,
                    [name]: "Value cannot be negative",
                }));
                return;
            }
            // else {
            //     setErrors((prevErrors) => {
            //         const updatedErrors = { ...prevErrors };
            //         delete updatedErrors[name];
            //         return updatedErrors;
            //     });
            // }

            const { success, error } = inputMinLimit(name, value, 0);
            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }


        setFormData({
            ...formData,
            [name]: value,
            is_manual: checked,
        });


        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });



    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];

        if (file) {
            const validFileTypes = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ];

            if (validFileTypes.includes(file.type)) {
                setFormData({
                    ...formData,
                    [name]: file,
                });
                setErrors({
                    ...errors,
                    [name]: "",
                });
            } else {
                setErrors({
                    ...errors,
                    [name]: "Invalid file type. Please select a PDF or DOC file.",
                });
            }
        } else {
            setFormData({
                ...formData,
                [name]: null,
            });
        }
    };


    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");

            const selectedType = investmentType.find(i => i.id === formData.type);
            const maxLimitValue =
                selectedType?.category.toLowerCase() === "income"
                    ? 9999999999
                    : formData.max_limit;

            const newFormData = new FormData();
            newFormData.append("code", formData.code);
            newFormData.append("description", formData.description);
            newFormData.append("type", formData.type);
            newFormData.append("regime", formData.regime);
            newFormData.append("max_limit", maxLimitValue);
            newFormData.append("sub_company", formData.sub_company);
            newFormData.append("is_manual", formData.is_manual);
            newFormData.append("updated_by", formData.updated_by);
            if (formData.ref_doc && formData.ref_doc instanceof File) {

                const customFile = generateCustomFileForUpload(formData.ref_doc, "Aimantra");
                newFormData.append("ref_doc", customFile);
            }

            try {


                let res = await axios.put(
                    `${BASE_URL}/wfm/tax-sections/${i?.id}/`,
                    newFormData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    await getTaxSections();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Tax Section updated successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const usageList = [
        { label: "Investment Forms", count: i?.section_form_count },
    ];

    const usedIn = usageList
        .filter(item => item.count > 0)
        .map(item => `${item.count} ${item.label} `)
        .join(", ");


    return (
        <>

            <button
                title="Update Tax Section"
                className="model-edit-button-ml"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Tax Section</Modal.Title>
                    <div className="justify-end" style={{ marginleft: '100px', width: '23vw' }}>
                        <div className="flex-row align-center justify-end">

                            <label
                                htmlFor="is_manual"
                                className="font-weight500 font-size-subheading "
                            >
                                Manual Calculation:
                            </label>
                            <hr className="field-cont-hr" />
                            <div className="checkbox-toggle">
                                <input
                                    type="checkbox"
                                    name="is_manual"
                                    checked={formData.is_manual}
                                    onChange={handleInputChange}
                                    id="is_manual"
                                />
                                <label htmlFor={`is_manual`}></label>
                            </div>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        <div className="mb-2">
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                    : null
                                }

                                <div className="flex-column">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime {!formData.sub_company && <span className="required"> (Select Sub Company First)</span>}<span className="required">*</span>
                                        {/* <span className="info-icon-wrapper">
                                            <InfoIcon />
                                            <span className="tooltip-text">Please select a subcompany first.</span>
                                        </span> */}
                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="regime"
                                            name="regime"
                                            style={{ marginBottom: "8px", width: 'auto' }}
                                            value={formData.regime}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.regime ? "error" : inputState.regime ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>{i?.name} ({formatDate(i?.financial_year_start)} - {formatDate(i?.financial_year_end)})</option>
                                            ))}


                                        </select>
                                    )}

                                    <div className="mb-2">
                                        {errors.regime && (
                                            <span className="error-message font-size-text ">{errors.regime}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="type"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Income/Investment Type {!formData.regime && <span className="required"> (Select Tax Regime First)</span>}<span className="required">*</span>
                                        {/* <span className="info-icon-wrapper">
                                            <InfoIcon />
                                            <span className="tooltip-text">Please select a Tax regime first.</span>
                                        </span> */}
                                    </label>
                                    {buffer2 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="type"
                                            name="type"
                                            value={formData.type}
                                            style={{ marginBottom: "8px", width: 'auto' }}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.type ? "error" : inputState.type ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select an Investment Type</option>

                                            {investmentType.map((i, index) => (
                                                <option key={index} value={i.id}>
                                                    {i.category.charAt(0).toUpperCase() + i.category.slice(1)} under {i.name}
                                                </option>
                                            ))}
                                        </select>
                                    )}


                                    <div className="mb-2">
                                        {errors.type && (
                                            <span className="error-message font-size-text">{errors.type}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex flex-row justify-between">
                                    <div className="flex-column w-full">
                                        <label
                                            htmlFor="code"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Code / Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="code"
                                            name="code"
                                            // maxLength={150}
                                            onChange={handleInputChange}
                                            value={formData.code}
                                            style={{
                                                width: (() => {
                                                    if (!formData.type) return "auto";
                                                    const selectedType = investmentType.find(i => i.id === formData.type);
                                                    return selectedType?.category.toLowerCase() === "income" ? "auto" : "14vw";
                                                })()
                                            }}
                                            className={`form-input form-input-background  ${errors.code
                                                ? "error"
                                                : inputState.code
                                                    ? "success"
                                                    : ""
                                                }`
                                            }
                                        />
                                        {errors.code && (
                                            <span className="error-message font-size-text">
                                                {errors.code}
                                            </span>
                                        )}
                                    </div>
                                    {formData.type && (() => {
                                        const selectedType = investmentType.find(i => i.id === formData.type);
                                        return selectedType?.category.toLowerCase() === "investment";
                                    })() && (
                                            <div className="flex-column">
                                                <label className="form-labels font-weight500 font-size-subheading"
                                                    htmlFor="max_limit">
                                                    Max limit <span className="required"> (Enter Value in Lakhs)*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    name="max_limit"
                                                    id="max_limit"
                                                    placeholder="Max limit"
                                                    min={0}
                                                    style={{ marginTop: '10px', width: '14vw' }}
                                                    value={formData.max_limit}
                                                    onChange={handleInputChange}
                                                    onWheel={(e) => e.target.blur()}
                                                    className={`form-input ${errors.max_limit ? "error" : inputState.max_limit ? "success" : ""}`}
                                                    required={(() => {
                                                        const selectedType = investmentType.find(i => i.id === formData.type);
                                                        return selectedType?.category.toLowerCase() === "investment";
                                                    })()}
                                                />
                                                {errors.max_limit && (
                                                    <span className="error-message font-size-text">
                                                        {errors.max_limit}
                                                    </span>
                                                )}
                                            </div>
                                        )}

                                </div>

                                {/* <div className="flex-row mb-2">
                                    <div className="checkbox-toggle">
                                        <input
                                            type="checkbox"
                                            name="is_manual"
                                            checked={formData.is_manual}
                                            onChange={handleInputChange}
                                            id="is_manual"
                                        />
                                        <label htmlFor={`is_manual`}></label>
                                    </div>
                                    <hr className="field-cont-hr" />
                                    <label
                                        htmlFor="is_manual"
                                        className="font-weight500 font-size-subheading"
                                    >
                                        {formData.is_manual ? "True" : "False"}
                                    </label>
                                </div> */}

                                <div className="flex-column">
                                    <label htmlFor="description" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                        Description<span className="required">*</span>
                                    </label>
                                    <textarea
                                        id="description"
                                        type="text"
                                        name="description"
                                        placeholder="Your Description"
                                        onChange={handleInputChange}
                                        // maxLength={200}
                                        style={{ width: 'auto' }}
                                        value={formData.description}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.description
                                            ? "error"
                                            : inputState.description
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.description && (
                                        <span className="error-message font-size-text ">{errors.description}</span>
                                    )}
                                </div>


                                <div className="flex-column">
                                    <label
                                        htmlFor="ref_doc"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Attachment<span className="required">*</span>
                                    </label>
                                    <div
                                        className={`file-upload-container flex-row justify-between file-in-upload`}
                                        style={{ padding: "0 3px", width: 'auto' }}
                                    >
                                        <label
                                            className="popup-label"
                                            htmlFor="ref_doc"
                                        >
                                            <CloudUpload />
                                            <span className="truncate-url">
                                                {formData?.ref_doc
                                                    ? formData?.ref_doc instanceof File
                                                        ? formData?.ref_doc.name
                                                        : getFileNameFromUrl(formData?.ref_doc)
                                                    : "No file selected"}
                                            </span>
                                        </label>
                                        <input
                                            type="file"
                                            id="ref_doc"
                                            name="ref_doc"
                                            accept=".pdf, .doc, .docx"
                                            onChange={handleFileChange}
                                            className="popup-input"

                                        />
                                        {formData?.ref_doc && (
                                            <span
                                                className="file-clear"
                                                onClick={() => handleFileClear("ref_doc")}
                                            >
                                                Clear
                                            </span>
                                        )}
                                        <div>
                                            {errors.ref_doc && (
                                                <span className="error-message font-size-text ">
                                                    {errors.ref_doc}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {(i?.section_form_count) > 0 && (
                                    <div className="flex-column margin_top padding_ color-badge-danger color-border-red notice-badge" style={{ marginTop: "5px" }}>
                                        <label
                                            className="font-weight500 font-size-subheading flex  align-start item-center gap-1"
                                            style={{ marginTop: "5px" }}
                                        >
                                            <input
                                                type="checkbox"
                                                style={{ marginTop: '6px' }}
                                                checked={variableConfirmation}
                                                onChange={(e) =>
                                                    setVariableConfirmation(e.target.checked)
                                                }
                                            />


                                            <span>
                                                Note: This Tax section is currently in use in:
                                                <br />
                                                {usedIn}
                                                <br />
                                                Editing this may impact existing configurations and records.
                                                Please confirm if you want to proceed.
                                            </span>

                                        </label>
                                    </div>
                                )}

                                <div className="button-models">
                                    <button
                                        type="button"
                                        className="model-button model-button-cancel font-weight500"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className={`${(i?.section_form_count) > 0 &&
                                            !variableConfirmation
                                            ? "model-button model-button-cancel font-weight500"
                                            : "model-button model-button-leave font-weight500 font-size-heading"
                                            }`}
                                        disabled={
                                            loading ||
                                            ((i?.section_form_count) > 0 &&
                                                !variableConfirmation)
                                        }
                                        onClick={handleSubmit}
                                    >
                                        {(i?.section_form_count) > 0
                                            ? variableConfirmation
                                                ? "Submit"
                                                : "Confirmation Needed"
                                            : "Submit"}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
const DeleteTaxSection = ({ i, getTaxSections }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(
                `${BASE_URL}/wfm/tax-sections/${i.id}/`
            );
            if (res.status === 200) {
                await getTaxSections();
                setShow(false);
                toast.success("Tax Section Deleted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow} title="Delete Tax Section">
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Tax Section</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Section  <b> {i?.code} </b> under <span className="text-capitalize"><b>{i?.type_details?.type}</b></span> type.

                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

//------------------------------------Age Range for Tax slab----------------------------------


const AddAgeRangeTaxslab = ({ SUB_COMPANIES, SUPER_ADMIN, getAgeRangeTaxSlab }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [buffer1, setBuffering1] = useState(true);

    const initialData = {
        age_limit_start: "",
        age_limit_end: "",
        lable: "",
        regime: "",
        sub_company: sessionStorage.getItem('company_id'),
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    }
    const [formData, setFormData] = useState(initialData);
    const handleClose = () => {
        setShow(false)
        setFormData(initialData);
        setErrors({});
    };

    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };

    useEffect(() => {
        if (formData.sub_company) {
            getTaxRegimeList();
        }
    }, [formData.sub_company])

    const handleShow = () => {
        setShow(true);
    };


    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "age_limit_start",
            "lable",
            "regime",
            "sub_company",

        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = `${formattedFieldName
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;


        const integerFields = ["age_limit_start", "age_limit_end"];
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (integerFields.includes(name)) {
            if (!isValidTwoDecimalNumber(value)) {
                return;
            }


            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }





            const { success, error } = inputMinLimit(name, value, 0);
            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }


        setFormData({
            ...formData,
            [name]: value,
        });


        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });


        // if (!integerFields.includes(name)) {
        //     setErrors((prevErrors) => {
        //         const updatedErrors = { ...prevErrors };
        //         delete updatedErrors[name];
        //         return updatedErrors;
        //     });
        // }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");
            const payload = {
                ...formData,
                age_limit_end: formData.age_limit_end === "" ? null : formData.age_limit_end,
            };

            try {

                let res = await axios.post(
                    `${BASE_URL}/wfm/age-range-for-tax-slab/`,
                    [payload]
                );

                if (res.status === 200 || res.status === 201) {
                    await getAgeRangeTaxSlab();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Age Range For Tax slab created successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button title="Add Age Range" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle /><span className="ms-1">Age Range</span>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Age Range For Tax slab</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            onChange={handleInputChange}
                                            style={{ marginBottom: "8px" }}
                                            className={`form-input ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        <div className="mb-2">
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                    : null
                                }

                                <div className="flex-column">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime {!formData.sub_company && <span className="required"> (Select Sub Company First)</span>}<span className="required">*</span>

                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="regime"
                                            name="regime"
                                            value={formData.regime}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.regime ? "error" : inputState.regime ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>{i?.name} ({formatDate(i?.financial_year_start)} - {formatDate(i?.financial_year_end)})</option>
                                            ))}


                                        </select>
                                    )}
                                    <div className="mb-2">
                                        {errors.regime && (
                                            <span className="error-message font-size-text ">{errors.regime}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="flex-column">
                                    <label
                                        htmlFor="lable"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Lable<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="lable"
                                        name="lable"
                                        maxLength={150}
                                        placeholder="Lable"
                                        onChange={handleInputChange}
                                        value={formData.lable}
                                        className={`form-input form-input-background  ${errors.lable
                                            ? "error"
                                            : inputState.lable
                                                ? "success"
                                                : ""
                                            }`
                                        }
                                    />
                                    {errors.lable && (
                                        <span className="error-message font-size-text">
                                            {errors.lable}
                                        </span>
                                    )}
                                </div>



                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="age_limit_start">
                                        Starting age<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="age_limit_start"
                                        id="age_limit_start"
                                        placeholder="Starting age"
                                        // defaultValue={}
                                        min={1}
                                        style={{ marginTop: '14px' }}
                                        value={formData.age_limit_start}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input ${errors.age_limit_start ? "error" : inputState.age_limit_start ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.age_limit_start && (
                                        <span className="error-message font-size-text ">
                                            {errors.age_limit_start}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="age_limit_end">
                                        Ending age
                                    </label>
                                    <input
                                        type="number"
                                        name="age_limit_end"
                                        id="age_limit_end"
                                        placeholder="Ending age"
                                        // defaultValue={}
                                        min={1}
                                        style={{ marginTop: '14px' }}
                                        value={formData.age_limit_end}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input ${errors.age_limit_end ? "error" : inputState.age_limit_end ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.age_limit_end && (
                                        <span className="error-message font-size-text ">
                                            {errors.age_limit_end}
                                        </span>
                                    )}
                                </div>


                                <div className="button-models">
                                    <button
                                        type="button"
                                        className="model-button model-button-cancel font-weight500"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="model-button model-button-leave font-weight500 font-size-heading"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>


                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
const UpdateAgeRangeTaxslab = ({ i, SUB_COMPANIES, SUPER_ADMIN, getAgeRangeTaxSlab }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [buffer1, setBuffering1] = useState(true);
    const [variableConfirmation, setVariableConfirmation] = useState(false);


    const handleClose = () => setShow(false);


    const initialData = {
        age_limit_start: "",
        age_limit_end: "",
        lable: "",
        regime: "",
        sub_company: sessionStorage.getItem('company_id'),
        updated_by: sessionStorage.getItem('emp_code'),
    }
    const [formData, setFormData] = useState(initialData);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "age_limit_start",

            "lable",
            "regime",
            "sub_company",
        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = `${formattedFieldName
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    useEffect(() => {
        setFormData(i);
    }, [i]);

    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };

    useEffect(() => {
        if (formData.sub_company) {
            getTaxRegimeList();
        }
    }, [formData.sub_company])


    const handleShow = () => {
        setShow(true);
    }


    const handleInputChange = (e) => {
        const { name, value } = e.target;


        const integerFields = ["age_limit_start", "age_limit_end"];
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (integerFields.includes(name)) {
            if (!isValidTwoDecimalNumber(value)) {
                return;
            }

            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }




            const { success, error } = inputMinLimit(name, value, 0);
            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }


        setFormData({
            ...formData,
            [name]: value,
        });


        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });



    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");
            const payload = {
                ...formData,
                updated_by: sessionStorage.getItem('emp_code'),
                age_limit_end: formData.age_limit_end === "" ? null : formData.age_limit_end,
            };
            try {


                let res = await axios.put(
                    `${BASE_URL}/wfm/age-range-for-tax-slab/${i?.id}/`,
                    payload

                );

                if (res.status === 200) {
                    await getAgeRangeTaxSlab();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Age Range For Tax slab updated successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const usageList = [
        { label: "Surcharge slabs", count: i?.agerange_slab_count },
    ];

    const usedIn = usageList
        .filter(item => item.count > 0)
        .map(item => `${item.count} ${item.label} `)
        .join(", ");

    return (
        <>

            <button
                title="Update Age Range"
                className="model-edit-button-ml"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Age Range For Tax slab</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        <div className="mb-2">
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                    : null
                                }

                                <div className="flex-column">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime {!formData.sub_company && <span className="required"> (Select Sub Company First)</span>}<span className="required">*</span>

                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="regime"
                                            name="regime"
                                            value={formData.regime}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.regime ? "error" : inputState.regime ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>{i?.name} ({formatDate(i?.financial_year_start)} - {formatDate(i?.financial_year_end)})</option>
                                            ))}


                                        </select>
                                    )}

                                    <div className="mb-2">
                                        {errors.regime && (
                                            <span className="error-message font-size-text ">{errors.regime}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="lable"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Lable<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="lable"
                                        name="lable"
                                        placeholder="Lable"
                                        maxLength={150}
                                        onChange={handleInputChange}
                                        value={formData.lable}
                                        className={`form-input form-input-background  ${errors.lable
                                            ? "error"
                                            : inputState.lable
                                                ? "success"
                                                : ""
                                            }`
                                        }
                                    />
                                    {errors.lable && (
                                        <span className="error-message font-size-text">
                                            {errors.lable}
                                        </span>
                                    )}
                                </div>



                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="age_limit_start">
                                        Starting age<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="age_limit_start"
                                        id="age_limit_start"
                                        placeholder="Starting age"
                                        // defaultValue={}
                                        min={1}
                                        style={{ marginTop: '14px' }}
                                        value={formData.age_limit_start}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={` inc-select form-input ${errors.age_limit_start ? "error" : inputState.age_limit_start ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.age_limit_start && (
                                        <span className="error-message font-size-text ">
                                            {errors.age_limit_start}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="age_limit_end">
                                        Ending age
                                    </label>
                                    <input
                                        type="number"
                                        name="age_limit_end"
                                        id="age_limit_end"
                                        placeholder="Ending age"
                                        // defaultValue={}
                                        min={1}
                                        style={{ marginTop: '14px' }}
                                        value={formData.age_limit_end}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={` inc-select form-input ${errors.age_limit_end ? "error" : inputState.age_limit_end ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.age_limit_end && (
                                        <span className="error-message font-size-text ">
                                            {errors.age_limit_end}
                                        </span>
                                    )}
                                </div>
                                {(i?.agerange_slab_count) > 0 && (
                                    <div className="flex-column margin_top padding_ color-badge-danger color-border-red notice-badge" style={{ marginTop: "5px" }}>
                                        <label
                                            className="font-weight500 font-size-subheading flex  align-start item-center gap-1"
                                            style={{ marginTop: "5px" }}
                                        >
                                            <input
                                                type="checkbox"
                                                style={{ marginTop: '6px' }}
                                                checked={variableConfirmation}
                                                onChange={(e) =>
                                                    setVariableConfirmation(e.target.checked)
                                                }
                                            />


                                            <span>
                                                Note: This Age range for Tax slab is currently in use in:
                                                <br />
                                                {usedIn}
                                                <br />
                                                Editing this may impact existing configurations and records.
                                                Please confirm if you want to proceed.
                                            </span>

                                        </label>
                                    </div>
                                )}

                                <div className="button-models">
                                    <button
                                        type="button"
                                        className="model-button model-button-cancel font-weight500"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className={`${(i?.agerange_slab_count) > 0 &&
                                            !variableConfirmation
                                            ? "model-button model-button-cancel font-weight500"
                                            : "model-button model-button-leave font-weight500 font-size-heading"
                                            }`}
                                        disabled={
                                            loading ||
                                            ((i?.agerange_slab_count) > 0 &&
                                                !variableConfirmation)
                                        }
                                        onClick={handleSubmit}
                                    >
                                        {(i?.agerange_slab_count) > 0
                                            ? variableConfirmation
                                                ? "Submit"
                                                : "Confirmation Needed"
                                            : "Submit"}
                                    </button>
                                </div>
                            </form>
                        </div>
                        {isSubmitted && Object.keys(errors).length > 0 && (
                            <div className="error-message font-size-text text-center">
                                {Object.keys(errors).length > 5 ? (
                                    <h5>Please fill all mandatory fields!</h5>
                                ) : (
                                    (() => {
                                        const fields = Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            );


                                        return (
                                            <h6>
                                                {fields.join(', ')} {fields.length === 1 ? 'is' : 'are'} required!
                                            </h6>
                                        );
                                    })()
                                )}
                            </div>
                        )}

                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
const DeleteAgeRangeTaxslab = ({ i, getAgeRangeTaxSlab }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(
                `${BASE_URL}/wfm/age-range-for-tax-slab/${i.id}/`
            );
            if (res.status === 200) {
                await getAgeRangeTaxSlab();
                setShow(false);
                toast.success("Age Range For Tax slab Deleted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow} title="Delete Age Range">
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Age Range For Tax slab</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Age Range For Tax slab of{" "}
                        <b>{i?.lable}</b>
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

//------------------------------------Tax Slab----------------------------------


const AddTaxslab = ({ SUB_COMPANIES, SUPER_ADMIN, getTaxSlab }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);


    const initialData = {
        regime: "",
        age_category: "",
        lower_limit: "",
        upper_limit: "",
        rate: "",
        sub_company: sessionStorage.getItem('company_id'),
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    }
    const [formData, setFormData] = useState(initialData);
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [ageCategoryData, setAgeCategoryData] = useState([]);
    const handleClose = () => {
        setShow(false);
        setFormData(initialData);
        setErrors({});
    };

    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };

    const getAgeCategoryByRegime = async (regimeId) => {
        setBuffering2(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/age-range-by-subcompany-regime/${formData.sub_company}/${regimeId}/`);
            setAgeCategoryData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering2(false);
        }
    };

    useEffect(() => {
        if (formData.sub_company) {
            getTaxRegimeList();
        }
    }, [formData.sub_company])

    useEffect(() => {
        if (formData.regime) {
            getAgeCategoryByRegime(formData.regime);
        }
    }, [formData.regime])

    const handleShow = () => {
        setShow(true);
    };


    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "regime",
            "age_category",
            "lower_limit",
            "rate",
            "sub_company",

        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = ` ${formattedFieldName
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const numericFields = [
            "lower_limit",
            "upper_limit",
            "rate",
        ];

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (numericFields.includes(name)) {

            if (!isValidTwoDecimalNumber(value)) {
                return;
            }


            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }


            const { success, error } = inputMinLimit(name, value, 0);

            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        // if (name === "regime" && value) {
        //     getAgeCategoryByRegime(value);
        //     setFormData((prev) => ({
        //         ...prev,
        //         age_category: "",
        //     }));
        // }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });




    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");

            const payload = {
                ...formData,
                upper_limit: formData.upper_limit === "" ? null : formData.upper_limit,
            }

            try {

                let res = await axios.post(
                    `${BASE_URL}/wfm/tax-slab/`,
                    [payload]
                );

                if (res.status === 200 || res.status === 201) {
                    await getTaxSlab();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Tax slab created successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button title="Add Tax Slab" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle /><span className="ms-1">Tax Slab</span>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Tax Slab</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        <div className="mb-2">
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                    : null
                                }
                                <div className="flex-column ">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime {!formData.sub_company && <span className="required"> (Select Sub Company First)</span>}<span className="required">*</span>

                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="regime"
                                            name="regime"
                                            value={formData.regime}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.regime ? "error" : inputState.regime ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>{i?.name}({formatDate(i?.financial_year_start)} - {formatDate(i?.financial_year_end)})</option>
                                            ))}


                                        </select>
                                    )}
                                    <div className="mb-2">
                                        {errors.regime && (
                                            <span className="error-message font-size-text ">{errors.regime}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="age_category" className="form-labels font-weight500 font-size-subheading">
                                        Age Category {!formData.regime && <span className="required"> (Select Tax regime First)</span>}<span className="required">*</span>

                                    </label>
                                    {buffer2 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="age_category"
                                            name="age_category"
                                            value={formData.age_category}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.age_category ? "error" : inputState.age_category ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Age Category</option>
                                            {ageCategoryData.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.lable}
                                                </option>
                                            ))}
                                        </select>
                                    )}

                                    {errors.age_category && (
                                        <span className="error-message font-size-text">{errors.age_category}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="rate">
                                        Rate(%)<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="rate"
                                        id="rate"
                                        placeholder="Rate"
                                        // defaultValue={}
                                        min={0}
                                        style={{ marginTop: '14px' }}
                                        value={formData.rate}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate}
                                        </span>
                                    )}
                                </div>

                                <div className="form-flex-wrap">
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading"
                                            htmlFor="lower_limit">
                                            Lower Limit<span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            name="lower_limit"
                                            id="lower_limit"
                                            placeholder="Lower limit"
                                            // defaultValue={}
                                            min={0}
                                            style={{ marginTop: '14px' }}
                                            value={formData.lower_limit}
                                            onChange={handleInputChange}
                                            onWheel={(e) => e.target.blur()}
                                            className={` inc-select form-input ${errors.lower_limit ? "error" : inputState.lower_limit ? "success" : ""
                                                }
                                            `}
                                            required
                                        />
                                        {errors.lower_limit && (
                                            <span className="error-message font-size-text ">
                                                {errors.lower_limit}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading"
                                            htmlFor="upper_limit">
                                            Upper Limit
                                        </label>
                                        <input
                                            type="number"
                                            name="upper_limit"
                                            id="upper_limit"
                                            placeholder="Upper limit"
                                            // defaultValue={}
                                            min={0}
                                            style={{ marginTop: '14px' }}
                                            value={formData.upper_limit}
                                            onChange={handleInputChange}
                                            onWheel={(e) => e.target.blur()}
                                            className={`inc-select form-input ${errors.upper_limit ? "error" : inputState.upper_limit ? "success" : ""
                                                }
                                            `}
                                            required
                                        />
                                        {errors.upper_limit && (
                                            <span className="error-message font-size-text ">
                                                {errors.upper_limit}
                                            </span>
                                        )}
                                    </div>
                                </div>



                                <div className="button-models">
                                    <button
                                        type="button"
                                        className="model-button model-button-cancel font-weight500"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="model-button model-button-leave font-weight500 font-size-heading"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
const UpdateTaxslab = ({ i, SUB_COMPANIES, SUPER_ADMIN, getTaxSlab }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const handleClose = () => setShow(false);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);
    const [variableConfirmation, setVariableConfirmation] = useState(false);


    const initialData = {
        regime: "",
        age_category: "",
        lower_limit: "",
        upper_limit: "",
        rate: "",
        sub_company: sessionStorage.getItem('company_id'),
        updated_by: sessionStorage.getItem('emp_code'),
    }
    const [formData, setFormData] = useState(initialData);
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [ageCategoryData, setAgeCategoryData] = useState([]);

    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };

    const getAgeCategoryByRegime = async (regimeId) => {
        setBuffering2(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/age-range-by-subcompany-regime/${formData.sub_company}/${regimeId}/`);
            setAgeCategoryData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering2(false);
        }
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "regime",
            "age_category",
            "lower_limit",

            "rate",
            "sub_company",

        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = ` ${formattedFieldName
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    useEffect(() => {
        setFormData(i);
    }, [i]);


    // useEffect(() => {
    //     if (formData.sub_company) {
    //         getTaxRegimeList();
    //     }
    // }, [formData.sub_company])



    // useEffect(() => {
    //     if (formData.regime) {
    //         getAgeCategoryByRegime(formData.regime);
    //     }
    // }, [formData.regime]);

    useEffect(() => {
        if (show) {
            setFormData(i);


            getTaxRegimeList();


            if (i?.regime) {
                getAgeCategoryByRegime(i.regime);
            }
        }
    }, [show]);



    const handleShow = () => {
        setShow(true);
    }


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const numericFields = [
            "lower_limit",
            "upper_limit",
            "rate",
        ];
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (numericFields.includes(name)) {

            if (!isValidTwoDecimalNumber(value)) {
                return;
            }


            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }


            const { success, error } = inputMinLimit(name, value, 0);

            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }

        if (name === "regime") {
            setFormData(prev => ({
                ...prev,
                regime: value,
                age_category: ""
            }));

            getAgeCategoryByRegime(value);
            return;
        }



        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        // if (name === "regime" && value) {
        //     getAgeCategoryByRegime(value);
        //     setFormData((prev) => ({
        //         ...prev,
        //         age_category: "",
        //     }));
        // }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });




    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");
            const payload = {
                ...formData,
                updated_by: sessionStorage.getItem('emp_code'),
                upper_limit: formData.upper_limit === "" ? null : formData.upper_limit,
            }
            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/tax-slab/${i?.id}/`,
                    payload
                );

                if (res.status === 200) {
                    await getTaxSlab();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Tax slab updated successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const usageList = [
        { label: "Saved TDS", count: i?.total_slab_usage_count },
    ];

    const usedIn = usageList
        .filter(item => item.count > 0)
        .map(item => `${item.count} ${item.label} `)
        .join(", ");

    return (
        <>

            <button
                title="Update Tax slab"
                className="model-edit-button-ml"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Tax slab</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        <div className="mb-2">
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                    : null
                                }
                                <div className="flex-column">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime {!formData.sub_company && <span className="required"> (Select Sub Company First)</span>}<span className="required">*</span>

                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="regime"
                                            name="regime"
                                            value={formData.regime}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.regime ? "error" : inputState.regime ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>{i?.name} ({formatDate(i?.financial_year_start)} - {formatDate(i?.financial_year_end)})</option>
                                            ))}


                                        </select>
                                    )}

                                    <div className="mb-2">
                                        {errors.regime && (
                                            <span className="error-message font-size-text ">{errors.regime}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="age_category" className="form-labels font-weight500 font-size-subheading">
                                        Age Category {!formData.regime && <span className="required"> (Select Tax Regime First)</span>}<span className="required">*</span>

                                    </label>

                                    {buffer2 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="age_category"
                                            name="age_category"
                                            value={formData.age_category}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.age_category ? "error" : inputState.age_category ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Age Category</option>
                                            {ageCategoryData.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.lable}
                                                </option>
                                            ))}
                                        </select>
                                    )}

                                    {errors.age_category && (
                                        <span className="error-message font-size-text">{errors.age_category}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="rate">
                                        Rate<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="rate"
                                        id="rate"
                                        placeholder="Rate"
                                        // defaultValue={}
                                        min={0}
                                        style={{ marginTop: '14px' }}
                                        value={formData.rate}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate}
                                        </span>
                                    )}
                                </div>

                                <div className="form-flex-wrap">
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading"
                                            htmlFor="lower_limit">
                                            Lower Limit<span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            name="lower_limit"
                                            id="lower_limit"
                                            placeholder="Lower limit"
                                            // defaultValue={}
                                            min={0}
                                            style={{ marginTop: '14px' }}
                                            value={formData.lower_limit}
                                            onChange={handleInputChange}
                                            onWheel={(e) => e.target.blur()}
                                            className={`inc-select form-input ${errors.lower_limit ? "error" : inputState.lower_limit ? "success" : ""
                                                }
                                            `}
                                            required
                                        />
                                        {errors.lower_limit && (
                                            <span className="error-message font-size-text ">
                                                {errors.lower_limit}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading"
                                            htmlFor="upper_limit">
                                            Upper Limit
                                        </label>
                                        <input
                                            type="number"
                                            name="upper_limit"
                                            placeholder="Upper limit"
                                            id="upper_limit"
                                            // defaultValue={}
                                            min={0}
                                            style={{ marginTop: '14px' }}
                                            value={formData.upper_limit}
                                            onChange={handleInputChange}
                                            onWheel={(e) => e.target.blur()}
                                            className={` inc-select form-input ${errors.upper_limit ? "error" : inputState.upper_limit ? "success" : ""
                                                }
                                            `}
                                            required
                                        />
                                        {errors.upper_limit && (
                                            <span className="error-message font-size-text ">
                                                {errors.upper_limit}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {(i?.total_slab_usage_count) > 0 && (
                                    <div className="flex-column margin_top padding_ color-badge-danger color-border-red notice-badge" style={{ marginTop: "5px" }}>
                                        <label
                                            className="font-weight500 font-size-subheading flex  align-start item-center gap-1"
                                            style={{ marginTop: "5px" }}
                                        >
                                            <input
                                                type="checkbox"
                                                style={{ marginTop: '6px' }}
                                                checked={variableConfirmation}
                                                onChange={(e) =>
                                                    setVariableConfirmation(e.target.checked)
                                                }
                                            />


                                            <span>
                                                Note: This Tax slab is currently in use in
                                                {usedIn}
                                                <br />
                                                Editing this may impact existing configurations and records.
                                                Please confirm if you want to proceed.
                                            </span>

                                        </label>
                                    </div>
                                )}

                                <div className="button-models">
                                    <button
                                        type="button"
                                        className="model-button model-button-cancel font-weight500"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className={`${(i?.total_slab_usage_count) > 0 &&
                                            !variableConfirmation
                                            ? "model-button model-button-cancel font-weight500"
                                            : "model-button model-button-leave font-weight500 font-size-heading"
                                            }`}
                                        disabled={
                                            loading ||
                                            ((i?.total_slab_usage_count) > 0 &&
                                                !variableConfirmation)
                                        }
                                        onClick={handleSubmit}
                                    >
                                        {(i?.total_slab_usage_count) > 0
                                            ? variableConfirmation
                                                ? "Submit"
                                                : "Confirmation Needed"
                                            : "Submit"}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
const DeleteTaxslab = ({ i, getTaxSlab }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(
                `${BASE_URL}/wfm/tax-slab/${i.id}/`
            );
            if (res.status === 200) {
                await getTaxSlab();
                setShow(false);
                toast.success("Tax slab Deleted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow} title="Delete Tax slab">
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Tax slab</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Tax slab of <b> {i?.age_range_details?.age_limit_start}-{i?.age_range_details?.age_limit_end} years</b> age range
                        {/* <b>{i?.lable}</b> */}
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

//------------------------------------Surcharges-Slab----------------------------------


const AddSurchargeslab = ({ SUB_COMPANIES, SUPER_ADMIN, getSurchargeSlab }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [buffer1, setBuffering1] = useState(true);

    const [isSubmitted, setIsSubmitted] = useState(false);
    const handleClose = () => {
        setShow(false);
        setFormData(initialData);
        setErrors({});
    };

    const initialData = {
        regime: "",
        min_income: "",
        max_income: "",
        rate: "",
        sub_company: sessionStorage.getItem('company_id'),
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    }
    const [formData, setFormData] = useState(initialData);
    const [taxRegimeData, setTaxRegimeData] = useState([]);



    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };

    useEffect(() => {
        if (formData.sub_company) {
            getTaxRegimeList();
        }
    }, [formData.sub_company])

    const handleShow = () => {
        setShow(true);
    };


    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "regime",
            "min_income",
            "rate",
            "sub_company",

        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = `${formattedFieldName
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const numericFields = [
            "min_income",
            "max_income",
            "rate",
        ];

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (numericFields.includes(name)) {

            if (!isValidTwoDecimalNumber(value)) {
                return;
            }


            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }


            const { success, error } = inputMinLimit(name, value, 0);

            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }






        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));


        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });




    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");
            const payload = {
                ...formData,

                max_income: formData.max_income === "" ? null : formData.max_income,
            }
            try {

                let res = await axios.post(
                    `${BASE_URL}/wfm/surcharge-slab/`,
                    [payload]
                );

                if (res.status === 200 || res.status === 201) {
                    await getSurchargeSlab();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Surcharge slab created successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button title="Add Surcharge Slab" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle /><span className="ms-1">Surcharge Slab</span>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Surcharge Slab</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        <div className="mb-2">
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                    : null
                                }
                                <div className="flex-column">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime
                                        {!formData.sub_company && <span className="required"> (Select Sub Company First)</span>}<span className="required">*</span>
                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="regime"
                                            name="regime"
                                            value={formData.regime}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.regime ? "error" : inputState.regime ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>{i?.name}({formatDate(i?.financial_year_start)} - {formatDate(i?.financial_year_end)})</option>
                                            ))}


                                        </select>
                                    )}

                                    <div className="mb-2">
                                        {errors.regime && (
                                            <span className="error-message font-size-text ">{errors.regime}</span>
                                        )}
                                    </div>
                                </div>




                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="rate">
                                        Rate (%)<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="rate"
                                        id="rate"
                                        placeholder="Rate"
                                        // defaultValue={}
                                        min={0}
                                        style={{ marginTop: '14px' }}
                                        value={formData.rate}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={` form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate}
                                        </span>
                                    )}
                                </div>

                                <div className="form-flex-wrap">

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading"
                                            htmlFor="min_income">
                                            Min Income<span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            name="min_income"
                                            id="min_income"
                                            placeholder="Min income"
                                            // defaultValue={}
                                            min={0}
                                            style={{ marginTop: '14px' }}
                                            value={formData.min_income}
                                            onChange={handleInputChange}
                                            onWheel={(e) => e.target.blur()}
                                            className={` inc-select form-input ${errors.min_income ? "error" : inputState.min_income ? "success" : ""
                                                }
                                            `}
                                            required
                                        />
                                        {errors.min_income && (
                                            <span className="error-message font-size-text ">
                                                {errors.min_income}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading"
                                            htmlFor="max_income">
                                            Max Income
                                        </label>
                                        <input
                                            type="number"
                                            name="max_income"
                                            id="max_income"
                                            placeholder="Max income"
                                            // defaultValue={}
                                            min={0}
                                            style={{ marginTop: '14px' }}
                                            value={formData.max_income}
                                            onChange={handleInputChange}
                                            onWheel={(e) => e.target.blur()}
                                            className={`inc-select form-input ${errors.max_income ? "error" : inputState.max_income ? "success" : ""
                                                }
                                            `}
                                            required
                                        />
                                        {errors.max_income && (
                                            <span className="error-message font-size-text ">
                                                {errors.max_income}
                                            </span>
                                        )}
                                    </div>
                                </div>



                                <div className="button-models">
                                    <button
                                        type="button"
                                        className="model-button model-button-cancel font-weight500"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="model-button model-button-leave font-weight500 font-size-heading"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
const UpdateSurchargeslab = ({ i, SUB_COMPANIES, SUPER_ADMIN, getSurchargeSlab }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const handleClose = () => setShow(false);
    const [buffer1, setBuffering1] = useState(true);
    const [variableConfirmation, setVariableConfirmation] = useState(false);


    const initialData = {
        regime: "",
        min_income: "",
        max_income: "",
        rate: "",
        sub_company: sessionStorage.getItem('company_id'),
        updated_by: sessionStorage.getItem('emp_code'),
    }
    const [formData, setFormData] = useState(initialData);
    const [taxRegimeData, setTaxRegimeData] = useState([]);


    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            setTaxRegimeData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };

    useEffect(() => {
        if (formData.sub_company) {
            getTaxRegimeList();
        }
    }, [formData.sub_company])

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "regime",
            "min_income",

            "rate",
            "sub_company",
        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = `${formattedFieldName
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    useEffect(() => {
        setFormData(i);
    }, [i]);


    const handleShow = () => {
        setShow(true);
    }


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const numericFields = [
            "min_income",
            "max_income",
            "rate",
        ];
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (numericFields.includes(name)) {

            if (!isValidTwoDecimalNumber(value)) {
                return;
            }


            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }


            const { success, error } = inputMinLimit(name, value, 0);

            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }






        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));


        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });




    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");

            const payload = {
                ...formData,
                updated_by: sessionStorage.getItem('emp_code'),
                max_income: formData.max_income === "" ? null : formData.max_income,
            }
            try {


                let res = await axios.put(
                    `${BASE_URL}/wfm/surcharge-slab/${i?.id}/`,
                    payload
                );

                if (res.status === 200) {
                    await getSurchargeSlab();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Surcharge slab updated successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const usageList = [
        { label: "Saved TDS", count: i?.surchargeslab_regime_saved_tax_count },
    ];

    const usedIn = usageList
        .filter(item => item.count > 0)
        .map(item => `${item.count} ${item.label} `)
        .join(", ");

    return (
        <>

            <button
                title="Update Surcharge slab"
                className="model-edit-button-ml"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Surcharge slab</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            value={formData.sub_company}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        <div className="mb-2">
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                    : null
                                }
                                <div className="flex-column">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime
                                        {!formData.sub_company && <span className="required"> (Select Sub Company First)</span>}<span className="required">*</span>
                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="regime"
                                            name="regime"
                                            value={formData.regime}
                                            onChange={handleInputChange}
                                            style={{ marginBottom: "8px" }}
                                            className={`form-input ${errors.regime ? "error" : inputState.regime ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>{i?.name}({formatDate(i?.financial_year_start)} - {formatDate(i?.financial_year_end)})</option>
                                            ))}


                                        </select>
                                    )}

                                    <div className="mb-2">
                                        {errors.regime && (
                                            <span className="error-message font-size-text ">{errors.regime}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                        htmlFor="rate">
                                        Rate (%)<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="rate"
                                        id="rate"
                                        placeholder="Rate"
                                        // defaultValue={}
                                        min={0}
                                        style={{ marginTop: '14px' }}
                                        value={formData.rate}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                            }
                                            `}
                                        required
                                    />
                                    {errors.rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate}
                                        </span>
                                    )}
                                </div>


                                <div className="form-flex-wrap">

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading"
                                            htmlFor="min_income">
                                            Min Income<span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            name="min_income"
                                            id="min_income"
                                            placeholder="Min income"
                                            // defaultValue={}
                                            min={0}
                                            style={{ marginTop: '14px' }}
                                            value={formData.min_income}
                                            onChange={handleInputChange}
                                            onWheel={(e) => e.target.blur()}
                                            className={`inc-select form-input ${errors.min_income ? "error" : inputState.min_income ? "success" : ""
                                                }
                                            `}
                                            required
                                        />
                                        {errors.min_income && (
                                            <span className="error-message font-size-text ">
                                                {errors.min_income}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading"
                                            htmlFor="max_income">
                                            Max Income
                                        </label>
                                        <input
                                            type="number"
                                            name="max_income"
                                            id="max_income"
                                            placeholder="Max income"
                                            // defaultValue={}
                                            min={0}
                                            style={{ marginTop: '14px' }}
                                            value={formData.max_income}
                                            onChange={handleInputChange}
                                            onWheel={(e) => e.target.blur()}
                                            className={`inc-select form-input ${errors.max_income ? "error" : inputState.max_income ? "success" : ""
                                                }
                                            `}
                                            required
                                        />
                                        {errors.max_income && (
                                            <span className="error-message font-size-text ">
                                                {errors.max_income}
                                            </span>
                                        )}
                                    </div>

                                </div>

                                {(i?.surchargeslab_regime_saved_tax_count) > 0 && (
                                    <div className="flex-column margin_top padding_ color-badge-danger color-border-red notice-badge" style={{ marginTop: "5px" }}>
                                        <label
                                            className="font-weight500 font-size-subheading flex  align-start item-center gap-1"
                                            style={{ marginTop: "5px" }}
                                        >
                                            <input
                                                type="checkbox"
                                                style={{ marginTop: '6px' }}
                                                checked={variableConfirmation}
                                                onChange={(e) =>
                                                    setVariableConfirmation(e.target.checked)
                                                }
                                            />


                                            <span>
                                                Note: This Surcharge slab is currently in use in
                                                {usedIn}
                                                <br />
                                                Editing this may impact existing configurations and records.
                                                Please confirm if you want to proceed.
                                            </span>

                                        </label>
                                    </div>
                                )}
                                <div className="button-models">
                                    <button
                                        type="button"
                                        className="model-button model-button-cancel font-weight500"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className={`${(i?.surchargeslab_regime_saved_tax_count) > 0 &&
                                            !variableConfirmation
                                            ? "model-button model-button-cancel font-weight500"
                                            : "model-button model-button-leave font-weight500 font-size-heading"
                                            }`}
                                        disabled={
                                            loading ||
                                            ((i?.surchargeslab_regime_saved_tax_count) > 0 &&
                                                !variableConfirmation)
                                        }
                                        onClick={handleSubmit}
                                    >
                                        {(i?.surchargeslab_regime_saved_tax_count) > 0
                                            ? variableConfirmation
                                                ? "Submit"
                                                : "Confirmation Needed"
                                            : "Submit"}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
const DeleteSurchargeslab = ({ i, getSurchargeSlab }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(
                `${BASE_URL}/wfm/surcharge-slab/${i.id}/`
            );
            if (res.status === 200) {
                await getSurchargeSlab();
                setShow(false);
                toast.success("Surcharge slab Deleted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };



    return (
        <>
            <button className="model-delete-button" onClick={handleShow} title="Delete Surcharge slab">
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Surcharge slab</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Surcharge slab for income range <b>{formatCurrencyIndian(i?.min_income)} - {formatCurrencyIndian(i?.max_income)} </b>  with <b>{formatCurrencyIndian(i?.rate)} %</b> rate ?
                        {/* <b>{i?.lable}</b> */}
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

//------------------------------------ Investment Form----------------------------------


const AddEmpInvestmentForm = ({ emp_code, SUB_COMPANIES, SUPER_ADMIN, PERMISSION_HR_ADMIN, getInvestmentForm, currentFormExists, viewAccess }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setFormData(initialData);
        getAllEmp_code();
        getTaxRegimeList();
        setShow(true);
        if (formData.emp_code) {
            getUSerDetails(formData.emp_code);
        }

    };
    const handleClose = () => {
        setFormData(initialData);
        setErrors({});
        setShowTdsResult(false)
        setShow(false);
    }


    const initialData = {
        emp_code: emp_code ? emp_code : sessionStorage.getItem("emp_code"),
        regime: "",
        declaration_status: "draft",
        prev_company_salary: '',
        prev_company_tax: '',
        prev_company_salary_doc: '',
        prev_company_tax_doc: '',
        items: [
            {
                section: "",
                declared_amount: "",
                declaration_remarks: "",
                declaration_status: "draft",
                final_amount: "",
                proof_amount: "", //declared_amount //total_proof_amount
                proof_remarks: "",
                calculation_amount: "",
                proof_status: "draft",
                created_by: sessionStorage.getItem("emp_code"),
                updated_by: sessionStorage.getItem("emp_code"),
                proofs: [
                    {
                        document: "",
                        document_url: "",
                        proof_amt: "",
                        status: 'pending',
                        remarks: "",
                        // final_amount: "",
                    }
                ]
            }
        ],

        sub_company: sessionStorage.getItem("company_id"),
        created_by: sessionStorage.getItem("emp_code"),
        updated_by: sessionStorage.getItem("emp_code"),
        submitted_at: null,
    };

    // const [currentFormExists, setCurrentFormExist] = useState(false);
    const [buffer, setBuffering] = useState(false);
    const [buffer1, setBuffering1] = useState(false);
    const [buffer2, setBuffering2] = useState(false);
    const [buffer3, setBuffering3] = useState(true);
    const [buffer4, setBuffering4] = useState(true);
    const [loading, setLoading] = useState(false);
    const [loadingTDs, setloadingTDs] = useState(false);

    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [showProofFields, setShowProofFields] = useState(false);
    const [TdsCalcList, setTdsCalcList] = useState({});

    const [formData, setFormData] = useState(initialData);

    const [taxSectionData, setTaxSectionData] = useState([]);
    const [empList, setEmpList] = useState([]);
    // const [isProofEditable, setIsProofEditable] = useState(false);
    const [showTdsResult, setShowTdsResult] = useState(false);
    const [userData, setUserData] = useState({});
    const [showPreviousCompanyFields, setShowPreviousCompanyFields] = useState(false);


    const getUSerDetails = async (empcode) => {
        setBuffering4(true); // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemp/${empcode}/`);
            setUserData(res.data);

        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering4(false);// End Buffering
        }
    };

    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            const allRegimes = res.data;

            const today = new Date();
            const currentRegimes = allRegimes.filter((regime) => {
                const startDate = new Date(regime.financial_year_start);
                const endDate = new Date(regime.financial_year_end);

                return startDate <= today && today <= endDate;
            });

            setTaxRegimeData(currentRegimes);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };

    const getTaxSectionList = async (regimeId) => {
        setBuffering2(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-sections-by-subcompany-tax-regime/${formData.sub_company}/${regimeId}/`);
            setTaxSectionData(res.data);
        } catch (err) {
            handleErrorToast(err);
        }
        finally {
            setBuffering2(false);
        }
    };


    const getAllEmp_code = async () => {
        setBuffering3(true); // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${formData.sub_company}/`
            );

            const sortedList = customSortByKey(res.data, "emp_code");

            setEmpList(sortedList);
        } catch (err) {
        } finally {
            setBuffering3(false); // End Buffering
        }
    };

    useEffect(() => {
        if (formData.emp_code) {
            getUSerDetails(formData.emp_code)
        }
    }, [formData.emp_code])

    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const fieldLabels = {
            regime: "Regime",
            emp_code: "Employee Code",
            prev_company_salary: "Previous Company Salary",
            prev_company_tax: "Previous Company Tax",
            prev_company_salary_doc: "Previous Company Salary Document",
            prev_company_tax_doc: "Previous Company Tax Document",
        };

        const requiredFields = [
            "regime",
            "emp_code",
            ...(showPreviousCompanyFields
                ? [
                    "prev_company_salary",
                    "prev_company_tax",
                    "prev_company_salary_doc",
                    ...(Number(formData.prev_company_tax) > 0
                        ? ["prev_company_tax_doc"]
                        : []),
                ]
                : []),
        ].filter(Boolean);

        requiredFields.forEach((field) => {
            const value = formData[field];

            if (
                value === undefined ||
                value === null ||
                (typeof value === "string" && value.trim() === "") ||
                (Array.isArray(value) && value.length === 0)
            ) {
                // newErrors[field] =
                //     `${field.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())} is required!`;
                newErrors[field] =
                    `${fieldLabels[field] || field.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())} is required!`;
            }
        });

        newErrors.items = [];

        formData.items.forEach((item, index) => {
            const itemErrors = {};

            if (!item.section) {
                itemErrors.section = "Section is required!";
            }

            if (!showProofFields && !item.declared_amount) {
                itemErrors.declared_amount = "Declared amount is required!";
            }

            if (!item.declaration_remarks) {
                itemErrors.declaration_remarks = "Remarks are required!";
            }

            if (showProofFields) {
                const proofArrErrors = [];
                let hasAtLeastOneValidProof = false;

                item.proofs.forEach((proof, pIndex) => {
                    const proofErrors = {};

                    const hasDocument = proof.document || proof.document_url;
                    const hasAmount = proof.proof_amt;
                    const hasRemarks = proof.remarks;

                    if (hasDocument && hasAmount && hasRemarks) {
                        hasAtLeastOneValidProof = true;
                    }

                    if (!hasDocument) {
                        proofErrors.document = "Document or URL is required!";
                    }

                    if (!hasAmount) {
                        proofErrors.proof_amt = "Amount is required!";
                    }

                    if (!hasRemarks) {
                        proofErrors.remarks = "Remarks are required!";
                    }

                    if (Object.keys(proofErrors).length > 0) {
                        proofArrErrors[pIndex] = proofErrors;
                    }
                });

                if (!hasAtLeastOneValidProof) {
                    itemErrors.proofsRequired = "Proof document is required.";
                }

                if (proofArrErrors.length > 0) {
                    itemErrors.proofs = proofArrErrors;
                }
            }

            if (Object.keys(itemErrors).length > 0) {
                newErrors.items[index] = itemErrors;
            }
        });

        if (newErrors.items.length === 0) {
            delete newErrors.items;
        }

        setErrors(newErrors);
        setIsSubmitted(true);
        const hasErrors = Object.keys(newErrors).length > 0;

        return !hasErrors;
    };


    const handleInputChange = async (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        const numberFields = [
            "prev_company_salary",
            "prev_company_tax",
        ];

        let updatedValue = value;

        if (numberFields.includes(name)) {
            updatedValue = value === "" ? null : Number(value);
        }

        setFormData((prev) => ({
            ...prev,
            [name]: updatedValue,
        }));


        if (name === "regime" && value) {
            await getTaxSectionList(value);

            const selectedRegime = taxRegimeData.find((item) => item.id === value);

            if (selectedRegime) {
                const today = new Date();
                const start = new Date(selectedRegime.proof_submission_start_date);
                const end = new Date(selectedRegime.proof_submission_end_date);

                const isProofWindowOpen = today >= start && today <= end;
                setShowProofFields(isProofWindowOpen);


                //Joining date 
                if (userData?.joining_date) {
                    const joiningDate = new Date(userData.joining_date);
                    const fyStart = new Date(selectedRegime.financial_year_start);


                    const isJoiningWithinFY =
                        joiningDate >= fyStart


                    setShowPreviousCompanyFields(isJoiningWithinFY);
                } else {
                    setShowPreviousCompanyFields(false);
                }
            }

            setFormData((prev) => ({
                ...prev,
                regime: value,
                items: JSON.parse(JSON.stringify(initialData.items)),
            }));

            setTdsCalcList(null);
            setShowTdsResult(false);


            setErrors({});
            return;
        }

        if (name === "prev_company_tax") {
            if (Number(updatedValue) <= 0) {
                setErrors((prev) => {
                    const newErr = { ...prev };
                    delete newErr.prev_company_tax_doc;
                    return newErr;
                });
            }
        }


        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };


    const handlePrevDocClearFile = (type) => {
        if (type === "salary") {
            setFormData(prev => ({
                ...prev,
                prev_company_salary_doc: null
            }));
        }

        if (type === "tax") {
            setFormData(prev => ({
                ...prev,
                prev_company_tax_doc: null
            }));
        }
    };


    const updateItemAmounts = () => {
        setFormData(prev => {
            const updatedItems = prev.items.map((item) => {


                const isAllProofsEmpty = !item.proofs || item.proofs.every(p =>
                    !p.proof_amt &&
                    !p.document &&
                    !p.document_url &&
                    !p.remarks
                    // && !p.calculation_amount
                );


                const finalProofArray = isAllProofsEmpty ? [] : item.proofs;


                const totalProof = finalProofArray.reduce(
                    (sum, p) => sum + Number(p.proof_amt || 0),
                    0
                );


                if (!showProofFields) {
                    return {
                        ...item,
                        final_amount: item.declared_amount || 0,
                        proof_amount: item.declared_amount || 0,
                        calculation_amount: item.declared_amount || 0,
                        proofs: []
                    };
                }


                return {
                    ...item,
                    declared_amount: totalProof,
                    final_amount: totalProof,
                    proof_amount: totalProof,
                    calculation_amount: totalProof,
                    proofs: finalProofArray.map(p => ({
                        ...p,
                        // final_amount: p.proof_amt || 0
                    }))
                };
            });

            return { ...prev, items: updatedItems };
        });
    };

    const handleItemChange = (index, e) => {
        const { name, value } = e.target;
        const updatedItems = [...formData.items];

        if (value.trim()) {

            setErrors((prev) => {
                const updated = { ...prev };


                if (updated.items?.[index]) {


                    if (updated.items[index][name]) {
                        updated.items[index][name] = "";
                    }


                    if (updated.items[index].proofs) {
                        updated.items[index].proofs = updated.items[index].proofs.map((proofErr) =>
                            Object.fromEntries(Object.entries(proofErr).filter(([_, v]) => v))
                        );


                        updated.items[index].proofs = updated.items[index].proofs.filter(
                            (obj) => Object.keys(obj).length > 0
                        );


                        if (updated.items[index].proofs.length === 0) {
                            delete updated.items[index].proofs;
                        }
                    }


                    if (Object.keys(updated.items[index]).length === 0) {
                        delete updated.items[index];
                    }


                    if (
                        updated.items &&
                        Object.keys(updated.items).every((key) => !updated.items[key] || Object.keys(updated.items[key]).length === 0)
                    ) {
                        delete updated.items;
                    }
                }

                return updated;
            });

        }


        const numericFields = ["declared_amount"];

        if (numericFields.includes(name)) {
            if (!isValidTwoDecimalNumber(value)) return;

            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => {
                    const updated = { ...prevErrors };
                    updated.items = updated.items || [];
                    updated.items[index] = updated.items[index] || {};
                    updated.items[index][name] = "Value cannot be negative";
                    return updated;
                });
                return;
            }

            const { success, error } = inputMinLimit(name, value, 0);
            if (!success) {
                setErrors((prevErrors) => {
                    const updated = { ...prevErrors };
                    updated.items = updated.items || [];
                    updated.items[index] = updated.items[index] || {};
                    updated.items[index][name] = error;
                    return updated;
                });
            }
        }


        updatedItems[index] = {
            ...updatedItems[index],
            [name]: value,
        };

        setFormData((prev) => {
            const newData = {
                ...prev,
                items: updatedItems,
            };

            return newData;
        });


        updateItemAmounts();


        setInputState((prev) => ({
            ...prev,
            [`item_${index}_${name}`]: value.trim() ? "green" : "",
        }));
    };

    const addItem = () => {
        setFormData((prev) => ({
            ...prev,
            items: [
                ...prev.items,
                {
                    section: "",
                    declared_amount: "",
                    declaration_remarks: "",
                    declaration_status: "draft",
                    final_amount: "",
                    proof_amount: "",
                    proof_remarks: "",
                    calculation_amount: "",
                    proof_status: "draft",
                    created_by: sessionStorage.getItem("emp_code"),
                    updated_by: sessionStorage.getItem("emp_code"),
                    proofs: [
                        {
                            document: "",
                            document_url: "",
                            proof_amt: "",
                            remarks: "",
                            status: "",
                            // final_amount: "",
                            // verified_by: sessionStorage.getItem("emp_code"),

                        }
                    ]
                }
            ],
        }));
    };

    const removeItem = (index) => {
        setFormData((prev) => ({
            ...prev,
            items: prev.items.filter((_, i) => i !== index),
        }));
    };

    const handleAddProof = (itemIndex) => {
        setFormData(prev => {
            const items = [...prev.items];
            const proofs = items[itemIndex].proofs || [];

            items[itemIndex].proofs = [
                ...proofs,
                {
                    document: "",
                    document_url: "",
                    proof_amt: "",
                    remarks: "",
                    status: "pending",
                }
            ];

            return { ...prev, items };
        });
    };




    const handleProofFieldChange = (e, itemIndex, proofIndex) => {
        const { name, value, files } = e.target;
        setErrors(prevErrors => {
            const updated = { ...prevErrors };

            if (updated.items?.[itemIndex]?.proofs?.[proofIndex]?.[name]) {
                updated.items[itemIndex].proofs[proofIndex][name] = "";
            }

            if (
                updated.items?.[itemIndex]?.proofs?.[proofIndex] &&
                Object.values(updated.items[itemIndex].proofs[proofIndex]).every(v => !v)
            ) {
                delete updated.items[itemIndex].proofs[proofIndex];
            }

            if (
                updated.items?.[itemIndex]?.proofs &&
                Object.values(updated.items[itemIndex].proofs).every(obj => !obj || Object.keys(obj).length === 0)
            ) {
                delete updated.items[itemIndex].proofs;
            }

            if (
                updated.items?.[itemIndex]?.proofs &&
                Array.isArray(updated.items[itemIndex].proofs) &&
                updated.items[itemIndex].proofs.length === 0
            ) {
                delete updated.items[itemIndex].proofs;
            }

            if (
                updated.items?.[itemIndex] &&
                Object.values(updated.items[itemIndex]).every(v => !v || (typeof v === "object" && Object.keys(v).length === 0))
            ) {
                delete updated.items[itemIndex];
            }

            if (
                updated.items &&
                Object.values(updated.items).every(itemObj => !itemObj || Object.keys(itemObj).length === 0)
            ) {
                delete updated.items;
            }

            return updated;
        });

        setFormData(prev => {
            const items = [...prev.items];
            const proofs = [...items[itemIndex].proofs];
            const proof = proofs[proofIndex];

            if (name === "document") {
                proof.document = files[0];
                proof.document_url = "";
            }
            else if (name === "document_url") {
                proof.document_url = value;
                proof.document = null;
            }
            else {
                proof[name] = value;
            }

            // proof.final_amount = Number(proof.proof_amt || 0);
            proofs[proofIndex] = proof;

            const total = proofs.reduce((sum, p) => sum + Number(p.proof_amt || 0), 0);

            items[itemIndex] = {
                ...items[itemIndex],
                proofs,
                proof_amount: total,
                declared_amount: total,
                final_amount: total,
                calculation_amount: total,
            };

            return { ...prev, items };
        });

        setInputState(prev => ({
            ...prev,
            [`proof_${itemIndex}_${proofIndex}_${name}`]:
                (name === "document" && files?.length > 0) ||
                    (name !== "document" && value.trim())
                    ? "green"
                    : "",
        }));
    };

    const handleRemoveProof = (itemIndex, proofIndex) => {
        setFormData(prev => {
            const items = [...prev.items];
            const proofs = [...items[itemIndex].proofs];

            proofs.splice(proofIndex, 1);

            const total = proofs.reduce((sum, p) => sum + Number(p.proof_amt || 0), 0);

            items[itemIndex].proofs = proofs;
            items[itemIndex].proof_amount = total;
            items[itemIndex].declared_amount = total;
            items[itemIndex].final_amount = total;
            items[itemIndex].calculation_amount = total;

            return { ...prev, items };
        });
    };

    const handleClearFile = (itemIndex, proofIndex) => {
        setFormData(prev => {
            const items = [...prev.items];
            const proofs = [...items[itemIndex].proofs];

            proofs[proofIndex].document = null;
            proofs[proofIndex].document_url = "";

            items[itemIndex].proofs = proofs;

            return { ...prev, items };
        });

        const inputEl = document.querySelector(`#proof-file-${itemIndex}-${proofIndex}`);
        if (inputEl) inputEl.value = "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);
        try {

            const fd = new FormData();

            fd.append("emp_code", formData.emp_code);
            fd.append("regime", formData.regime);
            fd.append("declaration_status", formData.declaration_status);
            fd.append("sub_company", formData.sub_company);
            fd.append("created_by", formData.created_by);
            fd.append("updated_by", formData.updated_by);
            fd.append("submitted_at", formData.submitted_at);


            fd.append(
                "prev_company_salary",
                formData.prev_company_salary === "" || formData.prev_company_salary === null
                    ? "0"
                    : formData.prev_company_salary
            );

            fd.append(
                "prev_company_tax",
                formData.prev_company_tax === "" || formData.prev_company_tax === null
                    ? "0"
                    : formData.prev_company_tax
            );

            // if (formData.prev_company_salary_doc instanceof File) {
            //     fd.append("prev_company_salary_doc", formData.prev_company_salary_doc);
            // }

            // if (formData.prev_company_tax_doc instanceof File) {
            //     fd.append("prev_company_tax_doc", formData.prev_company_tax_doc);
            // }

            fd.append("prev_company_salary_doc", formData.prev_company_salary_doc);
            fd.append("prev_company_tax_doc", formData.prev_company_tax_doc);

            formData.items.forEach((item, i) => {
                fd.append(`items[${i}][section]`, item.section);
                fd.append(`items[${i}][declared_amount]`, item.declared_amount);
                fd.append(`items[${i}][declaration_status]`, item.declaration_status);
                fd.append(`items[${i}][declaration_remarks]`, item.declaration_remarks);
                fd.append(`items[${i}][final_amount]`, item.final_amount);
                fd.append(`items[${i}][calculation_amount]`, item.calculation_amount);
                fd.append(`items[${i}][proof_amount]`, item.proof_amount);
                fd.append(`items[${i}][proof_status]`, item.proof_status);
                fd.append(`items[${i}][updated_by]`, item.updated_by);
                fd.append(`items[${i}][created_by]`, item.created_by);

                item.proofs.forEach((p, j) => {

                    if (p.document && typeof p.document === "object") {
                        fd.append(`items[${i}][proofs][${j}][document]`, p.document);
                    }

                    if (p.document_url) {
                        fd.append(`items[${i}][proofs][${j}][document_url]`, p.document_url);
                    }

                    fd.append(`items[${i}][proofs][${j}][proof_amt]`, p.proof_amt);
                    fd.append(`items[${i}][proofs][${j}][approved_amt]`, p.proof_amt);
                    fd.append(`items[${i}][proofs][${j}][remarks]`, p.remarks);
                    fd.append(`items[${i}][proofs][${j}][status]`, p.status);
                });
            });

            let res = await axios.post(
                `${BASE_URL}/wfm/investmentform-fillup-withproofs/`, fd,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (res.status === 200 || res.status === 201) {
                await getInvestmentForm();
                setShow(false);
                setFormData(initialData);
                toast.success("Investment Form created successfully!");
            } else {
                console.error("Something went wrong: " + res.statusText);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleTdsCalculation = async (e) => {
        e.preventDefault();
        setloadingTDs(true);
        setBuffering(true);
        try {

            let res = await axios.post(
                `${BASE_URL}/wfm/tds-calculater-byempinput/${formData.emp_code}/${formData.regime || 'null'}/`,
                formData.items
            );
            if (res.status === 200 || res.status === 201) {
                setTdsCalcList(res.data);
                setShowTdsResult(true);
            } else {
                setShowTdsResult(false);
                console.error("Something went wrong at AddEmpInvestmentForm: " + res.statusText);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
            setloadingTDs(false);
        }
    };


    return (
        <>
            <button title={currentFormExists ? "Calculate TDS" : "Add Investment Form"}
                className="upload-svg flex-row" onClick={handleShow}>
                {currentFormExists
                    ?
                    <>
                        <UpdatePencilBox /><span className="ms-1">Calculate TDS</span>
                    </>
                    :
                    <>
                        <AddwithWhiteCircle /><span className="ms-1">Investment Form</span>
                    </>
                }
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="five-sixth-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {currentFormExists
                            ?
                            "Calculate Estimated TDS"
                            :
                            "Apply Investment Form"
                        }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">

                            <div className="form-flex-wrap">
                                {SUPER_ADMIN ?
                                    <div className="flex-column">
                                        <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>

                                        <select
                                            id="sub_company"
                                            name="sub_company"
                                            style={{ marginBottom: "8px" }}
                                            value={formData.sub_company}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Company  </option>
                                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                        </select>

                                        <div className="mb-2">
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">{errors.sub_company}</span>
                                            )}
                                        </div>
                                    </div>
                                    : null
                                }
                                {viewAccess === 'hr' && (
                                    <div className="flex-column ">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Employee<span className="required">*</span>
                                        </label>
                                        {buffer3 ? (
                                            <div className="form-loader">
                                                <div className="bar-loader"></div>
                                            </div>
                                        ) : (
                                            <select
                                                name="emp_code"
                                                value={formData.emp_code}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.emp_code
                                                    ? "error"
                                                    : inputState.emp_code
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select An Employee</option>
                                                {empList
                                                    .sort((a, b) => a.emp_code - b.emp_code)
                                                    .map((i, index) => (
                                                        <option value={i.emp_code}>
                                                            {i.name} - {i.emp_code}
                                                        </option>
                                                    ))}
                                            </select>
                                        )}
                                        {errors.emp_code && (
                                            <span className="error-message font-size-text ">
                                                {errors.emp_code}
                                            </span>
                                        )}
                                    </div>
                                )}
                                <div className="flex-column">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime
                                        {!formData.sub_company && <span className="required"> (Select Sub Company First)</span>}<span className="required">*</span>
                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="regime"
                                            name="regime"
                                            value={formData.regime}
                                            style={{ marginBottom: "8px" }}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.regime ? "error" : inputState.regime ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>
                                                    {/* {i?.name}({formatDate(i?.financial_year_start)} - {formatDate(i?.financial_year_end)}) */}
                                                    {i?.name} ({formatDate(i?.financial_year_start, true).MonthYear} to {formatDate(i?.financial_year_end, true).MonthYear})
                                                </option>
                                            ))}


                                        </select>
                                    )}

                                    <div className="mb-2">
                                        {errors.regime && (
                                            <span className="error-message font-size-text ">{errors.regime}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {showPreviousCompanyFields && (


                                <div className="form-flex-wrap  mb-2">
                                    <div className="flex-column">
                                        <label
                                            htmlFor="prev_company_salary"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Previous Company Salary Amount
                                            <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            placeholder="Previous Company Salary Amount"
                                            name="prev_company_salary"
                                            id="prev_company_salary"
                                            min={0}
                                            onWheel={(e) => e.target.blur()}
                                            value={formData.prev_company_salary || ''}

                                            onChange={handleInputChange}
                                            className={`form-input ${errors.prev_company_salary
                                                ? "error"
                                                : inputState.prev_company_salary
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        />

                                        {errors.prev_company_salary && (
                                            <span className="error-message">
                                                {errors.prev_company_salary}
                                            </span>
                                        )}

                                    </div>


                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">Previous Company Salary Document
                                            <span className="required">*</span></label>

                                        <div className={`flex-row justify-between form-input w-full"
                                        ${errors.prev_company_salary_doc
                                                ? "error"
                                                : inputState.prev_company_salary_doc
                                                    ? "success"
                                                    : ""
                                            }
                                                                                                `}

                                        >
                                            <label
                                                htmlFor='prev_company_salary_doc'
                                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                            >
                                                <CloudUpload />
                                                <span className="truncate-url" style={{ marginLeft: "10px" }}>
                                                    {formData.prev_company_salary_doc?.name || "No file selected"}
                                                </span>
                                            </label>

                                            <input
                                                type="file"
                                                id='prev_company_salary_doc'
                                                name="prev_company_salary_doc"
                                                accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpeg,.jpg"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        prev_company_salary_doc: file
                                                    }));
                                                    if (file) {
                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            prev_company_salary_doc: "",
                                                        }));
                                                    }
                                                }}

                                                style={{ display: "none" }}
                                            />

                                            {formData.prev_company_salary_doc && (
                                                <span
                                                    className="file-clear"
                                                    onClick={() => handlePrevDocClearFile("salary")}


                                                >
                                                    Clear
                                                </span>
                                            )}
                                        </div>
                                        {errors?.prev_company_salary_doc && (
                                            <span className="error-message">
                                                {errors?.prev_company_salary_doc}
                                            </span>
                                        )}

                                    </div>
                                    <div className="flex-column">
                                        <label
                                            htmlFor="prev_company_tax"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Previous Company Tax
                                            <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            placeholder="Previous Company Tax"
                                            name="prev_company_tax"
                                            id="prev_company_tax"
                                            min={0}
                                            // style={{ width: "auto" }}
                                            onWheel={(e) => e.target.blur()}
                                            value={formData.prev_company_tax}

                                            onChange={handleInputChange}

                                            className={`form-input ${errors.prev_company_tax
                                                ? "error"
                                                : inputState.prev_company_tax
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        />

                                        {errors.prev_company_tax && (
                                            <span className="error-message">
                                                {errors.prev_company_tax}
                                            </span>
                                        )}

                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Previous Company Tax Document
                                            {Number(formData.prev_company_tax) > 0 && (
                                                <span className="required">*</span>
                                            )}
                                        </label>

                                        <div className={`flex-row justify-between form-input w-full"
                                       ${errors.prev_company_tax_doc
                                                ? "error"
                                                : inputState.prev_company_tax_doc
                                                    ? "success"
                                                    : ""
                                            }
                                                                                                `}

                                        >
                                            <label
                                                htmlFor='prev_company_tax_doc'
                                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                            >
                                                <CloudUpload />
                                                <span className="truncate-url" style={{ marginLeft: "10px" }}>
                                                    {formData.prev_company_tax_doc?.name || "No file selected"}
                                                </span>
                                            </label>

                                            <input
                                                type="file"
                                                id='prev_company_tax_doc'
                                                name="prev_company_tax_doc"
                                                accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpeg,.jpg"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        prev_company_tax_doc: file
                                                    }));
                                                    if (file) {
                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            prev_company_tax_doc: "",
                                                        }));
                                                    }
                                                }}

                                                style={{ display: "none" }}
                                            />

                                            {formData.prev_company_tax_doc && (
                                                <span
                                                    className="file-clear"
                                                    onClick={() => handlePrevDocClearFile("tax")}


                                                >
                                                    Clear
                                                </span>
                                            )}
                                        </div>
                                        {errors?.prev_company_tax_doc && (
                                            <span className="error-message">
                                                {errors?.prev_company_tax_doc}
                                            </span>
                                        )}

                                    </div>
                                </div>

                            )}
                            <div className="form-flex-wrap">


                                <div className="items-section">
                                    {/* <h4 className="font-size-heading font-weight600 mb-2">Items</h4> */}

                                    {formData.items.map((item, index) => (
                                        <>
                                            <div
                                                key={index}
                                                className="item-box rounded relative"
                                                style={{
                                                    border: "1px solid #dfdfdf",
                                                    marginBottom: '23px'
                                                }}
                                            >
                                                {/* <div
                                                    className="w-full p-1 form-labels font-weight500 font-size-subheading mt-0 w-auto border-bottom"
                                                    style={{ textAlign: 'center' }}
                                                >
                                                    {index + 1}
                                                </div> */}
                                                <div
                                                    className="container-top-center-content"
                                                >
                                                    {index + 1}
                                                </div>
                                                <div className="p-4">
                                                    <div className="grid grid-cols-2 gap-3">
                                                        <div className="flex-row PaymentDashBoard gap-15 mt-2 p-2 w-full item-two-column" style={{ alignItems: 'start', flexDirection: 'row' }}>
                                                            <div className="flex flex-column item-left">
                                                                <div className="flex-column">
                                                                    <label
                                                                        htmlFor="section"
                                                                        className="form-labels font-weight500 font-size-subheading"
                                                                    >
                                                                        Tax Section{" "}
                                                                        <span className="required">

                                                                            {formData.regime === "" &&
                                                                                "(Select Tax regime First)"}
                                                                            *{" "}
                                                                        </span>
                                                                        {/* <span className="info-icon-wrapper">
                                                                    <InfoIcon />
                                                                    <span className="tooltip-text">Please select a Tax regime first.</span>
                                                                </span> */}
                                                                    </label>
                                                                    {buffer2 ? (
                                                                        <div className="form-loader">
                                                                            <div className="bar-loader"></div>
                                                                        </div>
                                                                    ) : (
                                                                        <select
                                                                            name="section"
                                                                            id="section"
                                                                            value={item.section}
                                                                            style={{ cursor: formData.regime === "" ? 'not-allowed' : 'defaut' }}
                                                                            onChange={(e) => handleItemChange(index, e)}
                                                                            className={`form-input ${errors.section
                                                                                ? "error"
                                                                                : inputState.section
                                                                                    ? "success"
                                                                                    : ""
                                                                                }`}
                                                                            disabled={formData.regime === ""}
                                                                        >
                                                                            <option value="">Select Section</option>
                                                                            {/*  {taxSectionData.map((i) => (
                                                                        <option value={i.id} key={i.id}>{i.code}({i.type_details.type} under {i.type_details.name})</option>
                                                                    ))} */}
                                                                            {(() => {
                                                                                const selectedSections = formData.items
                                                                                    .filter((_, i) => i !== index)
                                                                                    .map((i) => i.section);

                                                                                const unusedTaxSections =
                                                                                    taxSectionData.filter(
                                                                                        (s) =>
                                                                                            !selectedSections.includes(
                                                                                                String(s.id)
                                                                                            )
                                                                                    );

                                                                                return unusedTaxSections.map((i) => (
                                                                                    <option value={i.id} key={i.id}>
                                                                                        {i.code} ({i.type_details.type} under{" "}
                                                                                        {i.type_details.name})
                                                                                    </option>
                                                                                ));
                                                                            })()}
                                                                        </select>
                                                                    )}

                                                                    {errors.items?.[index]?.section && (
                                                                        <span className="error-message">
                                                                            {errors.items[index].section}
                                                                        </span>
                                                                    )}

                                                                </div>
                                                                {!showProofFields && (
                                                                    <div className="flex-column mt-2">
                                                                        <label
                                                                            htmlFor="declared_amount"
                                                                            className="form-labels font-weight500 font-size-subheading"
                                                                        >
                                                                            Declare Amount
                                                                            <span className="required">*</span>
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            placeholder="Declare Amount"
                                                                            name="declared_amount"
                                                                            id="declared_amount"
                                                                            min={0}
                                                                            // style={{ width: "auto" }}
                                                                            onWheel={(e) => e.target.blur()}
                                                                            value={item.declared_amount}
                                                                            // value={showProofFields ? formData.proof_amt : item.declared_amount}

                                                                            onChange={(e) => handleItemChange(index, e)}
                                                                            // onChange={!showProofFields ? (e) => handleItemChange(index, e) : undefined}

                                                                            className={`form-input ${errors.declared_amount
                                                                                ? "error"
                                                                                : inputState.declared_amount
                                                                                    ? "success"
                                                                                    : ""
                                                                                }`}
                                                                            required
                                                                        />

                                                                        {errors.items?.[index]?.declared_amount && (
                                                                            <span className="error-message">
                                                                                {errors.items[index].declared_amount}
                                                                            </span>
                                                                        )}

                                                                    </div>
                                                                )}

                                                                {showProofFields && (
                                                                    <div className="form-flex-wrap w-full">
                                                                        <div className="flex-column">
                                                                            <label className="form-labels font-weight500 font-size-subheading">
                                                                                Total Declared/Proof Amount <span className="required">(Auto)*</span>
                                                                            </label>
                                                                            <input
                                                                                type="number"
                                                                                name="total_proof_amount"
                                                                                // value={formData.proof_amt || 0}
                                                                                value={item.proof_amount || 0}

                                                                                disabled
                                                                                className="form-input"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="flex flex-column item-right h-full">
                                                                <label
                                                                    htmlFor="declaration_remarks"
                                                                    className="form-labels font-weight500 font-size-subheading"
                                                                >
                                                                    Remarks<span className="required">*</span>
                                                                </label>
                                                                <textarea
                                                                    name="declaration_remarks"
                                                                    value={item.declaration_remarks}
                                                                    onChange={(e) => handleItemChange(index, e)}
                                                                    className="form-input flex-1"
                                                                    style={{
                                                                        minHeight: '133px',
                                                                        padding: '13px 10px'
                                                                    }}
                                                                    // rows="6"
                                                                    placeholder="Enter Remark"
                                                                ></textarea>
                                                                {errors.items?.[index]?.declaration_remarks && (
                                                                    <span className="error-message">
                                                                        {errors.items[index].declaration_remarks}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div
                                                        className="flex-row justify-end"
                                                        style={{
                                                            position: "absolute",
                                                            top: "-14px",
                                                            right: "-9px",
                                                        }}
                                                    >
                                                        <button
                                                            type="button"
                                                            title="Remove"
                                                            className="align-center justify-center"
                                                            style={{
                                                                backgroundColor: "white",
                                                                paddingLeft: "0px",
                                                            }}
                                                            onClick={() => removeItem(index)}
                                                        >
                                                            <CrosswithRedCircle />
                                                        </button>
                                                    </div>



                                                    {showProofFields && (
                                                        <div className="item-box p-2 relative">
                                                            <div className="grid grid-cols-2 gap-3">



                                                                <div className="jd-heading-outer-flex w-full">
                                                                    <h2 className="jd-heading-main font-weight600 font-size-heading">
                                                                        Upload Proof Documents
                                                                    </h2>


                                                                </div>


                                                                {formData.items[index].proofs?.map((proof, pIndex) => (

                                                                    <div
                                                                        key={pIndex}
                                                                        className="PaymentDashBoard gap-15 flex-column mb-3 border p-2 rounded relative"
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                padding: '0px 5px',
                                                                                position: "absolute",
                                                                                top: "-17px",
                                                                                left: "50%",
                                                                                transform: "translateX(-50%)",
                                                                                fontWeight: "600",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                margin: '4px',
                                                                                backgroundColor: 'white'

                                                                            }}
                                                                        >
                                                                            <span> Document - </span>
                                                                            <span style={{ marginLeft: '3px' }}>{pIndex + 1}</span>

                                                                        </div>

                                                                        <div className="form-flex-wrap" style={{ padding: '20px', gap: '0px' }}>

                                                                            <div className="form-flex-wrap w-full" style={{ gap: '3px' }}>


                                                                                {!proof.document_url && (

                                                                                    <div className="flex-column">

                                                                                        <label className="form-labels font-weight500 font-size-subheading">Document<span className="required">*</span></label>

                                                                                        <div className={`flex-row justify-between form-input w-full"
                                                                                            ${errors[`proofs[${pIndex}][document]`]
                                                                                                ? "error"
                                                                                                : inputState?.[
                                                                                                    `proofs[${pIndex}][document]`
                                                                                                ]
                                                                                                    ? "success"
                                                                                                    : ""
                                                                                            }
                                                                                                `}
                                                                                            style={{ width: '32vw' }}
                                                                                        >
                                                                                            <label
                                                                                                htmlFor={`proof-file-${index}-${pIndex}`}
                                                                                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                                                                            >
                                                                                                <CloudUpload />
                                                                                                <span className="truncate-url" style={{ marginLeft: "10px" }}>
                                                                                                    {proof.document?.name || "No file selected"}
                                                                                                </span>
                                                                                            </label>

                                                                                            <input
                                                                                                type="file"
                                                                                                // id={`proof-file-${pIndex}`}
                                                                                                id={`proof-file-${index}-${pIndex}`}

                                                                                                name="document"
                                                                                                accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpeg,.jpg"
                                                                                                onChange={(e) => handleProofFieldChange(e, index, pIndex)}
                                                                                                // className="form-input"
                                                                                                style={{ display: "none" }}
                                                                                            />

                                                                                            {proof.document && (
                                                                                                <span
                                                                                                    className="file-clear"
                                                                                                    // onClick={() => handleClearFile(pIndex)}
                                                                                                    onClick={() => handleClearFile(index, pIndex)}

                                                                                                >
                                                                                                    Clear
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                        {errors.items?.[index]?.proofs?.[pIndex]?.document && (
                                                                                            <span className="error-message">
                                                                                                {errors.items[index].proofs[pIndex].document}
                                                                                            </span>
                                                                                        )}

                                                                                    </div>

                                                                                )}

                                                                                {/* {!proof.document && !proof.document_url && (
                                                                                    // <div className="align-center ps-0 justify-center">
                                                                                    //     <span style={{ width: '0.5px' }} >OR</span>
                                                                                    // </div>
                                                                                    <div className="w-full md:w-auto flex justify-center items-center">
                                                                                        <span>OR</span>
                                                                                    </div>

                                                                                )} */}


                                                                                {!proof.document && (

                                                                                    <div className="flex-column">

                                                                                        <label className="form-labels font-weight500 font-size-subheading">Document URL<span className="required">*</span></label>
                                                                                        <input
                                                                                            type="url"
                                                                                            name="document_url"
                                                                                            value={proof.document_url || ""}
                                                                                            className="form-input"
                                                                                            style={{ width: '32vw' }}
                                                                                            placeholder="Enter document URL"
                                                                                            // onChange={(e) => handleProofFieldChange(e, pIndex)}
                                                                                            onChange={(e) => handleProofFieldChange(e, index, pIndex)}

                                                                                        />
                                                                                        {/* {errors.items?.[index]?.proofs?.[pIndex]?.document_url && (
                                                                                        <span className="error-message">
                                                                                            {errors.items[index].proofs[pIndex].document_url}
                                                                                        </span>
                                                                                    )} */}

                                                                                    </div>
                                                                                )}
                                                                            </div>



                                                                            <div className="flex-column" >
                                                                                <label className="form-labels font-weight500 font-size-subheading">
                                                                                    Amount<span className="required">*</span>
                                                                                </label>
                                                                                <input
                                                                                    type="number"
                                                                                    name="proof_amt"
                                                                                    value={proof.proof_amt || ""}
                                                                                    min={0}
                                                                                    step={0.01}
                                                                                    style={{ width: '32vw' }}
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                    className="form-input"
                                                                                    placeholder="Enter amount"
                                                                                    // onChange={(e) => handleProofFieldChange(e, pIndex)}
                                                                                    onChange={(e) => handleProofFieldChange(e, index, pIndex)}

                                                                                />
                                                                                {errors.items?.[index]?.proofs?.[pIndex]?.proof_amt && (
                                                                                    <span className="error-message">
                                                                                        {errors.items[index].proofs[pIndex].proof_amt}
                                                                                    </span>
                                                                                )}

                                                                            </div>


                                                                            <div className="flex-column" >
                                                                                <label className="form-labels font-weight500 font-size-subheading">Remarks<span className="required">*</span> </label>
                                                                                <textarea
                                                                                    name="remarks"
                                                                                    value={proof.remarks || ""}
                                                                                    style={{ padding: '13px 10px', width: '32vw' }}
                                                                                    className="form-input"
                                                                                    placeholder="Enter remarks"

                                                                                    // onChange={(e) => handleProofFieldChange(e, pIndex)}
                                                                                    onChange={(e) => handleProofFieldChange(e, index, pIndex)}

                                                                                ></textarea>
                                                                                {errors.items?.[index]?.proofs?.[pIndex]?.remarks && (
                                                                                    <span className="error-message">
                                                                                        {errors.items[index].proofs[pIndex].remarks}
                                                                                    </span>
                                                                                )}

                                                                            </div>
                                                                        </div>

                                                                        <button
                                                                            className="remove-btn"
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: "white",
                                                                                marginTop: "10px",
                                                                                position: "absolute",
                                                                                top: "-27px",
                                                                                right: "-12px",
                                                                            }}
                                                                            // onClick={() => handleRemoveProof(pIndex)}
                                                                            onClick={() => handleRemoveProof(index, pIndex)}

                                                                            title="Remove"
                                                                        >
                                                                            <CrosswithRedCircle />
                                                                        </button>

                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {showProofFields && (
                                                        <div className="flex-row">
                                                            <hr className="line" />
                                                            <button type='button' title="Add Proofs" className="flex-row jd-heading-main font-weight600 gap-2" onClick={() => handleAddProof(index)}>
                                                                <AddwithBlueCircle /> <span className="w-max-content">Add Proofs</span>
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>


                                            </div>

                                        </>
                                    ))}
                                    <div className="flex-row">

                                        <hr className="line" />
                                        <button type='button' title="Add Section" className="flex-row jd-heading-main font-weight600 gap-2" onClick={addItem}>
                                            <AddwithBlueCircle /> <span className="w-max-content">Add Items</span>
                                        </button>
                                    </div>

                                </div>


                                <div className={showTdsResult ? "flex-row gap-2 w-full" : "w-full button-models"}>
                                    <button
                                        type="submit"
                                        style={{ width: '160px' }}
                                        className="model-button model-button-leave font-weight500 font-size-heading"
                                        disabled={loadingTDs}
                                        onClick={handleTdsCalculation}
                                    >
                                        {loadingTDs ? "Calculating... " : "Calculate TDS"}
                                    </button>
                                    {buffer ? <div className="spinner-small"></div> :
                                        showTdsResult && (
                                            <div className="calculation-row total w-full align-center">
                                                {/* <div className="color-card color-card-danger color-bg-danger-light w-full align-center"> */}
                                                <div>
                                                    <span>TDS amount:</span>
                                                    <span className="amount ms-2">{TdsCalcList?.monthly_tds_12_declared}</span>
                                                </div>
                                                <TdsCalculationModal employee={TdsCalcList} />
                                            </div>
                                        )}
                                </div>


                            </div>

                            {!currentFormExists && <div className="button-models">
                                <button
                                    type="button"
                                    className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>


                                <button
                                    type="submit"
                                    className="model-button model-button-leave font-weight500 font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Submit
                                </button>
                            </div>}
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && (
                                (() => {
                                    const hasTopLevelErrors = Object.keys(errors).some(
                                        (key) => key !== "items"
                                    );

                                    const hasProofError = errors.items?.some(
                                        (item) =>
                                            item?.proofsRequired ||
                                            item?.proofs?.some(
                                                (proof) =>
                                                    proof?.document ||
                                                    proof?.proof_amt ||
                                                    proof?.remarks
                                            )
                                    );

                                    const hasOtherItemErrors = errors.items?.some(
                                        (item) =>
                                            item &&
                                            (
                                                item.section ||
                                                item.declared_amount ||
                                                item.declaration_remarks
                                            )
                                    );


                                    if (hasProofError && !hasTopLevelErrors && !hasOtherItemErrors) {
                                        return (
                                            <h5 className="text-center">
                                                Proof document is required.
                                            </h5>
                                        );
                                    }


                                    if (hasTopLevelErrors || hasOtherItemErrors || hasProofError) {
                                        return (
                                            <h5 className="text-center">
                                                Please fill all mandatory fields!
                                            </h5>
                                        );
                                    }

                                    return null;
                                })()
                            )}
                        </p>
                        {/* <p className="error-message font-size-text">
                            {isSubmitted && (() => {
                                const errorCount = countErrors(errors);
                                const validProofExists = hasValidProof(errors);

                                const proofOnlyError =
                                    errors.items?.some(item => item?.proofsRequired) &&
                                    !validProofExists;


                                if (proofOnlyError && errorCount <= 5) {
                                    return (
                                        <h5 className="text-center">
                                            Proof document is required.
                                        </h5>
                                    );
                                }


                                if (errorCount > 0 && errorCount <= 5) {
                                    return (
                                        <h6 className="text-center">
                                            {Object.keys(errors)
                                                .map((field) =>
                                                    field
                                                        .replace(/_/g, ' ')
                                                        .replace(/\b\w/g, (char) => char.toUpperCase())
                                                )
                                                .join(', ') + ' are required!'}
                                        </h6>
                                    );
                                }


                                if (errorCount > 5) {
                                    return (
                                        <h5 className="text-center">
                                            Please fill all mandatory fields!
                                        </h5>
                                    );
                                }

                                return null;
                            })()}
                        </p> */}



                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal >
        </>
    );
};




// --------------------------------------------incomplete
const UpdateEmpInvestmentForm1 = ({ i, userData, SUB_COMPANIES, SUPER_ADMIN, PERMISSION_HR_ADMIN, getInvestmentForm }) => {

    const [proofData, setProofData] = useState([]);
    const [show, setShow] = useState(false);
    const [isProofEditable, setIsProofEditable] = useState(false);
    const [taxRegimeData, setTaxRegimeData] = useState([]);
    const [TdsCalcList, setTdsCalcList] = useState({});
    const [loadingTDs, setloadingTDs] = useState(false);
    const [buffer, setBuffering] = useState(false);
    const [showTdsResult, setShowTdsResult] = useState(false);


    const handleShow = async () => {
        getTaxRegimeList();
        getAllEmp_code();

        setFormData(i);
        setShow(true);

        let empDetails = empData;

        if (i.emp_code) {
            empDetails = await getUSerDetails(i.emp_code);
        }

    };

    const handleClose = () => {
        setShow(false);
        setFormData(initialData);
        setShowTdsResult(false)
        setErrors({});
    }

    const [taxSectionData, setTaxSectionData] = useState([]);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);
    const [buffer3, setBuffering3] = useState(true);
    const [loading, setLoading] = useState(false);
    const [proofs, setProofs] = useState([]);
    const [showProofFields, setShowProofFields] = useState(false);
    const [empList, setEmpList] = useState([]);



    const initialData = {
        emp_code: PERMISSION_HR_ADMIN ? "" : sessionStorage.getItem("emp_code"),
        regime: "",
        declaration_status: "draft",
        prev_company_salary: '',
        prev_company_tax: '',
        prev_company_salary_doc: '',
        prev_company_tax_doc: '',
        items: [
            {
                section: "",
                declared_amount: "",
                declaration_remarks: "",
                declaration_status: "draft",
                final_amount: "",
                calculation_amount: "",
                proof_remarks: "",
                proof_status: "draft",
                proof_amount: "", //declared_amount //total_proof_amount
                created_by: sessionStorage.getItem("emp_code"),
                updated_by: sessionStorage.getItem("emp_code"),
                proofs: [
                    {
                        document: "",
                        document_url: "",
                        proof_amt: "",
                        status: 'pending',
                        remarks: "",
                        // final_amount: "",

                    }
                ]
            }
        ],

        sub_company: sessionStorage.getItem("company_id"),
        created_by: sessionStorage.getItem("emp_code"),
        updated_by: sessionStorage.getItem("emp_code"),
        submitted_at: null,
    };
    const [formData, setFormData] = useState(initialData);
    const [empData, setEmpData] = useState({});
    const [showPreviousCompanyFields, setShowPreviousCompanyFields] = useState(false);
    const [buffer4, setBuffering4] = useState(true);
    const getUSerDetails = async (empcode) => {
        setBuffering4(true); // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemp/${empcode}/`);
            setEmpData(res.data);

        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering4(false);// End Buffering
        }
    };

    const getTaxRegimeList = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-regieme-by-subcompany/${formData.sub_company}/`);
            const allRegimes = res.data;

            // const { start, end } = getCurrentFinancialYear();

            // const filtered = allRegimes.filter((regime) =>
            //     regime.financial_year_start === start && regime.financial_year_end === end
            // );
            const today = new Date();
            const currentRegimes = allRegimes.filter((regime) => {
                const startDate = new Date(regime.financial_year_start);
                const endDate = new Date(regime.financial_year_end);

                return startDate <= today && today <= endDate;
            });


            setTaxRegimeData(currentRegimes);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };


    const getTaxSectionList = async (regimeId) => {
        setBuffering2(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/tax-sections-by-subcompany-tax-regime/${formData.sub_company}/${regimeId}/`);
            setTaxSectionData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering2(false);
        }
    };

    const getAllEmp_code = async () => {
        setBuffering3(true); // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${formData.sub_company}/`
            );

            const sortedList = customSortByKey(res.data, "emp_code");

            setEmpList(sortedList);
        } catch (err) {
        } finally {
            setBuffering3(false); // End Buffering
        }
    };

    useEffect(() => {
        if (i.emp_code) {
            getUSerDetails(i.emp_code)
        }
    }, [i.emp_code])



    useEffect(() => {
        setProofData(i)
        checkEditPermissions();
    }, [i]);


    const handlePrevDocClearFile = (type) => {
        if (type === "salary") {
            setFormData(prev => ({
                ...prev,
                prev_company_salary_doc: null
            }));
        }

        if (type === "tax") {
            setFormData(prev => ({
                ...prev,
                prev_company_tax_doc: null
            }));
        }
    };

    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const isHR = SUPER_ADMIN || PERMISSION_HR_ADMIN;


    const validateForm = () => {
        const newErrors = {};
        const fieldLabels = {
            regime: "Regime",
            emp_code: "Employee Code",
            prev_company_salary: "Previous Company Salary",
            prev_company_tax: "Previous Company Tax",
            prev_company_salary_doc: "Previous Company Salary Document",
            prev_company_tax_doc: "Previous Company Tax Document",
        };
        const requiredFields = [
            "regime",
            "emp_code",
            ...(showPreviousCompanyFields
                ? [
                    "prev_company_salary",
                    "prev_company_tax",
                    "prev_company_salary_doc",
                    ...(Number(formData.prev_company_tax) > 0
                        ? ["prev_company_tax_doc"]
                        : []),
                ]
                : []),
        ].filter(Boolean);

        // requiredFields.forEach((field) => {
        //     if (!formData[field] || formData[field]?.trim() === "") {
        //         newErrors[field] =
        //             `${field.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())} is required!`;
        //     }
        // });
        requiredFields.forEach((field) => {
            const value = formData[field];

            if (
                value === undefined ||
                value === null ||
                (typeof value === "string" && value.trim() === "") ||
                (Array.isArray(value) && value.length === 0)
            ) {
                // newErrors[field] =
                //   `${field.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())} is required!`;
                newErrors[field] =
                    `${fieldLabels[field] || field.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())} is required!`;
            }
        });

        newErrors.items = [];

        formData.items.forEach((item, index) => {
            const itemErrors = {};

            if (!item.section) {
                itemErrors.section = "Section is required!";
            }

            if (!showProofFields && !item.declared_amount) {
                itemErrors.declared_amount = "Declared amount is required!";
            }

            if (!item.declaration_remarks) {
                itemErrors.declaration_remarks = "Remarks are required!";
            }

            if (showProofFields) {
                const proofArrErrors = [];
                let hasAtLeastOneValidProof = false;

                item.proofs.forEach((proof, pIndex) => {
                    const proofErrors = {};

                    const hasDocument = proof.document || proof.document_url;
                    const hasAmount = proof.proof_amt;
                    const hasRemarks = proof.remarks;

                    if (hasDocument && hasAmount && hasRemarks) {
                        hasAtLeastOneValidProof = true;
                    }

                    if (!hasDocument) {
                        proofErrors.document = "Document or URL is required!";
                    }

                    if (!hasAmount) {
                        proofErrors.proof_amt = "Amount is required!";
                    }

                    if (!hasRemarks) {
                        proofErrors.remarks = "Remarks are required!";
                    }

                    if (Object.keys(proofErrors).length > 0) {
                        proofArrErrors[pIndex] = proofErrors;
                    }
                });

                if (!hasAtLeastOneValidProof) {
                    itemErrors.proofsRequired = "Proof document is required.";
                }

                if (proofArrErrors.length > 0) {
                    itemErrors.proofs = proofArrErrors;
                }
            }

            if (Object.keys(itemErrors).length > 0) {
                newErrors.items[index] = itemErrors;
            }
        });

        if (newErrors.items.length === 0) {
            delete newErrors.items;
        }
        setErrors(newErrors);
        setIsSubmitted(true);

        const hasErrors = Object.keys(newErrors).length > 0;
        return !hasErrors;
    };

    const checkEditPermissions = () => {
        const month = new Date().getMonth() + 1;

        // April–Dec
        // if (month >= 4 && month <= 12) {
        //     setIsDeclarationEditable(true);
        //     setIsProofEditable(false);
        // }

        // Jan–Mar
        if (month >= 9 && month <= 11) {
            // setIsDeclarationEditable(false);
            setIsProofEditable(true);
        }
    };

    const handleInputChange = async (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        const numberFields = ["prev_company_salary", "prev_company_tax"];

        let updatedValue = value;

        if (numberFields.includes(name)) {
            updatedValue = value === "" ? null : Number(value);
        }

        setFormData((prev) => ({
            ...prev,
            [name]: updatedValue,
        }));

        if (name === "regime" && value) {
            await getTaxSectionList(value);

            const selectedRegime = taxRegimeData.find((item) => item.id === value);

            if (selectedRegime) {
                const today = new Date();
                const start = new Date(selectedRegime.proof_submission_start_date);
                const end = new Date(selectedRegime.proof_submission_end_date);

                const isProofWindowOpen = today >= start && today <= end;
                setShowProofFields(isProofWindowOpen);

                //Joining date
                if (empData?.joining_date) {
                    const joiningDate = new Date(empData.joining_date);
                    const fyStart = new Date(selectedRegime.financial_year_start);

                    const isJoiningWithinFY = joiningDate >= fyStart;

                    setShowPreviousCompanyFields(isJoiningWithinFY);
                } else {
                    setShowPreviousCompanyFields(false);
                }
            }
            setFormData((prev) => ({
                ...prev,
                regime: value,
                items: JSON.parse(JSON.stringify(initialData.items)),
            }));

            setTdsCalcList(null);
            setShowTdsResult(false);

            setErrors({});
            return;
        }

        if (name === "prev_company_tax") {
            if (Number(updatedValue) <= 0) {
                setErrors((prev) => {
                    const newErr = { ...prev };
                    delete newErr.prev_company_tax_doc;
                    return newErr;
                });
            }
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };



    const updateItemAmounts = () => {
        setFormData(prev => {
            const updatedItems = prev.items.map((item) => {


                const isAllProofsEmpty = !item.proofs || item.proofs.every(p =>
                    !p.proof_amt &&
                    !p.document &&
                    !p.document_url &&
                    !p.remarks
                    // !p.final_amount
                );


                const finalProofArray = isAllProofsEmpty ? [] : item.proofs;


                const totalProof = finalProofArray.reduce(
                    (sum, p) => sum + Number(p.proof_amt || 0),
                    0
                );


                if (!showProofFields) {
                    return {
                        ...item,
                        final_amount: item.declared_amount || 0,
                        proof_amount: item.declared_amount || 0,
                        calculation_amount: item.declared_amount || 0,
                        proofs: []
                    };
                }


                return {
                    ...item,
                    // declared_amount: totalProof,
                    final_amount: totalProof,
                    proof_amount: totalProof,
                    calculation_amount: totalProof,
                    proofs: finalProofArray,
                };



            });

            return { ...prev, items: updatedItems };
        });
    };


    const handleItemChange = (index, e) => {
        const { name, value } = e.target;
        const updatedItems = [...formData.items];

        if (value.trim()) {

            setErrors((prev) => {
                const updated = { ...prev };


                if (updated.items?.[index]) {


                    if (updated.items[index][name]) {
                        updated.items[index][name] = "";
                    }


                    if (updated.items[index].proofs) {
                        updated.items[index].proofs = updated.items[index].proofs.map((proofErr) =>
                            Object.fromEntries(Object.entries(proofErr).filter(([_, v]) => v))
                        );


                        updated.items[index].proofs = updated.items[index].proofs.filter(
                            (obj) => Object.keys(obj).length > 0
                        );


                        if (updated.items[index].proofs.length === 0) {
                            delete updated.items[index].proofs;
                        }
                    }


                    if (Object.keys(updated.items[index]).length === 0) {
                        delete updated.items[index];
                    }


                    if (
                        updated.items &&
                        Object.keys(updated.items).every((key) => !updated.items[key] || Object.keys(updated.items[key]).length === 0)
                    ) {
                        delete updated.items;
                    }
                }

                return updated;
            });

        }


        const numericFields = ["declared_amount"];

        if (numericFields.includes(name)) {
            if (!isValidTwoDecimalNumber(value)) return;

            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => {
                    const updated = { ...prevErrors };
                    updated.items = updated.items || [];
                    updated.items[index] = updated.items[index] || {};
                    updated.items[index][name] = "Value cannot be negative";
                    return updated;
                });
                return;
            }

            const { success, error } = inputMinLimit(name, value, 0);
            if (!success) {
                setErrors((prevErrors) => {
                    const updated = { ...prevErrors };
                    updated.items = updated.items || [];
                    updated.items[index] = updated.items[index] || {};
                    updated.items[index][name] = error;
                    return updated;
                });
            }
        }


        updatedItems[index] = {
            ...updatedItems[index],
            [name]: value,
        };

        setFormData((prev) => {
            const newData = {
                ...prev,
                items: updatedItems,
            };

            return newData;
        });


        updateItemAmounts();


        setInputState((prev) => ({
            ...prev,
            [`item_${index}_${name}`]: value.trim() ? "green" : "",
        }));
    };

    const addItem = () => {
        const isProof = showProofFields;
        setFormData((prev) => ({
            ...prev,
            items: [
                ...prev.items,
                {
                    section: "",
                    declared_amount: isProof ? 0 : "",
                    // declared_amount: "",
                    declaration_remarks: "",
                    declaration_status: "draft",
                    // declaration_status: isProof ? "approved" : "pending",
                    proof_amount: "",
                    final_amount: "",
                    // proof_remarks: "",
                    calculation_amount: "",
                    proof_status: "draft",
                    created_by: userData?.emp_code || sessionStorage.getItem("emp_code"),
                    updated_by: userData?.emp_code || sessionStorage.getItem("emp_code"),
                    // proofs: [
                    proofs: isProof ? [] : [
                        {
                            document: "",
                            document_url: "",
                            proof_amt: "",
                            remarks: "",
                            status: "",
                            // final_amount: "",
                            // verified_by: sessionStorage.getItem("emp_code"),

                        }
                    ]
                }
            ],
        }));
    };

    const removeItem = (index) => {
        setFormData((prev) => ({
            ...prev,
            items: prev.items.filter((_, i) => i !== index),
        }));
    };

    const handleAddProof = (itemIndex) => {
        setFormData(prev => {
            const items = [...prev.items];
            const proofs = items[itemIndex].proofs || [];

            items[itemIndex].proofs = [
                ...proofs,
                {
                    document: "",
                    document_url: "",
                    proof_amt: "",
                    remarks: "",
                    status: "pending",
                }
            ];

            return { ...prev, items };
        });
    };

    const handleProofFieldChange = (e, itemIndex, proofIndex) => {
        const { name, value, files } = e.target;
        setErrors(prevErrors => {
            const updated = { ...prevErrors };

            if (updated.items?.[itemIndex]?.proofs?.[proofIndex]?.[name]) {
                updated.items[itemIndex].proofs[proofIndex][name] = "";
            }

            if (
                updated.items?.[itemIndex]?.proofs?.[proofIndex] &&
                Object.values(updated.items[itemIndex].proofs[proofIndex]).every(v => !v)
            ) {
                delete updated.items[itemIndex].proofs[proofIndex];
            }


            if (
                updated.items?.[itemIndex]?.proofs &&
                Object.values(updated.items[itemIndex].proofs).every(obj => !obj || Object.keys(obj).length === 0)
            ) {
                delete updated.items[itemIndex].proofs;
            }


            if (
                updated.items?.[itemIndex]?.proofs &&
                Array.isArray(updated.items[itemIndex].proofs) &&
                updated.items[itemIndex].proofs.length === 0
            ) {
                delete updated.items[itemIndex].proofs;
            }



            if (
                updated.items?.[itemIndex] &&
                Object.values(updated.items[itemIndex]).every(v => !v || (typeof v === "object" && Object.keys(v).length === 0))
            ) {
                delete updated.items[itemIndex];
            }


            if (
                updated.items &&
                Object.values(updated.items).every(itemObj => !itemObj || Object.keys(itemObj).length === 0)
            ) {
                delete updated.items;
            }

            return updated;
        });

        setFormData(prev => {
            const items = [...prev.items];
            const proofs = [...items[itemIndex].proofs];

            const proof = proofs[proofIndex];

            if (name === "document") {
                proof.document = files[0];
                proof.document_url = "";
            }
            else if (name === "document_url") {
                proof.document_url = value;
                proof.document = null;
            }
            else {
                proof[name] = value;
            }

            // proof.final_amount = Number(proof.proof_amt || 0);
            proofs[proofIndex] = proof;
            const total = proofs.reduce((sum, p) => sum + Number(p.proof_amt || 0), 0);
            // items[itemIndex].proofs = proofs;
            // items[itemIndex].proof_amount = total;
            // items[itemIndex].declared_amount = total;
            // items[itemIndex].final_amount = total;
            //-----------------changed
            items[itemIndex] = {
                ...items[itemIndex],
                proofs,
                proof_amount: total,
                // declared_amount: total,
                final_amount: total,
                calculation_amount: total,
            };
            //---------------changed



            return { ...prev, items };
        });

        setInputState(prev => ({
            ...prev,
            [`proof_${itemIndex}_${proofIndex}_${name}`]:
                (name === "document" && files?.length > 0) ||
                    (name !== "document" && value.trim())
                    ? "green"
                    : "",
        }));
    };

    const handleRemoveProof = (itemIndex, proofIndex) => {
        setFormData(prev => {
            const items = [...prev.items];
            const proofs = [...items[itemIndex].proofs];
            proofs.splice(proofIndex, 1);
            const total = proofs.reduce((sum, p) => sum + Number(p.proof_amt || 0), 0);
            items[itemIndex].proofs = proofs;

            //changed------------------------
            items[itemIndex].proof_amount = total;
            // items[itemIndex].declared_amount = total; //changed
            items[itemIndex].final_amount = total;
            items[itemIndex].calculation_amount = total;
            //chnaged-----------------------------


            return { ...prev, items };
        });
    };


    const handleClearFile = (itemIndex, proofIndex) => {
        setFormData(prev => {
            const items = [...prev.items];
            const proofs = [...items[itemIndex].proofs];

            proofs[proofIndex].document = null;
            proofs[proofIndex].document_url = "";

            items[itemIndex].proofs = proofs;

            return { ...prev, items };
        });

        const inputEl = document.querySelector(`#proof-file-${itemIndex}-${proofIndex}`);
        if (inputEl) inputEl.value = "";
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (validateForm()) {
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");
        const fd = new FormData();

        fd.append("emp_code", formData.emp_code);
        fd.append("regime", formData.regime);
        fd.append("declaration_status", formData.declaration_status);
        fd.append("sub_company", formData.sub_company);
        fd.append("updated_by", formData.updated_by);
        fd.append("submitted_at", formData.submitted_at);
        // if (!showProofFields) {
        //     fd.append("prev_company_salary", formData.prev_company_salary);
        //     fd.append("prev_company_tax", formData.prev_company_tax);
        //     fd.append("prev_company_salary_doc", formData.prev_company_salary_doc);
        //     fd.append("prev_company_tax_doc", formData.prev_company_tax_doc);
        // }
        if (!showProofFields) {
            fd.append("prev_company_salary", formData.prev_company_salary);
            fd.append("prev_company_tax", formData.prev_company_tax);

            // Previous salary document
            if (formData.prev_company_salary_doc instanceof File) {
                fd.append(
                    "prev_company_salary_doc",
                    formData.prev_company_salary_doc
                );
            } else if (formData.prev_company_salary_doc === null) {
                fd.append("prev_company_salary_doc", "");
            }

            // Previous tax document
            if (formData.prev_company_tax_doc instanceof File) {
                fd.append(
                    "prev_company_tax_doc",
                    formData.prev_company_tax_doc
                );
            } else if (formData.prev_company_tax_doc === null) {
                fd.append("prev_company_tax_doc", "");
            }
        }




        formData.items.forEach((item, i) => {
            fd.append(`items[${i}][section]`, item.section);
            fd.append(`items[${i}][declared_amount]`, item.declared_amount);
            fd.append(`items[${i}][declaration_status]`, item.declaration_status);
            fd.append(`items[${i}][declaration_remarks]`, item.declaration_remarks);
            fd.append(`items[${i}][final_amount]`, item.final_amount);
            fd.append(`items[${i}][calculation_amount]`, item.calculation_amount);
            fd.append(`items[${i}][proof_amount]`, item.proof_amount);
            fd.append(`items[${i}][proof_status]`, item.proof_status);
            fd.append(`items[${i}][updated_by]`, item.updated_by);

            if (showProofFields) {
                item.proofs.forEach((p, j) => {

                    if (p.document && typeof p.document === "object") {
                        fd.append(`items[${i}][proofs][${j}][document]`, p.document);
                    }

                    if (p.document_url) {
                        fd.append(`items[${i}][proofs][${j}][document_url]`, p.document_url);
                    }

                    fd.append(`items[${i}][proofs][${j}][proof_amt]`, p.proof_amt);
                    fd.append(`items[${i}][proofs][${j}][remarks]`, p.remarks);
                    fd.append(`items[${i}][proofs][${j}][approved_amt]`, p.proof_amt);
                    // fd.append(`items[${i}][proofs][${j}][final_amount]`, p.final_amount);
                    fd.append(`items[${i}][proofs][${j}][status]`, p.status);
                });
            }
        });

        try {
            let res = await axios.put(
                `${BASE_URL}/wfm/investmentform-update-withproofs/${i?.id}/`,
                fd,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (res.status === 200 || res.status === 201) {
                await getInvestmentForm();
                setShow(false);
                // setFormData(initialData);
                toast.success("Investment Form updated successfully!");
            } else {
                console.error("Something went wrong: " + res.statusText);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
        // }
    };


    useEffect(() => {
        if (formData.regime && taxRegimeData?.length > 0) {
            (async () => {
                await getTaxSectionList(formData.regime);

                const selectedRegime = taxRegimeData.find(
                    (item) => item.id === formData.regime
                );

                if (selectedRegime) {

                    const today = new Date();
                    const start = new Date(selectedRegime.proof_submission_start_date);
                    const end = new Date(selectedRegime.proof_submission_end_date);

                    setShowProofFields(today >= start && today <= end);


                    if (empData?.joining_date) {
                        const joiningDate = new Date(empData.joining_date);
                        const fyStart = new Date(selectedRegime.financial_year_start);

                        const isJoiningAfterFYStart = joiningDate >= fyStart;
                        setShowPreviousCompanyFields(isJoiningAfterFYStart);
                    } else {
                        setShowPreviousCompanyFields(false);
                    }
                }
            })();

        }
    }, [formData.regime, taxRegimeData, empData]);


    // const handleTdsCalculation = async (e) => {
    //     e.preventDefault();
    //     setloadingTDs(true);
    //     setBuffering(true);
    //     try {

    //         let res = await axios.post(
    //             `${BASE_URL}/wfm/tds-calculater-byempinput/${formData.emp_code}/${formData.regime || 'null'}/`,
    //             formData.items
    //         );
    //         if (res.status === 200 || res.status === 201) {
    //             setTdsCalcList(res.data);
    //             setShowTdsResult(true);
    //         } else {
    //             setShowTdsResult(false);
    //             console.error("Something went wrong at AddEmpInvestmentForm: " + res.statusText);
    //         }
    //     } catch (err) {
    //         handleErrorToast(err);
    //     } finally {
    //         setBuffering(false);
    //         setloadingTDs(false);
    //     }
    // };


    const handleTdsCalculation = async (e) => {
        e.preventDefault();
        setloadingTDs(true);
        setBuffering(true);
        try {

            let res = await axios.post(
                `${BASE_URL}/wfm/tds-calculater-byempinput/${formData.emp_code}/${formData.regime || 'null'}/`,
                formData.items
            );
            if (res.status === 200 || res.status === 201) {
                setTdsCalcList(res.data);
                setShowTdsResult(true);
            } else {
                setShowTdsResult(false);
                console.error("Something went wrong at AddEmpInvestmentForm: " + res.statusText);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
            setloadingTDs(false);
        }
    };



    return (
        <>
            <button
                title={i?.declaration_status === "submitted" || i?.declaration_status === "approved"
                    ? "Update with Proof Submission"
                    : "Update Investment Form"}

                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="five-sixth-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{i?.declaration_status === "submitted" || i?.declaration_status === "approved"
                        ? "Update with Proof Submission"
                        : "Update Investment Form"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showProofFields && (
                        <div className='padding_ color-tab-yellow text-warning-color-dark notice-badge' style={{ marginLeft: '20px', marginRight: '20px' }}>
                            Tax regime and section(If approved) can't be changed after the proof submission period starts, because your declared investments and sections are already linked to the selected regime.
                        </div>
                    )}
                    <div className="parent-div">
                        <div className="bdy-div">


                            {SUPER_ADMIN ?
                                <div className="flex-column">
                                    <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                        Sub Company<span className="required">*</span>
                                    </label>

                                    <select
                                        id="sub_company"
                                        name="sub_company"
                                        style={{ marginBottom: "8px" }}
                                        value={formData.sub_company}
                                        onChange={handleInputChange}
                                        className={`form-input  ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Company  </option>
                                        {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                    </select>

                                    <div className="mb-2">
                                        {errors.sub_company && (
                                            <span className="error-message font-size-text ">{errors.sub_company}</span>
                                        )}
                                    </div>
                                </div>
                                : null
                            }

                            <div className="form-flex-wrap">
                                {isHR && (
                                    <div className="flex-column ">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            To Employee<span className="required">*</span>
                                        </label>
                                        {buffer3 ? (
                                            <div className="form-loader">
                                                <div className="bar-loader"></div>
                                            </div>
                                        ) : (
                                            <select
                                                name="emp_code"
                                                value={formData.emp_code}
                                                onChange={handleInputChange}
                                                className={`form-input ${errors.emp_code
                                                    ? "error"
                                                    : inputState.emp_code
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select An Employee</option>
                                                {empList
                                                    .sort((a, b) => a.emp_code - b.emp_code)
                                                    .map((i, index) => (
                                                        <option value={i.emp_code}>
                                                            {i.name} - {i.emp_code}
                                                        </option>
                                                    ))}
                                            </select>
                                        )}
                                        {errors.emp_code && (
                                            <span className="error-message font-size-text ">
                                                {errors.emp_code}
                                            </span>
                                        )}
                                    </div>
                                )}

                                <div className="flex-column">
                                    <label htmlFor="regime" className="form-labels font-weight500 font-size-subheading">
                                        Tax Regime
                                        {!formData.sub_company && <span className="required">(Select Sub Company First)</span>}<span className="required">*</span>
                                        {/* <CustomTooltip
                                            position="right"
                                            tooltipContent={
                                                <div
                                                    style={{
                                                        minWidth: "15vw",
                                                        padding: "10px",
                                                        fontSize: "13px",

                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                    }}
                                                >
                                                    Tax regime can't be changed after the proof submission period starts, because your declared investments and sections are already linked to the selected regime.
                                                </div>
                                            }
                                        >
                                            <InfoIcon />
                                        </CustomTooltip> */}

                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            id="regime"
                                            name="regime"
                                            value={formData.regime}
                                            style={{ marginBottom: "8px", cursor: showProofFields ? 'not-allowed' : 'pointer' }}
                                            onChange={handleInputChange}
                                            disabled={showProofFields ? true : false}
                                            className={`form-input  ${errors.regime ? "error" : inputState.regime ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Tax regime</option>
                                            {taxRegimeData.map((i, index) => (
                                                <option key={index} value={i?.id}>
                                                    {/* {i?.name}({formatDate(i?.financial_year_start)} - {formatDate(i?.financial_year_end)}) */}
                                                    {i?.name} ({formatDate(i?.financial_year_start, true).MonthYear} to {formatDate(i?.financial_year_end, true).MonthYear})
                                                </option>
                                            ))}


                                        </select>
                                    )}

                                    <div className="mb-2">
                                        {errors.regime && (
                                            <span className="error-message font-size-text ">{errors.regime}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {showProofFields && (
                                <div className="form-flex-wrap rounded"
                                    style={{
                                        border: "1px solid #e0e0e0",
                                        padding: "16px",
                                        backgroundColor: "#fafafa",
                                        flexDirection: "column",
                                        marginBottom: '20px'
                                    }}
                                >
                                    {/* Row */}
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <span style={{ fontWeight: 600, color: "#333" }}>
                                            Previous Company Salary:
                                        </span>
                                        <span style={{ color: "#555" }}>
                                            ₹ {i?.prev_company_salary || "-"}
                                        </span>
                                    </div>

                                    {/* Salary Document */}
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <span style={{ fontWeight: 600, color: "#333" }}>
                                            Salary Document:
                                        </span>
                                        <span>
                                            {i.prev_company_salary_doc ? (
                                                <a
                                                    href={i.prev_company_salary_doc}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{
                                                        textDecoration: "none",
                                                        color: "#1976d2",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "6px"
                                                    }}
                                                >
                                                    <AttachmentIcon source={i.prev_company_salary_doc} />
                                                    View File
                                                </a>
                                            ) : (
                                                <span style={{ color: "#999" }}>No file attached</span>
                                            )}
                                        </span>
                                    </div>

                                    {/* Tax */}
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <span style={{ fontWeight: 600, color: "#333" }}>
                                            Previous Company Tax:
                                        </span>
                                        <span style={{ color: "#555" }}>
                                            ₹ {i?.prev_company_tax || "-"}
                                        </span>
                                    </div>

                                    {/* Tax Document */}
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <span style={{ fontWeight: 600, color: "#333" }}>
                                            Tax Document:
                                        </span>
                                        <span>
                                            {i.prev_company_tax_doc ? (
                                                <a
                                                    href={i.prev_company_tax_doc}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{
                                                        textDecoration: "none",
                                                        color: "#1976d2",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "6px"
                                                    }}
                                                >
                                                    <AttachmentIcon source={i.prev_company_tax_doc} />
                                                    View File
                                                </a>
                                            ) : (
                                                <span style={{ color: "#999" }}>No file attached</span>
                                            )}
                                        </span>
                                    </div>
                                </div>
                            )}



                            {!showProofFields && showPreviousCompanyFields && (
                                <div className="form-flex-wrap  mb-2">
                                    <div className="flex-column">
                                        <label
                                            htmlFor="prev_company_salary"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Previous Company Salary Amount
                                            <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            placeholder="Previous Company Salary Amount"
                                            name="prev_company_salary"
                                            id="prev_company_salary"
                                            min={0}
                                            onWheel={(e) => e.target.blur()}
                                            value={formData.prev_company_salary || ''}

                                            onChange={handleInputChange}
                                            className={`form-input ${errors.prev_company_salary
                                                ? "error"
                                                : inputState.prev_company_salary
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        />

                                        {errors.prev_company_salary && (
                                            <span className="error-message">
                                                {errors.prev_company_salary}
                                            </span>
                                        )}

                                    </div>


                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">Previous Company Salary Document<span className="required">*</span></label>

                                        <div className={`flex-row justify-between form-input w-full"
                                        ${errors.prev_company_salary_doc
                                                ? "error"
                                                : inputState.prev_company_salary_doc
                                                    ? "success"
                                                    : ""
                                            }
                                                                                                `}

                                        >
                                            <label
                                                htmlFor='prev_company_salary_doc'
                                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                            >
                                                <CloudUpload />
                                                <span className="truncate-url" style={{ marginLeft: "10px", width: '20vw' }}>
                                                    {typeof formData.prev_company_salary_doc === "string"
                                                        ? formData.prev_company_salary_doc
                                                        : formData.prev_company_salary_doc?.name || "No file selected"}

                                                </span>
                                            </label>

                                            <input
                                                type="file"
                                                id='prev_company_salary_doc'
                                                name="prev_company_salary_doc"
                                                accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpeg,.jpg"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        prev_company_salary_doc: file
                                                    }));
                                                    if (file) {
                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            prev_company_salary_doc: "",
                                                        }));
                                                    }
                                                }}

                                                style={{ display: "none" }}
                                            />

                                            {formData.prev_company_salary_doc && (
                                                <span
                                                    className="file-clear"
                                                    onClick={() => handlePrevDocClearFile("salary")}


                                                >
                                                    Clear
                                                </span>
                                            )}
                                        </div>
                                        {errors?.prev_company_salary_doc && (
                                            <span className="error-message">
                                                {errors?.prev_company_salary_doc}
                                            </span>
                                        )}

                                    </div>
                                    <div className="flex-column">
                                        <label
                                            htmlFor="prev_company_tax"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Previous Company Tax
                                            <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            placeholder="Previous Company Tax"
                                            name="prev_company_tax"
                                            id="prev_company_tax"
                                            min={0}
                                            // style={{ width: "auto" }}
                                            onWheel={(e) => e.target.blur()}
                                            value={formData.prev_company_tax}

                                            onChange={handleInputChange}

                                            className={`form-input ${errors.prev_company_tax
                                                ? "error"
                                                : inputState.prev_company_tax
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        />

                                        {errors.prev_company_tax && (
                                            <span className="error-message">
                                                {errors.prev_company_tax}
                                            </span>
                                        )}

                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">Previous Company Tax Document
                                            {Number(formData.prev_company_tax) > 0 && (
                                                <span className="required">*</span>
                                            )}
                                        </label>

                                        <div className={`flex-row justify-between form-input w-full"
                                       ${errors.prev_company_tax_doc
                                                ? "error"
                                                : inputState.prev_company_tax_doc
                                                    ? "success"
                                                    : ""
                                            }
                                                                                                `}

                                        >
                                            <label
                                                htmlFor='prev_company_tax_doc'
                                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                            >
                                                <CloudUpload />
                                                <span className="truncate-url" style={{ marginLeft: "10px", width: '20vw' }}>
                                                    {typeof formData.prev_company_tax_doc === "string"
                                                        ? formData.prev_company_tax_doc
                                                        : formData.prev_company_tax_doc?.name || "No file selected"}

                                                </span>
                                            </label>

                                            <input
                                                type="file"
                                                id='prev_company_tax_doc'
                                                name="prev_company_tax_doc"
                                                accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpeg,.jpg"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        prev_company_tax_doc: file
                                                    }));
                                                    if (file) {
                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            prev_company_tax_doc: "",
                                                        }));
                                                    }
                                                }}

                                                style={{ display: "none" }}
                                            />

                                            {formData.prev_company_tax_doc && (
                                                <span
                                                    className="file-clear"
                                                    onClick={() => handlePrevDocClearFile("tax")}


                                                >
                                                    Clear
                                                </span>
                                            )}
                                        </div>
                                        {errors?.prev_company_tax_doc && (
                                            <span className="error-message">
                                                {errors?.prev_company_tax_doc}
                                            </span>
                                        )}

                                    </div>
                                </div>
                            )}

                            <div className="form-flex-wrap">


                                <div className="items-section">
                                    {/* <h4 className="font-size-heading font-weight600 mb-2">Items</h4> */}

                                    {formData.items.map((item, index) => (
                                        <>
                                            <div
                                                key={index}
                                                className="item-box rounded relative"
                                                style={{
                                                    border: "1px solid #dfdfdf",
                                                    marginBottom: '23px'
                                                }}
                                            >

                                                <div
                                                    style={{

                                                        position: "absolute",
                                                        top: "-15px",
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                        background: "white",
                                                        padding: "0px 1px",
                                                        borderRadius: "50%",
                                                        fontWeight: "600",
                                                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.15)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        minWidth: "32px",
                                                        minHeight: "32px",

                                                    }}
                                                >
                                                    {index + 1}
                                                </div>
                                                <div className="p-4">
                                                    <div className="grid grid-cols-2 gap-3">
                                                        <div className="flex-row PaymentDashBoard gap-15 mt-2 p-2 w-full item-two-column" style={{ alignItems: 'start', flexDirection: 'row' }}>
                                                            <div className="flex flex-column item-left">
                                                                <div className="flex-column">
                                                                    <label
                                                                        htmlFor="section"
                                                                        className="form-labels font-weight500 font-size-subheading"
                                                                    >
                                                                        Tax Section{" "}
                                                                        <span className="required">
                                                                            {formData.regime === "" && "(Select Tax regime First)"}*{" "}
                                                                        </span>
                                                                        {/* <span className="info-icon-wrapper">
                                                                    <InfoIcon />
                                                                    <span className="tooltip-text">Please select a Tax regime first.</span>
                                                                </span> */}
                                                                    </label>
                                                                    {buffer2 ? (
                                                                        <div className="form-loader">
                                                                            <div className="bar-loader"></div>
                                                                        </div>
                                                                    ) : (
                                                                        <select
                                                                            name="section"
                                                                            id="section"
                                                                            value={item.section}
                                                                            style={{ cursor: item.declaration_status === 'approved' ? 'not-allowed' : 'pointer' }}
                                                                            disabled={item.declaration_status === 'approved' ? true : false}
                                                                            onChange={(e) => handleItemChange(index, e)}
                                                                            className={`form-input ${errors.section
                                                                                ? "error"
                                                                                : inputState.section
                                                                                    ? "success"
                                                                                    : ""
                                                                                }`}
                                                                        >
                                                                            <option value="">Select Section</option>
                                                                            {/*  {taxSectionData.map((i) => (
                                                                        <option value={i.id} key={i.id}>{i.code}({i.type_details.type} under {i.type_details.name})</option>
                                                                    ))} */}
                                                                            {(() => {
                                                                                const selectedSections = formData.items
                                                                                    .filter((_, i) => i !== index)
                                                                                    .map((i) => i.section);

                                                                                const unusedTaxSections =
                                                                                    taxSectionData.filter(
                                                                                        (s) =>
                                                                                            !selectedSections.includes(
                                                                                                String(s.id)
                                                                                            )
                                                                                    );

                                                                                return unusedTaxSections.map((i) => (
                                                                                    <>{
                                                                                        formData.regime === ""
                                                                                            ?
                                                                                            '' :
                                                                                            <option value={i.id} key={i.id}>
                                                                                                {i.code} ({i.type_details.type} under{" "}
                                                                                                {i.type_details.name})
                                                                                            </option>
                                                                                    }
                                                                                    </>
                                                                                ));
                                                                            })()}
                                                                        </select>
                                                                    )}

                                                                    {errors.items?.[index]?.section && (
                                                                        <span className="error-message">
                                                                            {errors.items[index].section}
                                                                        </span>
                                                                    )}

                                                                </div>
                                                                {/* {showProofFields && ( */}
                                                                <div className="flex-column mt-2">
                                                                    <label
                                                                        htmlFor="declared_amount"
                                                                        className="form-labels font-weight500 font-size-subheading"
                                                                    >
                                                                        Declare Amount
                                                                        <span className="required">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="number"
                                                                        placeholder="Declare Amount"
                                                                        name="declared_amount"
                                                                        id="declared_amount"
                                                                        min={0}
                                                                        style={{ cursor: item.declaration_status === 'approved' ? 'not-allowed' : 'text' }}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        value={item.declared_amount}
                                                                        // value={showProofFields ? formData.proof_amt : item.declared_amount}

                                                                        // onChange={(e) => handleItemChange(index, e)}
                                                                        onChange={item.declaration_status !== 'approved' ? (e) => handleItemChange(index, e) : undefined}

                                                                        className={`form-input ${errors.declared_amount
                                                                            ? "error"
                                                                            : inputState.declared_amount
                                                                                ? "success"
                                                                                : ""
                                                                            }`}
                                                                        required
                                                                        disabled={item.declaration_status === 'approved' ? true : false}
                                                                    />
                                                                    <div className="">
                                                                        {errors.items?.[index]?.declared_amount && (
                                                                            <span className="error-message">
                                                                                {errors.items[index].declared_amount}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                {/* )} */}

                                                                {showProofFields && (
                                                                    <div className="form-flex-wrap w-full">
                                                                        <div className="flex-column">
                                                                            <label className="form-labels font-weight500 font-size-subheading">
                                                                                Total Proof Amount <span className="required">(Auto)*</span>
                                                                            </label>
                                                                            <input
                                                                                type="number"
                                                                                name="total_proof_amount"
                                                                                // value={formData.proof_amt || 0}
                                                                                value={item.calculation_amount || 0}

                                                                                disabled
                                                                                className="form-input"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="flex flex-column item-right h-full">
                                                                <label
                                                                    htmlFor="declaration_remarks"
                                                                    className="form-labels font-weight500 font-size-subheading"
                                                                >
                                                                    Remarks<span className="required">*</span>
                                                                </label>
                                                                <textarea
                                                                    name="declaration_remarks"
                                                                    value={item.declaration_remarks}
                                                                    onChange={(e) => handleItemChange(index, e)}
                                                                    className="form-input flex-1"
                                                                    style={{
                                                                        minHeight: '133px',
                                                                        padding: '13px 10px', cursor: item.declaration_status === 'approved' ? 'not-allowed' : 'text'
                                                                    }}
                                                                    rows="5"
                                                                    disabled={item.declaration_status === 'approved' ? true : false}
                                                                    placeholder="Enter Remark"
                                                                ></textarea>
                                                                {errors.items?.[index]?.declaration_remarks && (
                                                                    <span className="error-message">
                                                                        {errors.items[index].declaration_remarks}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div
                                                        className="flex-row justify-end"
                                                        style={{
                                                            position: "absolute",
                                                            top: "-14px",
                                                            right: "-9px",
                                                        }}
                                                    >
                                                        <button
                                                            type="button"
                                                            title={
                                                                item.declaration_status === "approved"
                                                                    ? "Approved item cannot be removed"
                                                                    : "Remove"
                                                            }
                                                            disabled={item.declaration_status === "approved"}
                                                            className="align-center justify-center"
                                                            style={{
                                                                backgroundColor: "white",
                                                                paddingLeft: "0px",
                                                                opacity: item.declaration_status === "approved" ? 0.4 : 1,
                                                                cursor: item.declaration_status === "approved" ? "not-allowed" : "pointer",
                                                            }}
                                                            onClick={() => removeItem(index)}
                                                        >
                                                            <CrosswithRedCircle />
                                                        </button>
                                                    </div>



                                                    {showProofFields && (
                                                        <div className="item-box p-2 relative">
                                                            <div className="grid grid-cols-2 gap-3">





                                                                <div className="jd-heading-outer-flex w-full">
                                                                    <h2 className="jd-heading-main font-weight600 font-size-heading">
                                                                        Upload Proof Documents
                                                                    </h2>


                                                                </div>


                                                                {formData.items[index].proofs?.map((proof, pIndex) => (

                                                                    <div
                                                                        key={pIndex}
                                                                        className="PaymentDashBoard gap-15 flex-column mb-3 border p-2 rounded relative"
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                padding: '0px 5px',
                                                                                position: "absolute",
                                                                                top: "-17px",
                                                                                left: "50%",
                                                                                transform: "translateX(-50%)",
                                                                                fontWeight: "600",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                margin: '4px',
                                                                                backgroundColor: 'white'

                                                                            }}
                                                                        >
                                                                            <span> Document - </span>
                                                                            <span style={{ marginLeft: '3px' }}>{pIndex + 1}</span>

                                                                        </div>
                                                                        {/* ROW 1: Document Upload + URL */}
                                                                        <div className="form-flex-wrap" style={{ padding: '20px', gap: '0px' }}>
                                                                            <div className="form-flex-wrap w-full" style={{ gap: '3px' }}>
                                                                                {/* === Document Upload === */}
                                                                                {(!proof.document_url || proof.document_url === '0') && (
                                                                                    <div className="flex-column">
                                                                                        <label className="form-labels font-weight500 font-size-subheading" >Document  <span className="required">
                                                                                            *
                                                                                        </span></label>

                                                                                        <div className={`flex-row justify-between form-input w-full
                                                                              ${errors[`proofs[${pIndex}][document]`]
                                                                                                ? "error"
                                                                                                : inputState?.[
                                                                                                    `proofs[${pIndex}][document]`
                                                                                                ]
                                                                                                    ? "success"
                                                                                                    : ""
                                                                                            }
                                                                                  `}

                                                                                            style={{ width: '32vw' }}
                                                                                        >
                                                                                            <label
                                                                                                htmlFor={`proof-file-${index}-${pIndex}`}
                                                                                                style={{ width: '30vw', cursor: "pointer", display: "flex", alignItems: "center" }}
                                                                                            >
                                                                                                <CloudUpload />
                                                                                                <span className="truncate-url" style={{ marginLeft: "10px" }}>
                                                                                                    {proof.document?.name || proof.document || "No file selected"}
                                                                                                </span>
                                                                                            </label>

                                                                                            <input
                                                                                                type="file"
                                                                                                // id={`proof-file-${pIndex}`}
                                                                                                id={`proof-file-${index}-${pIndex}`}

                                                                                                name="document"
                                                                                                accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpeg,.jpg"
                                                                                                onChange={(e) => handleProofFieldChange(e, index, pIndex)}
                                                                                                // className="form-input"
                                                                                                style={{ display: "none" }}
                                                                                            />

                                                                                            {proof.document && (
                                                                                                <span
                                                                                                    className="file-clear"
                                                                                                    // onClick={() => handleClearFile(pIndex)}
                                                                                                    onClick={() => handleClearFile(index, pIndex)}

                                                                                                >
                                                                                                    Clear
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                        {errors.items?.[index]?.proofs?.[pIndex]?.document && (
                                                                                            <span className="error-message">
                                                                                                {errors.items[index].proofs[pIndex].document}
                                                                                            </span>
                                                                                        )}

                                                                                    </div>

                                                                                )}

                                                                                {/* {!proof.document && !proof.document_url && (
                                                                                <div className="flex align-center ps-0 justify-center">
                                                                                    <span className="font-weight500">OR</span>
                                                                                </div>
                                                                            )} */}

                                                                                {/* === Document URL === */}
                                                                                {!proof.document && (
                                                                                    <div className="flex-column" >
                                                                                        <label className="form-labels font-weight500 font-size-subheading">Document URL <span className="required">*</span> </label>
                                                                                        <input
                                                                                            type="url"
                                                                                            name="document_url"
                                                                                            value={proof.document_url || ""}
                                                                                            className="form-input"
                                                                                            // style={{ width: '32vw' }}
                                                                                            placeholder="Enter document URL"
                                                                                            // onChange={(e) => handleProofFieldChange(e, pIndex)}
                                                                                            onChange={(e) => handleProofFieldChange(e, index, pIndex)}

                                                                                        />
                                                                                        {/* {errors.items?.[index]?.proofs?.[pIndex]?.document_url && (
                                                                                        <span className="error-message">
                                                                                            {errors.items[index].proofs[pIndex].document_url}
                                                                                        </span>
                                                                                    )} */}

                                                                                    </div>
                                                                                )}

                                                                            </div>


                                                                            <div className="flex-column" >
                                                                                <label className="form-labels font-weight500 font-size-subheading">
                                                                                    Amount <span className="required">*</span>
                                                                                </label>
                                                                                <input
                                                                                    type="number"
                                                                                    name="proof_amt"
                                                                                    value={proof.proof_amt || ""}
                                                                                    min={0}
                                                                                    step={0.01}
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                    className="form-input"
                                                                                    placeholder="Enter amount"
                                                                                    // onChange={(e) => handleProofFieldChange(e, pIndex)}
                                                                                    onChange={(e) => handleProofFieldChange(e, index, pIndex)}

                                                                                />
                                                                                {errors.items?.[index]?.proofs?.[pIndex]?.proof_amt && (
                                                                                    <span className="error-message">
                                                                                        {errors.items[index].proofs[pIndex].proof_amt}
                                                                                    </span>
                                                                                )}

                                                                            </div>


                                                                            <div className="flex-column" >
                                                                                <label className="form-labels font-weight500 font-size-subheading">Remarks <span className="required">*</span> </label>
                                                                                <textarea
                                                                                    name="remarks"
                                                                                    value={proof.remarks || ""}
                                                                                    style={{ padding: '13px 10px' }}
                                                                                    className="form-input"
                                                                                    placeholder="Enter remarks"
                                                                                    // onChange={(e) => handleProofFieldChange(e, pIndex)}
                                                                                    onChange={(e) => handleProofFieldChange(e, index, pIndex)}

                                                                                ></textarea>
                                                                                {errors.items?.[index]?.proofs?.[pIndex]?.remarks && (
                                                                                    <span className="error-message">
                                                                                        {errors.items[index].proofs[pIndex].remarks}
                                                                                    </span>
                                                                                )}

                                                                            </div>
                                                                        </div>



                                                                        <button
                                                                            className="remove-btn"
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: "white",
                                                                                marginTop: "10px",
                                                                                position: "absolute",
                                                                                top: "-27px",
                                                                                right: "-12px",
                                                                            }}
                                                                            // onClick={() => handleRemoveProof(pIndex)}
                                                                            onClick={() => handleRemoveProof(index, pIndex)}

                                                                            title="Remove"
                                                                        >
                                                                            <CrosswithRedCircle />
                                                                        </button>

                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {showProofFields && (
                                                        <div className="flex-row">
                                                            <hr className="line" />
                                                            <button type='button' title="Add Proofs" className="flex-row jd-heading-main font-weight600 gap-2" onClick={() => handleAddProof(index)}>
                                                                <AddwithBlueCircle /> <span className="w-max-content">Add Proofs</span>
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>


                                            </div>

                                        </>
                                    ))}
                                    <div className="flex-row">

                                        <hr className="line" />
                                        <button type='button' title="Add Section" className="flex-row jd-heading-main font-weight600 gap-2" onClick={addItem}>
                                            <AddwithBlueCircle /> <span className="w-max-content">Add Items</span>
                                        </button>
                                    </div>

                                </div>


                                {/* <div className="flex flex-row gap-2 w-full mb-2">
                                    <button
                                        type="submit"
                                        style={{ width: '160px' }}
                                        className="model-button model-button-leave font-weight500 font-size-heading"
                                        disabled={loadingTDs}
                                        onClick={handleTdsCalculation}
                                    >
                                        {loadingTDs ? "Calculating... " : "Calculate TDS"}
                                    </button>
                                    {buffer ? <div className="spinner-small"></div> :
                                        showTdsResult && (
                                            <div className="calculation-row total w-full align-center">
                                                <div>
                                                    <span>TDS amount:</span>
                                                    <span className="amount ms-2">{TdsCalcList?.monthly_tds_12_declared}</span>
                                                </div>
                                                <TdsCalculationModal employee={TdsCalcList} />
                                            </div>
                                        )}
                                </div> */}
                                <div className={showTdsResult ? "flex-row gap-2 w-full" : "w-full button-models"}>
                                    <button
                                        type="submit"
                                        style={{ width: '160px' }}
                                        className="model-button model-button-leave font-weight500 font-size-heading"
                                        disabled={loadingTDs}
                                        onClick={handleTdsCalculation}
                                    >
                                        {loadingTDs ? "Calculating... " : "Calculate TDS"}
                                    </button>
                                    {buffer ? <div className="spinner-small"></div> :
                                        showTdsResult && (
                                            <div className="calculation-row total w-full align-center">
                                                {/* <div className="color-card color-card-danger color-bg-danger-light w-full align-center"> */}
                                                <div>
                                                    <span>TDS amount:</span>
                                                    <span className="amount ms-2">{TdsCalcList?.monthly_tds_12_declared}</span>
                                                </div>
                                                <TdsCalculationModal employee={TdsCalcList} />
                                            </div>
                                        )}
                                </div>

                            </div>

                            <div className="button-models">
                                <button
                                    type="button"
                                    className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>


                                <button
                                    type="submit"
                                    className="model-button model-button-leave font-weight500 font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && (
                                (() => {
                                    const hasTopLevelErrors = Object.keys(errors).some(
                                        (key) => key !== "items"
                                    );

                                    const hasProofError = errors.items?.some(
                                        (item) =>
                                            item?.proofsRequired ||
                                            item?.proofs?.some(
                                                (proof) =>
                                                    proof?.document ||
                                                    proof?.proof_amt ||
                                                    proof?.remarks
                                            )
                                    );

                                    const hasOtherItemErrors = errors.items?.some(
                                        (item) =>
                                            item &&
                                            (
                                                item.section ||
                                                item.declared_amount ||
                                                item.declaration_remarks
                                            )
                                    );


                                    if (hasProofError && !hasTopLevelErrors && !hasOtherItemErrors) {
                                        return (
                                            <h5 className="text-center">
                                                Please upload at least one valid proof.
                                            </h5>
                                        );
                                    }


                                    if (hasTopLevelErrors || hasOtherItemErrors || hasProofError) {
                                        return (
                                            <h5 className="text-center">
                                                Please fill all mandatory fields!
                                            </h5>
                                        );
                                    }

                                    return null;
                                })()
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal >


        </>
    );
};

const DeleteInvestmentForm = ({ i, getInvestmentForm }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);

        try {
            const res = await axios.delete(
                `${BASE_URL}/wfm/investment-form-edit/${i.id}/`
            );

            if (res.status === 200) {
                await getInvestmentForm();
                setShow(false);
                toast.success("Investment Form Deleted Successfully!");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    console.log(i);


    return (
        <>
            <button
                className="model-delete-button"
                onClick={handleShow}
                title="Delete Investment Form"
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Investment Form of "{i.emp_name}"
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {/* =================== FORM DETAILS PREVIEW =================== */}
                    <div className="form-details-box">

                        {/* <h5 className="mb-2">Form Summary</h5> */}

                        {/* <div className="summary-grid">

                            <div className="summary-item">
                                <strong>Employee :</strong>
                                {" "}
                                <span>
                                    <>
                                        <CustomImageModal customStyle>
                                            {i.emp_profilepic ? (
                                                <img
                                                    src={`${`${IMAGE_URL}${i.emp_profilepic}`}`}
                                                    alt="profile" className="profile-img"
                                                />
                                            ) : (
                                                <UserDefaultLogo user={{ name: i.emp_name, profilepic: i.emp_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                            )}
                                        </CustomImageModal>
                                    </>
                                    {i.emp_code}-{i.emp_name}
                                </span>
                            </div>

                           

                            <div className="summary-item">
                                <strong>Tax Regime :</strong>
                                {" "}
                                <span>{i.regime_details?.name || "-"}</span>
                            </div>

                            <div className="summary-item">
                                <strong>Declaration Status :</strong>
                                {" "}
                                <span request-status={i.declaration_status} className="request-status text-capitalize">
                        a            {i.declaration_status}
                                </span>
                            </div>

                            <div className="summary-item">
                                <strong>Proof Status :</strong>
                                {" "}
                                <span request-status={i.proofs_status} className="request-status text-capitalize">
                                    {i.proofs_status}
                                </span>
                            </div>



                          

                        </div> */}
                        <div className="section-card border-left" style={{ padding: '10px' }} >


                            <div className="form-flex-wrap gap-0">
                                <div className="info-item justify-start row-align borderbottom-none" >
                                    <label>Employee:</label>

                                    <span>

                                        {i.emp_code}-{i.emp_name}
                                    </span>


                                </div>
                                <div className="info-item justify-start row-align borderbottom-none">
                                    <label>Tax Regime:</label>
                                    <span>{i.regime_details?.name || "-"}
                                        ({i?.regime_details?.financial_year_start && i?.regime_details?.financial_year_end
                                            ? `${new Date(i?.regime_details?.financial_year_start).getFullYear()}-${new Date(i?.regime_details?.financial_year_end).getFullYear()}`
                                            : "-"
                                        })
                                    </span>
                                </div>
                                <div className="info-item justify-start row-align borderbottom-none">
                                    <label>Declaration Status:</label>
                                    <span request-status={i.declaration_status} className="request-status text-capitalize">
                                        {i.declaration_status}
                                    </span>
                                </div>


                                <div className="info-item justify-start row-align borderbottom-none">
                                    <label>Proof Status:</label>
                                    <span request-status={i.proofs_status} className="request-status text-capitalize">
                                        {i.proofs_status}
                                    </span>
                                </div>



                            </div>
                        </div>

                        {/* =================== ITEMS BREAKDOWN =================== */}
                        {i.items?.length > 0 && (
                            <div className="items-section mt-3" style={{ padding: '10px' }}>
                                <div className="align-center"> No of Sections in this form - {i.items?.length}</div>
                                <table className="mt-2 w-full ">
                                    <thead>
                                        <tr>
                                            <th>Section</th>
                                            <hr className="field-cont-hr" />
                                            <th>Declared</th>
                                            <hr className="field-cont-hr" />
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {i.items.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {item.items_details?.section_name}
                                                </td>
                                                <hr className="field-cont-hr" />
                                                <td>
                                                    ₹{Number(item.declared_amount || 0).toLocaleString('en-IN')}
                                                </td>
                                                <hr className="field-cont-hr" />
                                                <td>
                                                    <span request-status={item.declaration_status} className="request-status text-capitalize">
                                                        {item.declaration_status}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <hr className="line" />
                        <div className=" padding_ bg-red-50 note-border note-border-red-color note-red-text">

                            This Investment form will permanently delete all declared sections, amount.
                            <div>
                                Are you sure want to delete this Investment Form?
                            </div>
                        </div>


                        {/* =================== DELETE CONFIRMATION =================== */}
                        <div className="parent-div">


                            <div className="button-models">
                                <button
                                    className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={handleDelete}
                                    className="model-button font-weight500 model-button-delete"
                                    disabled={loading}
                                >
                                    {loading ? "Deleting..." : "Delete"}
                                </button>
                            </div>
                        </div>
                    </div>

                    <ToastContainer position="top-center" autoClose={1000} />
                </Modal.Body>
            </Modal>

            <ToastContainer position="top-center" autoClose={1000} />
        </>
    );
};


const SubmitInvestmentDeclaration = ({ i, getInvestmentForm }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        declaration_status: 'submitted'
    });

    const handleConfirmSubmit = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.put(`${BASE_URL}/wfm/investment-form-declaration-submit/${i.id}/`, formData);
            if (res.status === 200 || res.status === 201) {
                await getInvestmentForm();
                setShow(false);
                toast.success("Investment Form Submitted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>

            <button onClick={handleShow} className="model-add-button" title="Submit Declarations">
                <SubmitArrowHead1 />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Submit Investment Declaration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div text-center" style={{ fontSize: '18px' }}>
                        Please confirm to submit your Investment Declaration.
                        {/* More Detais */}

                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirmSubmit}
                                className="model-button   font-weight500    model-button-submit"
                                disabled={loading}
                            >
                                {loading ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>

        </>
    );
};

const ResubmitInvestmentDeclaration = ({ i, getInvestmentForm }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        declaration_status: 'submitted'
    });

    const handleConfirmResubmit = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Resubmitting... Please wait...");
        setLoading(true);

        try {
            const res = await axios.put(`${BASE_URL}/wfm/investment-form-resubmit-declaration/${i.id}/`, formData);
            if (res.status === 200 || res.status === 201) {
                await getInvestmentForm();
                setShow(false);
                toast.success("Investment Declaration Resubmitted Successfully!");
            } else {
                toast.error("Failed to resubmit investment declaration");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                onClick={handleShow}
                className="model-partial-button"
                title="Resubmit Rejected Declaration"
            >
                <SubmitArrowHead1 color={'#f7ba1e'} />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Resubmit Investment Declaration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div text-center" style={{ fontSize: '18px' }}>
                        <p>Are you sure you want to resubmit this rejected investment declaration?</p>
                        <p style={{ fontSize: '14px', color: '#666', marginTop: '10px' }}>
                            This will reset the approval process and set the status back to submitted.
                        </p>

                        <div className="button-models" style={{ marginTop: '20px' }}>
                            <button
                                className="model-button model-button-cancel font-weight500"
                                onClick={handleClose}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirmResubmit}
                                className="model-button model-button-submit font-weight500"
                                disabled={loading}
                            >
                                {loading ? "Resubmitting..." : "Confirm Resubmit"}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const SubmitInvestmentProofs = ({ i, getInvestmentForm }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        proofs_status: 'submitted'
    });

    const handleConfirmSubmit = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.put(`${BASE_URL}/wfm/investment-form-proof-submit/${i.id}/`, formData);
            if (res.status === 200 || res.status === 201) {
                await getInvestmentForm();
                setShow(false);
                toast.success("Investment Form with Proofs Submitted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>

            <button onClick={handleShow} className="model-add-button" title="Submit Proof">
                <SubmitArrowHead2 />

            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation Form</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div text-center" style={{ fontSize: '18px' }}>
                        Please confirm to submit your Investment Proofs.
                        {/* More Detais */}

                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel font-weight500"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirmSubmit}
                                className="model-button font-weight500 model-button-submit"
                                disabled={loading}
                            >
                                {loading ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

const ResubmitInvestmentProof = ({ i, getInvestmentForm }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        proofs_status: 'submitted'
    });

    const handleConfirmResubmit = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Resubmitting... Please wait...");
        setLoading(true);

        try {
            const res = await axios.put(`${BASE_URL}/wfm/investment-form-resubmit-proof/${i.id}/`, formData);
            if (res.status === 200 || res.status === 201) {
                await getInvestmentForm();
                setShow(false);
                toast.success("Investment Proofs Resubmitted Successfully!");
            } else {
                toast.error("Failed to resubmit investment proofs");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                onClick={handleShow}
                className="model-partial-button"
                title="Resubmit Rejected Proofs"
            >
                <SubmitArrowHead1 color={'#f7ba1e'} />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Resubmit Investment Proofs</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div text-center" style={{ fontSize: '18px' }}>
                        <p>Are you sure you want to resubmit these rejected investment proofs?</p>
                        <p style={{ fontSize: '14px', color: '#666', marginTop: '10px' }}>
                            This will reset the proof approval process and set the status back to submitted.
                        </p>

                        <div className="button-models" style={{ marginTop: '20px' }}>
                            <button
                                className="model-button model-button-cancel font-weight500"
                                onClick={handleClose}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirmResubmit}
                                className="model-button font-weight500"
                                disabled={loading}
                                style={{
                                    backgroundColor: '#ffc107',
                                    borderColor: '#ffc107',
                                    color: '#212529'
                                }}
                            >
                                {loading ? "Resubmitting..." : "Confirm Resubmit"}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const EditProofModal = ({ rowData, ItemData, getInvestmentForm }) => {
    const initialData = {

        item: "",
        document_url: "",
        document: "",
        status: "pending",
        verified_by: sessionStorage.getItem('emp_code'),
        proof_amt: "",
        approved_amt: 0
    }
    const [formData, setFormData] = useState(initialData);
    const [viewItems, setViewItems] = useState(null);
    const [editProofModal, setEditProofModal] = useState(false);
    const [errors, setErrors] = useState({});
    const [proofs, setProofs] = useState([]);
    const [isProofEditable, setIsProofEditable] = useState(false);
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleClose = () => setEditProofModal(false);

    const handleEditProofOpen = (rowData) => {
        console.log(rowData, "rowdata");

        setViewItems(rowData);
        setEditProofModal(true);

        // setFormData((prev) => ({
        //     ...prev,
        //     item: rowData.id,
        // }));
    };


    useEffect(() => {
        const totalProofAmount = proofs.reduce((sum, proof) => {
            const amt = Number(proof.proof_amt) || 0;
            return sum + amt;
        }, 0);




        setFormData(prev => ({
            ...prev,
            proof_amt: totalProofAmount,
            item: rowData.id,

        }));
    }, [proofs]);

    const handleEditProofClose = () => {
        setEditProofModal(false);
        setFormData(initialData);
        setErrors({});
    };

    const handleApprovedAmountChange = (e) => {
        const { name, value } = e.target;
        const numericFields = [
            "approved_amt",
        ];

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (numericFields.includes(name)) {

            if (!isValidTwoDecimalNumber(value)) {
                return;
            }


            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }


            const { success, error } = inputMinLimit(name, value, 0);

            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }


        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));


    }


    useEffect(() => {
        if (viewItems) {
            setProofs(
                viewItems.proofs?.map(p => ({
                    id: p.id,
                    proof_amt: p.proof_amt || "",
                    remarks: p.remarks || "",
                    document: p.document || null,
                    document_url: p.document_url || null,
                    file: null
                })) || []
            );

            // setInputState({
            //     declared_amount: viewitems.declared_amount || "",
            //     remarks: viewitems.remarks || ""
            // });
        }
    }, [viewItems]);

    const checkEditPermissions = () => {
        const month = new Date().getMonth() + 1;

        // April–Dec
        // if (month >= 4 && month <= 12) {
        //     setIsDeclarationEditable(true);
        //     setIsProofEditable(false);
        // }

        // Jan–Mar
        if (month >= 9 && month <= 11) {
            // setIsDeclarationEditable(false);
            setIsProofEditable(true);
        }
    };
    console.log(isProofEditable, "proof");


    useEffect(() => {
        checkEditPermissions();
    }, [ItemData])

    const handleAddProof = () => {
        setProofs((prev) => [
            ...prev,
            {
                file: null,
                document_url: "",
                remarks: "",
                proof_amt: 0,
            },
        ]);
    };


    const handleProofFileChange = (e, index) => {
        const file = e.target.files[0];
        const { name, value } = e.target
        const updatedProofs = [...proofs];
        updatedProofs[index].file = file;
        updatedProofs[index].document_url = "";
        setProofs(updatedProofs);

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        })

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };
    const handleClearFile = (index) => {
        const updatedProofs = [...proofs];
        updatedProofs[index] = {
            ...updatedProofs[index],
            file: null,
            document: null,
            document_url: "",
        };
        setProofs(updatedProofs);

        const inputEl = document.querySelector(`#proof-file-${index}`);
        if (inputEl) inputEl.value = "";
    };


    const handleProofUrlChange = (e, index) => {
        const value = e.target.value;
        const name = e.target.name
        const updatedProofs = [...proofs];
        updatedProofs[index].document_url = value;
        updatedProofs[index].file = null;
        setProofs(updatedProofs);

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        })

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleProofAmountChange = (e, index) => {
        const inputValue = e.target.value; // string
        const updatedProofs = [...proofs];
        const key = `proofs[${index}][proof_amt]`;

        if (inputValue === "" || inputValue === ".") {
            updatedProofs[index].proof_amt = 0;
            setProofs(updatedProofs);
            setFormData((prev) => ({
                ...prev,
                proof_amt: updatedProofs.reduce((sum, p) => sum + (Number(p.proof_amt) || 0), 0),
            }));
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated[key];
                return updated;
            });
            return;
        }

        const value = parseFloat(inputValue);

        if (!isValidTwoDecimalNumber(value)) return;

        if (value < 0) {
            setErrors((prev) => ({ ...prev, [key]: "Value cannot be negative" }));
            return;
        } else {
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated[key];
                return updated;
            });
        }

        const { success, error } = inputMinLimit(key, inputValue, 0);
        if (!success) {
            setErrors((prev) => ({ ...prev, [key]: error }));
        }

        updatedProofs[index].proof_amt = value;
        setProofs(updatedProofs);

        const total = updatedProofs.reduce((sum, p) => sum + (Number(p.proof_amt) || 0), 0);
        setFormData((prev) => ({ ...prev, proof_amt: total }));

        setInputState((prev) => ({
            ...prev,
            [key]: inputValue.trim() ? "green" : "",
        }));
    };

    const handleProofRemarkChange = (e, index) => {
        const value = e.target.value;
        const updatedProofs = [...proofs];
        updatedProofs[index].remarks = value;
        setProofs(updatedProofs);
    };



    const handleRemoveProof = (index) => {
        const updatedProofs = [...proofs];
        updatedProofs.splice(index, 1);

        const total = updatedProofs.reduce(
            (sum, p) => sum + (Number(p.proof_amt) || 0),
            0
        );

        setProofs(updatedProofs);
        setFormData((prev) => ({ ...prev, proof_amt: total }));
    };





    const validateForm = () => {
        const newErrors = {};

        // Validate proofs
        proofs.forEach((proof, index) => {
            // File or URL is required
            if (!proof.file && !proof.document_url && !proof.document) {

                newErrors[`proofs[${index}][document_url]`] = "Document URL or File is required!";
                newErrors[`proofs[${index}][document]`] = "Document file is required!";
            }

            // Proof amount required
            if (!proof.proof_amt || proof.proof_amt === 0) {
                newErrors[`proofs[${index}][proof_amt]`] = "Proof Amount is required!";
            }
        });



        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    const handleProofSubmit = async (e) => {


        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Uploading proofs...");

            try {
                const formDataToSend = new FormData();

                formDataToSend.append("item", formData.item);
                formDataToSend.append("status", formData.status || "pending");
                formDataToSend.append("verified_by", formData.verified_by || "");
                formDataToSend.append("proof_amt", formData.proof_amt || 0);
                formDataToSend.append("approved_amt", formData.approved_amt);


                // proofs.forEach((proof, i) => {
                //     if (proof.file) {
                //         formDataToSend.append(`proofs[${i}][document]`, proof.file);
                //     } else if (proof.document_url) {
                //         formDataToSend.append(
                //             `proofs[${i}][document_url]`,
                //             proof.document_url
                //         );
                //     }
                //     formDataToSend.append(`proofs[${i}][remarks]`, proof.remarks || "");
                //     formDataToSend.append(`proofs[${i}][proof_amt]`, proof.proof_amt || 0);
                // });

                proofs.forEach((proof, i) => {
                    // Only send document if user picked a NEW file
                    if (proof.file) {
                        formDataToSend.append(`proofs[${i}][document]`, proof.file);
                    }

                    // Only send URL if user typed NEW url
                    if (proof.document_url && proof.document_url !== proof.original_document_url) {
                        formDataToSend.append(`proofs[${i}][document_url]`, proof.document_url);
                    }

                    formDataToSend.append(`proofs[${i}][remarks]`, proof.remarks || "");
                    formDataToSend.append(`proofs[${i}][proof_amt]`, proof.proof_amt || 0);
                    formDataToSend.append(`proofs[${i}][id]`, proof.id);
                });


                const res = await axios.put(
                    `${BASE_URL}/wfm/investment-proofs-bulk-update/${viewItems.id}/`,
                    formDataToSend,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                );

                if (res.status === 200 || res.status === 201) {
                    toast.success("Proofs uploaded successfully!");
                    await getInvestmentForm();
                } else {
                    toast.error("Something went wrong while submitting proofs!");
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };



    return (
        <>

            <button onClick={() => handleEditProofOpen(rowData)} className="model-delete-button">
                <UpdatePencil />
            </button>
            <Modal
                show={editProofModal}
                onHide={handleEditProofClose}
                dialogClassName="modal-dialog three-fourth-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Proof Documents</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table className="w-full">
                        <tr className="flex-row align-center justify-start">
                            <td className="personal-detail-1 font-weight500 font-size-text" style={{ width: '150px', textAlign: 'left' }}>Sub company</td>
                            <th className="personal-detail-2 font-weight500 font-size-text">
                                {ItemData?.sub_company_title}
                            </th>
                        </tr>

                        <tr className="flex-row align-center justify-start">
                            <td className="personal-detail-1 font-weight500 font-size-text" style={{ width: '150px', textAlign: 'left' }}>Tax Regime</td>
                            <th className="personal-detail-2 font-weight500 font-size-text">
                                {ItemData?.regime_details?.name} (
                                {formatDate(ItemData?.regime_details?.financial_year_start)} to{" "}
                                {formatDate(ItemData?.regime_details?.financial_year_end)})
                            </th>
                        </tr>

                        <tr className="flex-row align-center justify-start">
                            <td className="personal-detail-1 font-weight500 font-size-text" style={{ width: '150px', textAlign: 'left' }}>Investment Items</td>
                            <th className="personal-detail-2 font-weight500 font-size-text flex flex-column" style={{ alignItems: 'start' }} >
                                {viewItems ? (
                                    <>
                                        <div>
                                            <strong>Section:</strong> {viewItems.items_details?.section_name}
                                        </div>
                                        <div>
                                            <strong>Declared Amount:</strong> ₹{viewItems.declared_amount}
                                        </div>

                                    </>

                                ) : (
                                    <span>No items found</span>
                                )}
                            </th>
                        </tr>
                        <tr>




                            <div className="item-box p-3 mb-3 border rounded-xl relative">
                                <div className="grid grid-cols-2 gap-3 ">
                                    {/* === Proof Amount (Sum of all proofs) === */}
                                    <div className="form-flex-wrap w-full">
                                        <div className="flex-column">
                                            <label
                                                htmlFor="proof_amount"
                                                className="form-labels font-weight500 font-size-subheading"
                                            >
                                                Total Proof Amount<span className="required">*(auto)</span>
                                            </label>
                                            <input
                                                type="number"
                                                placeholder="Total proof amount"
                                                name="proof_amount"
                                                value={formData.proof_amt || ""}
                                                disabled
                                                className="form-input w-26vw"
                                            />
                                        </div>

                                        <div className="flex-column">
                                            <label
                                                htmlFor="approved_amt"
                                                className="form-labels font-weight500 font-size-subheading"
                                            >
                                                Approved Amount<span className="required">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                name="approved_amt"
                                                value={formData.approved_amt || ""}
                                                className="form-input w-26vw"
                                                min={0}
                                                placeholder="Enter approved amount"
                                                onChange={(e) => handleApprovedAmountChange(e)}
                                                onWheel={(e) => e.target.blur()}
                                                step={0.01}
                                            />

                                        </div>
                                    </div>

                                    {/* === Proof Upload Header === */}
                                    <div className="jd-heading-outer-flex w-100">
                                        <h2 className="jd-heading-main font-weight600 font-size-heading">
                                            Upload Proof Documents
                                        </h2>

                                        {isProofEditable && (
                                            <button
                                                type="button"
                                                onClick={handleAddProof}
                                                className="jd-heading-main font-weight600 -right-button"
                                            >
                                                <AddwithBlueCircle /> Add Document
                                            </button>
                                        )}
                                    </div>






                                    {/* === Proofs List === */}
                                    {proofs.map((proof, pIndex) => {
                                        const hasFile = proof.document;
                                        const hasUrl = proof.document_url;

                                        return (
                                            <div
                                                key={pIndex}
                                                className="PaymentDashBoard gap-15 flex-column border p-2 rounded relative"
                                            >
                                                <div className="form-flex-wrap">


                                                    {(!hasUrl) && (
                                                        <div className="flex-column">
                                                            <label htmlFor={`proof-file-${pIndex}`} className="form-label" style={{ width: "20vw" }}>
                                                                Document<span className="required">*</span>
                                                            </label>

                                                            <div
                                                                className={`file-upload-container flex-row justify-between file-in-upload 
                                ${errors[`proofs[${pIndex}][document]`] ? "error"
                                                                        : inputState?.[`proofs[${pIndex}][document]`] ? "success" : ""
                                                                    }
                            `}
                                                                style={{ width: "25vw" }}
                                                            >
                                                                <label
                                                                    htmlFor={`proof-file-${pIndex}`}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        width: "29vw",
                                                                    }}
                                                                >
                                                                    <CloudUpload />
                                                                    <span className="truncate-url" style={{ marginLeft: "20px", width: '19vw' }}>
                                                                        {proof.file?.name || hasFile || "No file selected"}
                                                                    </span>
                                                                </label>

                                                                <input
                                                                    type="file"
                                                                    id={`proof-file-${pIndex}`}
                                                                    name={`proofs[${pIndex}][document]`}
                                                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpeg,.jpg,image/*"
                                                                    disabled={!isProofEditable}
                                                                    onChange={(e) => handleProofFileChange(e, pIndex)}
                                                                    className="form-input"
                                                                    style={{ display: "none" }}
                                                                />

                                                                {/* {(proof.file || hasUrl) && isProofEditable && (
                                                                    <span className="file-clear" onClick={() => handleClearFile(pIndex)}>
                                                                        Clear
                                                                    </span>
                                                                )} */}
                                                                {(proof.file || hasFile) && isProofEditable && (
                                                                    <span
                                                                        className="file-clear"
                                                                        onClick={() => handleClearFile(pIndex)}
                                                                    >
                                                                        Clear
                                                                    </span>
                                                                )}

                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* === DOCUMENT URL (if document OR document_url exists) === */}
                                                    {hasUrl && (
                                                        <div className="flex-column">
                                                            <label htmlFor={`document-url-${pIndex}`} className="form-label">
                                                                Document URL<span className="required">*</span>
                                                            </label>

                                                            <input
                                                                type="url"
                                                                id={`document-url-${pIndex}`}
                                                                name={`proofs[${pIndex}][document_url]`}
                                                                className="form-input"
                                                                style={{ width: "25vw" }}
                                                                placeholder="Enter document URL"
                                                                // value={proof.document || proof.document_url || ""}
                                                                value={proof.document_url || ""}

                                                                disabled={!isProofEditable}
                                                                onChange={(e) => handleProofUrlChange(e, pIndex)}
                                                            />

                                                            {errors[`proofs[${pIndex}][document_url]`] && (
                                                                <span className="error-message font-size-text">
                                                                    {errors[`proofs[${pIndex}][document_url]`]}
                                                                </span>
                                                            )}
                                                        </div>
                                                    )}

                                                </div>

                                                {/* === Proof Amount and Remarks === */}
                                                <div className="form-flex-wrap">
                                                    <div className="flex-column">
                                                        <label htmlFor={`proof-amt-${pIndex}`} className="form-labels announce-date">
                                                            Amount<span className="required">*</span>
                                                        </label>
                                                        <input
                                                            type="number"
                                                            id={`proof-amt-${pIndex}`}
                                                            min={0}
                                                            name="proof_amt"
                                                            className="form-input"
                                                            placeholder="Enter proof amount"
                                                            value={proof.proof_amt || ""}
                                                            disabled={!isProofEditable}
                                                            onWheel={(e) => e.target.blur()}
                                                            step={0.01}
                                                            onChange={(e) => handleProofAmountChange(e, pIndex)}
                                                        />
                                                        {errors[`proofs[${pIndex}][proof_amt]`] && (
                                                            <span className="error-message font-size-text ">
                                                                {errors[`proofs[${pIndex}][proof_amt]`]}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <div className="flex-column">
                                                        <label htmlFor={`proof-remarks-${pIndex}`} className="form-labels announce-date">
                                                            Remarks
                                                        </label>
                                                        <textarea
                                                            type="text"
                                                            id={`proof-remarks-${pIndex}`}
                                                            className="form-input"
                                                            placeholder="Enter proof remarks"
                                                            value={proof.remarks || ""}
                                                            disabled={!isProofEditable}
                                                            onChange={(e) => handleProofRemarkChange(e, pIndex)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* === Remove Button === */}
                                                {isProofEditable && (
                                                    <button
                                                        className="remove-btn"
                                                        type="button"
                                                        style={{ backgroundColor: "white", marginTop: "10px", position: 'absolute', top: '-27px', right: '-12px' }}
                                                        onClick={() => handleRemoveProof(pIndex)}
                                                        title="Remove"
                                                    >
                                                        <CrosswithRedCircle />
                                                    </button>
                                                )}
                                            </div>
                                        )
                                    })}

                                    {/* === Upload Proof Button === */}
                                    <div className="button-models w-full">
                                        <button
                                            type="button"
                                            className="model-button model-button-cancel font-weight500"
                                            onClick={handleClose}
                                        >
                                            Cancel
                                        </button>
                                        {isProofEditable && (
                                            <button
                                                onClick={handleProofSubmit}
                                                className="model-button model-button-leave font-weight500 font-size-heading"
                                            >
                                                Upload Proofs
                                            </button>
                                        )}

                                    </div>
                                </div>
                            </div>


                        </tr>
                    </table>
                    <p className="error-message font-size-text">
                        {isSubmitted && Object.keys(errors).length > 0 && (
                            Object.keys(errors).length > 5 ? (
                                <h5 className="text-center">Please fill all mandatory fields!</h5>
                            ) : (
                                <h6 className="text-center">
                                    {Object.keys(errors)
                                        .map((field) =>
                                            field
                                                .replace(/_/g, ' ')
                                                .replace(/\b\w/g, (char) => char.toUpperCase())
                                        )
                                        .join(', ') + ' are required!'}
                                </h6>
                            )
                        )}
                    </p>
                </Modal.Body>


            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
};



export {
    AddTaxregime,
    UpdateTaxregime,
    DeleteTaxRegime,
    AddInvestmentType,
    UpdateInvestmentType,
    DeleteInvestmentType,
    AddTaxSection,
    UpdateTaxSection,
    DeleteTaxSection,
    AddAgeRangeTaxslab,
    UpdateAgeRangeTaxslab,
    DeleteAgeRangeTaxslab,
    AddTaxslab,
    UpdateTaxslab,
    DeleteTaxslab,
    AddSurchargeslab,
    UpdateSurchargeslab,
    DeleteSurchargeslab,
    DeleteInvestmentForm,

    EditProofModal,

    SubmitInvestmentDeclaration,
    ResubmitInvestmentDeclaration,
    SubmitInvestmentProofs,
    ResubmitInvestmentProof,
    AddEmpInvestmentForm,
    UpdateEmpInvestmentForm1,
}